webpackJsonp([150],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_543", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_601", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_584", function() { return O365_REGISTER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_585", function() { return O365_REGISTER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_583", function() { return O365_REGISTER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_563", function() { return O365_LOAD_EVENTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_564", function() { return O365_LOAD_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_562", function() { return O365_LOAD_EVENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_566", function() { return O365_LOAD_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_567", function() { return O365_LOAD_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_565", function() { return O365_LOAD_EVENT_FAILURE; });
/* unused harmony export O365_LOAD_EDIT_EVENT_REQUEST */
/* unused harmony export O365_LOAD_EDIT_EVENT_SUCCESS */
/* unused harmony export O365_LOAD_EDIT_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_581", function() { return O365_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_582", function() { return O365_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_580", function() { return O365_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_548", function() { return O365_CREATE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_549", function() { return O365_CREATE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_547", function() { return O365_CREATE_EVENT_FAILURE; });
/* unused harmony export O365_UPDATE_EVENT_REQUEST */
/* unused harmony export O365_UPDATE_EVENT_SUCCESS */
/* unused harmony export O365_UPDATE_EVENT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_557", function() { return O365_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_558", function() { return O365_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_556", function() { return O365_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BSRS_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BSRS_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSRS_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_599", function() { return PROFILE_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_600", function() { return PROFILE_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_598", function() { return PROFILE_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_545", function() { return O365_ACCEPT_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_546", function() { return O365_ACCEPT_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_544", function() { return O365_ACCEPT_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_587", function() { return O365_TENTATIVE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_588", function() { return O365_TENTATIVE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_586", function() { return O365_TENTATIVE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_554", function() { return O365_DECLINE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_555", function() { return O365_DECLINE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_553", function() { return O365_DECLINE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return CORE_LOAD_ORDERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return CORE_LOAD_ORDERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return CORE_LOAD_ORDERS_FAILURE; });
/* unused harmony export CORE_LOAD_ORDER_DETAIL_REQUEST */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_SUCCESS */
/* unused harmony export CORE_LOAD_ORDER_DETAIL_FAILURE */
/* unused harmony export CORE_CHANGE_ORDER_AMOUNT */
/* unused harmony export CORE_UPSERT_ORDERS_REQUEST */
/* unused harmony export CORE_UPSERT_ORDERS_SUCCESS */
/* unused harmony export CORE_UPSERT_ORDERS_FAILURE */
/* unused harmony export CORE_LOAD_CHEKIN_REQUEST */
/* unused harmony export CORE_LOAD_CHEKIN_SUCCESS */
/* unused harmony export CORE_LOAD_CHEKIN_FAILURE */
/* unused harmony export CORE_CREATE_CHECKIN_REQUEST */
/* unused harmony export CORE_CREATE_CHECKIN_SUCCESS */
/* unused harmony export CORE_CREATE_CHECKIN_FAILURE */
/* unused harmony export O365_CHECKOUT_EVENT_REQUEST */
/* unused harmony export O365_CHECKOUT_EVENT_SUCCESS */
/* unused harmony export O365_CHECKOUT_EVENT_FAILURE */
/* unused harmony export O365_LOAD_PEOPLE_REQUEST */
/* unused harmony export O365_LOAD_PEOPLE_SUCCESS */
/* unused harmony export O365_LOAD_PEOPLE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_569", function() { return O365_LOAD_LOCATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_570", function() { return O365_LOAD_LOCATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_568", function() { return O365_LOAD_LOCATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return CORE_LOAD_LOCATIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return CORE_LOAD_LOCATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return CORE_LOAD_LOCATIONS_FAILURE; });
/* unused harmony export O365_SEARCH_SLOT_REQUEST */
/* unused harmony export O365_SEARCH_SLOT_SUCCESS */
/* unused harmony export O365_SEARCH_SLOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return CORE_INTEGRATION_O365_GO_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return CORE_INTEGRATION_O365_GO_SAVE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return CORE_INTEGRATION_O365_ADD_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return CORE_INTEGRATION_O365_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return CORE_INTEGRATION_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return CORE_INTEGRATION_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return CORE_INTEGRATION_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_CREATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_CREATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_CREATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_346", function() { return CORE_LOAD_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_347", function() { return CORE_LOAD_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_345", function() { return CORE_LOAD_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_FIND_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_FIND_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_FIND_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_523", function() { return CORE_UPDATE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_524", function() { return CORE_UPDATE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_522", function() { return CORE_UPDATE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_DELETE_ROOM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_DELETE_ROOM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_DELETE_ROOM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_560", function() { return O365_DELETE_ROOM_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_561", function() { return O365_DELETE_ROOM_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_559", function() { return O365_DELETE_ROOM_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_551", function() { return O365_CREATE_ROOM_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_552", function() { return O365_CREATE_ROOM_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_550", function() { return O365_CREATE_ROOM_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_575", function() { return O365_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_576", function() { return O365_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_574", function() { return O365_LOAD_ROOMS_FAILURE; });
/* unused harmony export O365_LOAD_ROOMS_INFO_REQUEST */
/* unused harmony export O365_LOAD_ROOMS_INFO_SUCCESS */
/* unused harmony export O365_LOAD_ROOMS_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_578", function() { return O365_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_579", function() { return O365_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_577", function() { return O365_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BSRS_SERVICE_TOKEN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BSRS_SERVICE_TOKEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BSRS_SERVICE_TOKEN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_337", function() { return CORE_LOAD_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_341", function() { return CORE_LOAD_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_336", function() { return CORE_LOAD_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_339", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_340", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_338", function() { return CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return CORE_LOAD_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return CORE_LOAD_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return CORE_LOAD_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return CORE_LOAD_LOCATIONS_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return CORE_LOAD_LOCATIONS_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return CORE_LOAD_LOCATIONS_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_CREATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_391", function() { return CORE_LOAD_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_392", function() { return CORE_LOAD_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_390", function() { return CORE_LOAD_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_397", function() { return CORE_LOAD_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_398", function() { return CORE_LOAD_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_393", function() { return CORE_LOAD_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_535", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_536", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_534", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_DELETE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_DELETE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_DELETE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_541", function() { return CORE_USER_CHANGEPASS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_542", function() { return CORE_USER_CHANGEPASS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_540", function() { return CORE_USER_CHANGEPASS_FAILURE; });
/* unused harmony export CORE_EDIT_USER_REQUEST */
/* unused harmony export CORE_EDIT_USER_SUCCESS */
/* unused harmony export CORE_EDIT_USER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_395", function() { return CORE_LOAD_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_396", function() { return CORE_LOAD_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_394", function() { return CORE_LOAD_USER_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return CORE_GET_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return CORE_GET_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return CORE_GET_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_355", function() { return CORE_LOAD_SETTING_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_356", function() { return CORE_LOAD_SETTING_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_354", function() { return CORE_LOAD_SETTING_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_CHANGE_SETTING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_CHANGE_SETTING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_CHANGE_SETTING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_382", function() { return CORE_LOAD_USERREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_383", function() { return CORE_LOAD_USERREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_381", function() { return CORE_LOAD_USERREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_331", function() { return CORE_LOAD_ROOMREPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_332", function() { return CORE_LOAD_ROOMREPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_330", function() { return CORE_LOAD_ROOMREPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_385", function() { return CORE_LOAD_USERSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_386", function() { return CORE_LOAD_USERSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_384", function() { return CORE_LOAD_USERSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_334", function() { return CORE_LOAD_ROOMSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_335", function() { return CORE_LOAD_ROOMSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_333", function() { return CORE_LOAD_ROOMSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return CORE_LOAD_REPORTSUMMARY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return CORE_LOAD_REPORTSUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return CORE_LOAD_REPORTSUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return CORE_LOAD_ALLAMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return CORE_LOAD_ALLAMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return CORE_LOAD_ALLAMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_DELETE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_DELETE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_DELETE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return CORE_LOAD_AMENITYINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return CORE_LOAD_AMENITYINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return CORE_LOAD_AMENITYINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CREATE_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CREATE_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CREATE_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_442", function() { return CORE_UPDATE_AMENITYINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_443", function() { return CORE_UPDATE_AMENITYINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_441", function() { return CORE_UPDATE_AMENITYINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return CORE_LOAD_ALL_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return CORE_LOAD_ALL_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return CORE_LOAD_ALL_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return CORE_LOAD_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return CORE_LOAD_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return CORE_LOAD_PROFILE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_CREATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_CREATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_CREATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_514", function() { return CORE_UPDATE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_515", function() { return CORE_UPDATE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_513", function() { return CORE_UPDATE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_DELETE_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_DELETE_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_DELETE_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_376", function() { return CORE_LOAD_USERGROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_377", function() { return CORE_LOAD_USERGROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_375", function() { return CORE_LOAD_USERGROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return CORE_LOAD_LIST_USERGROUPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return CORE_LOAD_LIST_USERGROUPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return CORE_LOAD_LIST_USERGROUPS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_379", function() { return CORE_LOAD_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_380", function() { return CORE_LOAD_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_378", function() { return CORE_LOAD_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_CREATE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_CREATE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_CREATE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_532", function() { return CORE_UPDATE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_533", function() { return CORE_UPDATE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_531", function() { return CORE_UPDATE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_DELETE_USERGROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_DELETE_USERGROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_DELETE_USERGROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return CORE_LOAD_ACTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return CORE_LOAD_ACTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return CORE_LOAD_ACTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return CORE_LOAD_ALLFBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return CORE_LOAD_ALLFBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return CORE_LOAD_ALLFBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_DELETE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_DELETE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_DELETE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return CORE_LOAD_FBSINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return CORE_LOAD_FBSINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return CORE_LOAD_FBSINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_CREATE_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_CREATE_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_CREATE_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_484", function() { return CORE_UPDATE_FBSINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_485", function() { return CORE_UPDATE_FBSINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_483", function() { return CORE_UPDATE_FBSINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return CORE_GET_INTEGRATION_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return CORE_GET_INTEGRATION_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return CORE_GET_INTEGRATION_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_358", function() { return CORE_LOAD_STATUSUSER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_359", function() { return CORE_LOAD_STATUSUSER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_357", function() { return CORE_LOAD_STATUSUSER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_388", function() { return CORE_LOAD_USERSUM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_389", function() { return CORE_LOAD_USERSUM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_387", function() { return CORE_LOAD_USERSUM_FAILURE; });
/* unused harmony export CORE_LOAD_ROOMSUM_REQUEST */
/* unused harmony export CORE_LOAD_ROOMSUM_SUCCESS */
/* unused harmony export CORE_LOAD_ROOMSUM_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_343", function() { return CORE_LOAD_ROOMTEMP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_344", function() { return CORE_LOAD_ROOMTEMP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_342", function() { return CORE_LOAD_ROOMTEMP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_370", function() { return CORE_LOAD_TOPROOMRESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_371", function() { return CORE_LOAD_TOPROOMRESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_369", function() { return CORE_LOAD_TOPROOMRESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_373", function() { return CORE_LOAD_TOPUSERRESERVE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_374", function() { return CORE_LOAD_TOPUSERRESERVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_372", function() { return CORE_LOAD_TOPUSERRESERVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_325", function() { return CORE_LOAD_ROOMDETAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_326", function() { return CORE_LOAD_ROOMDETAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_324", function() { return CORE_LOAD_ROOMDETAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_364", function() { return CORE_LOAD_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_365", function() { return CORE_LOAD_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_363", function() { return CORE_LOAD_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_529", function() { return CORE_UPDATE_TERM_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_530", function() { return CORE_UPDATE_TERM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_528", function() { return CORE_UPDATE_TERM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return CORE_LOAD_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return CORE_LOAD_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return CORE_LOAD_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_481", function() { return CORE_UPDATE_FAQ_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_482", function() { return CORE_UPDATE_FAQ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_480", function() { return CORE_UPDATE_FAQ_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return CORE_LOAD_CONTACT_US_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return CORE_LOAD_CONTACT_US_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return CORE_LOAD_CONTACT_US_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_454", function() { return CORE_UPDATE_CONTACT_US_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_455", function() { return CORE_UPDATE_CONTACT_US_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_453", function() { return CORE_UPDATE_CONTACT_US_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return CORE_LOAD_REPORTROOMSTATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return CORE_LOAD_REPORTROOMSTATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return CORE_LOAD_REPORTROOMSTATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return CORE_LOAD_ALL_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return CORE_LOAD_ALL_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return CORE_LOAD_ALL_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return CORE_LOAD_ALLBUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return CORE_LOAD_ALLBUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return CORE_LOAD_ALLBUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_DELETE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_DELETE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_DELETE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return CORE_LOAD_BUILDINGINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return CORE_LOAD_BUILDINGINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return CORE_LOAD_BUILDINGINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_451", function() { return CORE_UPDATE_BUILDINGINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_452", function() { return CORE_UPDATE_BUILDINGINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_450", function() { return CORE_UPDATE_BUILDINGINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_CREATE_BUILDING_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_CREATE_BUILDING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_CREATE_BUILDING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return CORE_LOAD_ALLFLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return CORE_LOAD_ALLFLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return CORE_LOAD_ALLFLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_DELETE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_DELETE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_DELETE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return CORE_LOAD_FLOORINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return CORE_LOAD_FLOORINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return CORE_LOAD_FLOORINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_490", function() { return CORE_UPDATE_FLOORINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_491", function() { return CORE_UPDATE_FLOORINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_489", function() { return CORE_UPDATE_FLOORINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_CREATE_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_CREATE_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_CREATE_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return CORE_LOAD_ALLZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return CORE_LOAD_ALLZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return CORE_LOAD_ALLZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_DELETE_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_DELETE_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_DELETE_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_403", function() { return CORE_LOAD_ZONEINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_404", function() { return CORE_LOAD_ZONEINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_402", function() { return CORE_LOAD_ZONEINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_538", function() { return CORE_UPDATE_ZONEINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_539", function() { return CORE_UPDATE_ZONEINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_537", function() { return CORE_UPDATE_ZONEINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_CREATE_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_CREATE_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_CREATE_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return CORE_LOAD_ALLBACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return CORE_LOAD_ALLBACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return CORE_LOAD_ALLBACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_DELETE_BACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_DELETE_BACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_DELETE_BACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return CORE_LOAD_BACKGROUNDINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return CORE_LOAD_BACKGROUNDINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return CORE_LOAD_BACKGROUNDINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_448", function() { return CORE_UPDATE_BACKGROUNDINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_449", function() { return CORE_UPDATE_BACKGROUNDINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_447", function() { return CORE_UPDATE_BACKGROUNDINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_CREATE_BACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_CREATE_BACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_CREATE_BACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_460", function() { return CORE_UPDATE_DEFAULTBACKGROUND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_461", function() { return CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_459", function() { return CORE_UPDATE_DEFAULTBACKGROUND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return CORE_GET_CATEGORY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return CORE_GET_CATEGORY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return CORE_GET_CATEGORY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_487", function() { return CORE_UPDATE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_488", function() { return CORE_UPDATE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_486", function() { return CORE_UPDATE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_CREATE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_CREATE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_CREATE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_DELETE_FB_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_DELETE_FB_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_DELETE_FB_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return CORE_LOAD_ALL_USERSAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return CORE_LOAD_ALL_USERSAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return CORE_LOAD_ALL_USERSAD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_CHECK_AD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_CHECK_AD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_CHECK_AD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_CHECK_TMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_CHECK_TMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_CHECK_TMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_CHECK_CMR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_CHECK_CMR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_CHECK_CMR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_CHECK_BOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_CHECK_BOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_CHECK_BOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_367", function() { return CORE_LOAD_TIMEZOZE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_368", function() { return CORE_LOAD_TIMEZOZE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_366", function() { return CORE_LOAD_TIMEZOZE_FAILURE; });
/* unused harmony export CORE_DELETE_IOT_REQUEST */
/* unused harmony export CORE_DELETE_IOT_SUCCESS */
/* unused harmony export CORE_DELETE_IOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_505", function() { return CORE_UPDATE_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_506", function() { return CORE_UPDATE_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_504", function() { return CORE_UPDATE_IOT_FAILURE; });
/* unused harmony export CORE_CREATE_IOT_REQUEST */
/* unused harmony export CORE_CREATE_IOT_SUCCESS */
/* unused harmony export CORE_CREATE_IOT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return CORE_LOAD_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return CORE_LOAD_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return CORE_LOAD_IOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return CORE_GET_IOT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return CORE_GET_IOT_INFO_SUCCESS; });
/* unused harmony export CORE_GET_IOT_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_EDIT_GOOGLE_INTEGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_EDIT_GOOGLE_INTEGRATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_496", function() { return CORE_UPDATE_HOTSEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_497", function() { return CORE_UPDATE_HOTSEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_495", function() { return CORE_UPDATE_HOTSEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return CORE_LOAD_ALLSEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return CORE_LOAD_ALLSEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return CORE_LOAD_ALLSEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_352", function() { return CORE_LOAD_SEAT_ZONE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_353", function() { return CORE_LOAD_SEAT_ZONE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_351", function() { return CORE_LOAD_SEAT_ZONE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_349", function() { return CORE_LOAD_SEAT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_350", function() { return CORE_LOAD_SEAT_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_348", function() { return CORE_LOAD_SEAT_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return CORE_LOAD_ALLDISABLESEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return CORE_LOAD_ALLDISABLESEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return CORE_LOAD_ALLDISABLESEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_CREATE_DISABLEDSEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_CREATE_DISABLEDSEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_CREATE_DISABLEDSEAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return CORE_LOAD_DISABLESEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return CORE_LOAD_DISABLESEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return CORE_LOAD_DISABLESEATINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_463", function() { return CORE_UPDATE_DISABLESEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_464", function() { return CORE_UPDATE_DISABLESEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_462", function() { return CORE_UPDATE_DISABLESEATINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_DELETE_DISABLESEATINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_DELETE_DISABLESEATINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_DELETE_DISABLESEATINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_418", function() { return CORE_SEARCH_ROOMS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_419", function() { return CORE_SEARCH_ROOMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_417", function() { return CORE_SEARCH_ROOMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_412", function() { return CORE_SEARCH_FLOOR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_413", function() { return CORE_SEARCH_FLOOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_411", function() { return CORE_SEARCH_FLOOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_424", function() { return CORE_SEARCH_ZONE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_425", function() { return CORE_SEARCH_ZONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_423", function() { return CORE_SEARCH_ZONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_415", function() { return CORE_SEARCH_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_416", function() { return CORE_SEARCH_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_414", function() { return CORE_SEARCH_IOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_421", function() { return CORE_SEARCH_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_422", function() { return CORE_SEARCH_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_420", function() { return CORE_SEARCH_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_409", function() { return CORE_SEARCH_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_410", function() { return CORE_SEARCH_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_408", function() { return CORE_SEARCH_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_CHECKIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_CHECKIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_CHECKIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_CHECKOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_CHECKOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_CHECKOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_DELETE_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_DELETE_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_DELETE_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_406", function() { return CORE_RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_407", function() { return CORE_RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_405", function() { return CORE_RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return CORE_LOAD_IOT_ROOMREGIS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return CORE_LOAD_IOT_ROOMREGIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return CORE_LOAD_IOT_ROOMREGIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return CORE_GET_IOT_ROOMREGIS_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return CORE_GET_IOT_ROOMREGIS_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_CREATE_IOT_ROOMREGIS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_CREATE_IOT_ROOMREGIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_CREATE_IOT_ROOMREGIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_DELETE_IOT_ROOMREGIS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_DELETE_IOT_ROOMREGIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_DELETE_IOT_ROOMREGIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return CORE_LOAD_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return CORE_LOAD_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return CORE_LOAD_DISPLAY_FAILURE; });
/* unused harmony export CORE_GET_DISPLAY_INFO_REQUEST */
/* unused harmony export CORE_GET_DISPLAY_INFO_SUCCESS */
/* unused harmony export CORE_GET_DISPLAY_INFO_FAILURE */
/* unused harmony export CORE_CREATE_DISPLAY_REQUEST */
/* unused harmony export CORE_CREATE_DISPLAY_SUCCESS */
/* unused harmony export CORE_CREATE_DISPLAY_FAILURE */
/* unused harmony export CORE_DELETE_DISPLAY_REQUEST */
/* unused harmony export CORE_DELETE_DISPLAY_SUCCESS */
/* unused harmony export CORE_DELETE_DISPLAY_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_466", function() { return CORE_UPDATE_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_467", function() { return CORE_UPDATE_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_465", function() { return CORE_UPDATE_DISPLAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_590", function() { return PROFILE_CENTER_LOAD_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_591", function() { return PROFILE_CENTER_LOAD_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_589", function() { return PROFILE_CENTER_LOAD_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_596", function() { return PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_597", function() { return PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_595", function() { return PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_593", function() { return PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_594", function() { return PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_592", function() { return PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return CORE_LOAD_ALL_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return CORE_LOAD_ALL_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return CORE_LOAD_ALL_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_328", function() { return CORE_LOAD_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_329", function() { return CORE_LOAD_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_327", function() { return CORE_LOAD_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_CREATE_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_CREATE_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_CREATE_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_520", function() { return CORE_UPDATE_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_521", function() { return CORE_UPDATE_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_519", function() { return CORE_UPDATE_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_DELETE_ROOMDISABLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_DELETE_ROOMDISABLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_DELETE_ROOMDISABLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_400", function() { return CORE_LOAD_VC_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_401", function() { return CORE_LOAD_VC_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_399", function() { return CORE_LOAD_VC_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return CORE_LOAD_CONCURRENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return CORE_LOAD_CONCURRENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return CORE_LOAD_CONCURRENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_DELETE_CONCURRENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_DELETE_CONCURRENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_DELETE_CONCURRENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return CORE_LOAD_ROLES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return CORE_LOAD_ROLES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return CORE_LOAD_ROLES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_CREATE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_CREATE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_CREATE_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_322", function() { return CORE_LOAD_ROLE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_323", function() { return CORE_LOAD_ROLE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_321", function() { return CORE_LOAD_ROLE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_517", function() { return CORE_UPDATE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_518", function() { return CORE_UPDATE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_516", function() { return CORE_UPDATE_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_DELETE_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_DELETE_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_DELETE_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_478", function() { return CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_479", function() { return CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_477", function() { return CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return CORE_LOAD_ORDER_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return CORE_LOAD_ORDER_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return CORE_LOAD_ORDER_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_DELETE_ORDER_FBS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_DELETE_ORDER_FBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_DELETE_ORDER_FBS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return CORE_LOAD_ORDER_FBS_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return CORE_LOAD_ORDER_FBS_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return CORE_LOAD_ORDER_FBS_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_511", function() { return CORE_UPDATE_ORDER_FBS_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_512", function() { return CORE_UPDATE_ORDER_FBS_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_510", function() { return CORE_UPDATE_ORDER_FBS_INFO_FAILURE; });
/* unused harmony export CORE_CREATE_ORDER_FBS_REQUEST */
/* unused harmony export CORE_CREATE_ORDER_FBS_SUCCESS */
/* unused harmony export CORE_CREATE_ORDER_FBS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return CORE_LOAD_ORDER_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return CORE_LOAD_ORDER_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return CORE_LOAD_ORDER_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_DELETE_ORDER_AMENITY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_DELETE_ORDER_AMENITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_DELETE_ORDER_AMENITY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return CORE_LOAD_ORDER_AMENITY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return CORE_LOAD_ORDER_AMENITY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_508", function() { return CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_509", function() { return CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_507", function() { return CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_572", function() { return O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_573", function() { return O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_571", function() { return O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_CREATE_ORDER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_CREATE_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_CREATE_ORDER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return CORE_LOAD_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return CORE_LOAD_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return CORE_LOAD_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return CORE_LOAD_EVENTTYPE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return CORE_LOAD_EVENTTYPE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return CORE_LOAD_EVENTTYPE_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_CREATE_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_CREATE_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_CREATE_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_475", function() { return CORE_UPDATE_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_476", function() { return CORE_UPDATE_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_474", function() { return CORE_UPDATE_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_DELETE_EVENTTYPE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_DELETE_EVENTTYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_DELETE_EVENTTYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_433", function() { return CORE_UNREGISTER_DISPLAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_434", function() { return CORE_UNREGISTER_DISPLAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_432", function() { return CORE_UNREGISTER_DISPLAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_439", function() { return CORE_UNREGISTER_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_440", function() { return CORE_UNREGISTER_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_438", function() { return CORE_UNREGISTER_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_436", function() { return CORE_UNREGISTER_IOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_437", function() { return CORE_UNREGISTER_IOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_435", function() { return CORE_UNREGISTER_IOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return CORE_IMPORT_USER_O365_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return CORE_IMPORT_USER_O365_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return CORE_IMPORT_USER_O365_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_430", function() { return CORE_SYNC_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_431", function() { return CORE_SYNC_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_429", function() { return CORE_SYNC_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return CORE_LOAD_IOT_MODULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return CORE_LOAD_IOT_MODULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return CORE_LOAD_IOT_MODULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_CREATE_IOT_MODULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_CREATE_IOT_MODULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_CREATE_IOT_MODULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return CORE_LOAD_IOTINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return CORE_LOAD_IOTINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return CORE_LOAD_IOTINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_499", function() { return CORE_UPDATE_IOTINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_500", function() { return CORE_UPDATE_IOTINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_498", function() { return CORE_UPDATE_IOTINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return CORE_GET_IOT_INFO_WITH_MODULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return CORE_GET_IOT_INFO_WITH_MODULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_GET_ALL_IOT_MODULE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_GET_ALL_IOT_MODULE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_GET_ALL_IOT_MODULE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_502", function() { return CORE_UPDATE_IOT_DATA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_503", function() { return CORE_UPDATE_IOT_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_501", function() { return CORE_UPDATE_IOT_DATA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return CORE_LOAD_ALL_TEMPORARY_CLOSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return CORE_LOAD_ALL_TEMPORARY_CLOSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return CORE_LOAD_ALL_TEMPORARY_CLOSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_CREATE_TEMP_CLOSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_CREATE_TEMP_CLOSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_CREATE_TEMP_CLOSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_DELETE_TEMP_CLOSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_DELETE_TEMP_CLOSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_DELETE_TEMP_CLOSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_361", function() { return CORE_LOAD_TEMPORARY_CLOSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_362", function() { return CORE_LOAD_TEMPORARY_CLOSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_360", function() { return CORE_LOAD_TEMPORARY_CLOSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_526", function() { return CORE_UPDATE_TEMP_CLOSE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_527", function() { return CORE_UPDATE_TEMP_CLOSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_525", function() { return CORE_UPDATE_TEMP_CLOSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return CORE_LOAD_ALL_AVAILABLE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return CORE_LOAD_ALL_AVAILABLE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return CORE_LOAD_ALL_AVAILABLE_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return CORE_LOAD_AVAILABLE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return CORE_LOAD_AVAILABLE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return CORE_LOAD_AVAILABLE_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_CREATE_AVAILABLE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_CREATE_AVAILABLE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_CREATE_AVAILABLE_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_445", function() { return CORE_UPDATE_AVAILABLE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_446", function() { return CORE_UPDATE_AVAILABLE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_444", function() { return CORE_UPDATE_AVAILABLE_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_DELETE_AVAILABLE_TIMESLOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_DELETE_AVAILABLE_TIMESLOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_DELETE_AVAILABLE_TIMESLOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_CREATE_HOTDESK_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_CREATE_HOTDESK_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_CREATE_HOTDESK_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_493", function() { return CORE_UPDATE_HOTDESK_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_494", function() { return CORE_UPDATE_HOTDESK_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_492", function() { return CORE_UPDATE_HOTDESK_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_DELETE_HOTDESK_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_DELETE_HOTDESK_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_DELETE_HOTDESK_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return CORE_LOAD_HOTDESK_ROLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return CORE_LOAD_HOTDESK_ROLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return CORE_LOAD_HOTDESK_ROLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return CORE_LOAD_ALL_CONTROL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return CORE_LOAD_ALL_CONTROL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return CORE_LOAD_ALL_CONTROL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return CORE_LOAD_ALL_IOT_ROOMINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return CORE_LOAD_ALL_IOT_ROOMINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return CORE_LOAD_ALL_IOT_ROOMINFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_472", function() { return CORE_UPDATE_DOUT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_473", function() { return CORE_UPDATE_DOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_471", function() { return CORE_UPDATE_DOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_457", function() { return CORE_UPDATE_DALI_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_458", function() { return CORE_UPDATE_DALI_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_456", function() { return CORE_UPDATE_DALI_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_469", function() { return CORE_UPDATE_DMX_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_470", function() { return CORE_UPDATE_DMX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_468", function() { return CORE_UPDATE_DMX_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_GET_ALL_LOCATION_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_GET_ALL_LOCATION_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_GET_ALL_LOCATION_INFO_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return CORE_LOAD_ALL_AD_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return CORE_LOAD_ALL_AD_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return CORE_LOAD_ALL_AD_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return CORE_IMPORT_USER_AD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return CORE_IMPORT_USER_AD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return CORE_IMPORT_USER_AD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_427", function() { return CORE_SYNC_365_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_428", function() { return CORE_SYNC_365_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_426", function() { return CORE_SYNC_365_USERS_FAILURE; });
var LOGOUT = 'LOGOUT';
var SET_ERROR = 'SET_ERROR';

var O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST';
var O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS';
var O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE';

var O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST';
var O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS';
var O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE';

var O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST';
var O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS';
var O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE';

var O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST';
var O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS';
var O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE';

var O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST';
var O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS';
var O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE';

var O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST';
var O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS';
var O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE';

var O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST';
var O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS';
var O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE';

var O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST';
var O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS';
var O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE';

var BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST';
var BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS';
var BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE';

var PROFILE_LOGIN_REQUEST = 'PROFILE_LOGIN_REQUEST';
var PROFILE_LOGIN_SUCCESS = 'PROFILE_LOGIN_SUCCESS';
var PROFILE_LOGIN_FAILURE = 'PROFILE_LOGIN_FAILURE';

var O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST';
var O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS';
var O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE';

var O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST';
var O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS';
var O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE';

var O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST';
var O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS';
var O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE';

var CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST';
var CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS';
var CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE';

var CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST';
var CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS';
var CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE';

var CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT';

var CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST';
var CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS';
var CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE';

var CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST';
var CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS';
var CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE';

var CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST';
var CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS';
var CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE';

var O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST';
var O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS';
var O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE';

var O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST';
var O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS';
var O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE';

var O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST';
var O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS';
var O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE';

var CORE_LOAD_LOCATIONS_REQUEST = 'CORE_LOAD_LOCATIONS_REQUEST';
var CORE_LOAD_LOCATIONS_SUCCESS = 'CORE_LOAD_LOCATIONS_SUCCESS';
var CORE_LOAD_LOCATIONS_FAILURE = 'CORE_LOAD_LOCATIONS_FAILURE';

var O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST';
var O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS';
var O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE';

var CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_GO_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_GO_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_GO_SAVE_DATA = 'CORE_INTEGRATION_O365_GO_SAVE_DATA';

var CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID';
var CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT';
var CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST';
var CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS';
var CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE';

var CORE_CREATE_ROOM_REQUEST = 'CORE_CREATE_ROOM_REQUEST';
var CORE_CREATE_ROOM_SUCCESS = 'CORE_CREATE_ROOM_SUCCESS';
var CORE_CREATE_ROOM_FAILURE = 'CORE_CREATE_ROOM_FAILURE';

var CORE_LOAD_ROOM_REQUEST = 'CORE_LOAD_ROOM_REQUEST';
var CORE_LOAD_ROOM_SUCCESS = 'CORE_LOAD_ROOM_SUCCESS';
var CORE_LOAD_ROOM_FAILURE = 'CORE_LOAD_ROOM_FAILURE';

var CORE_FIND_ROOM_REQUEST = 'CORE_FIND_ROOM_REQUEST';
var CORE_FIND_ROOM_SUCCESS = 'CORE_FIND_ROOM_SUCCESS';
var CORE_FIND_ROOM_FAILURE = 'CORE_FIND_ROOM_FAILURE';

var CORE_UPDATE_ROOM_REQUEST = 'CORE_UPDATE_ROOM_REQUEST';
var CORE_UPDATE_ROOM_SUCCESS = 'CORE_UPDATE_ROOM_SUCCESS';
var CORE_UPDATE_ROOM_FAILURE = 'CORE_UPDATE_ROOM_FAILURE';

var CORE_DELETE_ROOM_REQUEST = 'CORE_DELETE_ROOM_REQUEST';
var CORE_DELETE_ROOM_SUCCESS = 'CORE_DELETE_ROOM_SUCCESS';
var CORE_DELETE_ROOM_FAILURE = 'CORE_DELETE_ROOM_FAILURE';

var O365_DELETE_ROOM_SUBSCRIBE_REQUEST = 'O365_DELETE_ROOM_SUBSCRIBE_REQUEST';
var O365_DELETE_ROOM_SUBSCRIBE_SUCCESS = 'O365_DELETE_ROOM_SUBSCRIBE_SUCCESS';
var O365_DELETE_ROOM_SUBSCRIBE_FAILURE = 'O365_DELETE_ROOM_SUBSCRIBE_FAILURE';

var O365_CREATE_ROOM_SUBSCRIBE_REQUEST = 'O365_CREATE_ROOM_SUBSCRIBE_REQUEST';
var O365_CREATE_ROOM_SUBSCRIBE_SUCCESS = 'O365_CREATE_ROOM_SUBSCRIBE_SUCCESS';
var O365_CREATE_ROOM_SUBSCRIBE_FAILURE = 'O365_CREATE_ROOM_SUBSCRIBE_FAILURE';

var O365_LOAD_ROOMS_REQUEST = 'O365_LOAD_ROOMS_REQUEST';
var O365_LOAD_ROOMS_SUCCESS = 'O365_LOAD_ROOMS_SUCCESS';
var O365_LOAD_ROOMS_FAILURE = 'O365_LOAD_ROOMS_FAILURE';

var O365_LOAD_ROOMS_INFO_REQUEST = 'O365_LOAD_ROOMS_INFO_REQUEST';
var O365_LOAD_ROOMS_INFO_SUCCESS = 'O365_LOAD_ROOMS_INFO_SUCCESS';
var O365_LOAD_ROOMS_INFO_FAILURE = 'O365_LOAD_ROOMS_INFO_FAILURE';

var O365_LOAD_USERS_REQUEST = 'O365_LOAD_USERS_REQUEST';
var O365_LOAD_USERS_SUCCESS = 'O365_LOAD_USERS_SUCCESS';
var O365_LOAD_USERS_FAILURE = 'O365_LOAD_USERS_FAILURE';

var BSRS_SERVICE_TOKEN_REQUEST = 'BSRS_SERVICE_TOKEN_REQUEST';
var BSRS_SERVICE_TOKEN_SUCCESS = 'BSRS_SERVICE_TOKEN_SUCCESS';
var BSRS_SERVICE_TOKEN_FAILURE = 'BSRS_SERVICE_TOKEN_FAILURE';

var CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST';
var CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS';
var CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE';

var CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST = 'CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST';
var CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS = 'CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS';
var CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE = 'CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE';

var CORE_LOAD_REPORT_REQUEST = 'CORE_LOAD_REPORT_REQUEST';
var CORE_LOAD_REPORT_SUCCESS = 'CORE_LOAD_REPORT_SUCCESS';
var CORE_LOAD_REPORT_FAILURE = 'CORE_LOAD_REPORT_FAILURE';

var CORE_LOAD_LOCATIONS_REPORT_REQUEST = 'CORE_LOAD_LOCATIONS_REPORT_REQUEST';
var CORE_LOAD_LOCATIONS_REPORT_SUCCESS = 'CORE_LOAD_LOCATIONS_REPORT_SUCCESS';
var CORE_LOAD_LOCATIONS_REPORT_FAILURE = 'CORE_LOAD_LOCATIONS_REPORT_FAILURE';

var CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST';
var CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS';
var CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE';

var CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST';
var CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS';
var CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE';

var CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST';
var CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS';
var CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

var CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST';
var CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS';
var CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE';

var CORE_USER_CHANGEPASS_REQUEST = 'CORE_USER_CHANGEPASS_REQUEST';
var CORE_USER_CHANGEPASS_SUCCESS = 'CORE_USER_CHANGEPASS_SUCCESS';
var CORE_USER_CHANGEPASS_FAILURE = 'CORE_USER_CHANGEPASS_FAILURE';

var CORE_EDIT_USER_REQUEST = 'CORE_EDIT_USER_REQUEST';
var CORE_EDIT_USER_SUCCESS = 'CORE_EDIT_USER_SUCCESS';
var CORE_EDIT_USER_FAILURE = 'CORE_EDIT_USER_FAILURE';

var CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST';
var CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS';
var CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE';

var CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST';
var CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS';
var CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE';

var CORE_GET_INTEGRATION_REQUEST = 'CORE_GET_INTEGRATION_REQUEST';
var CORE_GET_INTEGRATION_SUCCESS = 'CORE_GET_INTEGRATION_SUCCESS';
var CORE_GET_INTEGRATION_FAILURE = 'CORE_GET_INTEGRATION_FAILURE';

var CORE_LOAD_SETTING_INFO_REQUEST = 'CORE_LOAD_SETTING_INFO_REQUEST';
var CORE_LOAD_SETTING_INFO_SUCCESS = 'CORE_LOAD_SETTING_INFO_SUCCESS';
var CORE_LOAD_SETTING_INFO_FAILURE = 'CORE_LOAD_SETTING_INFO_FAILURE';

var CORE_CHANGE_SETTING_REQUEST = 'CORE_CHANGE_SETTING_REQUEST';
var CORE_CHANGE_SETTING_SUCCESS = 'CORE_CHANGE_SETTING_SUCCESS';
var CORE_CHANGE_SETTING_FAILURE = 'CORE_CHANGE_SETTING_FAILURE';

var CORE_LOAD_USERREPORT_REQUEST = 'CORE_LOAD_USERREPORT_REQUEST';
var CORE_LOAD_USERREPORT_SUCCESS = 'CORE_LOAD_USERREPORT_SUCCESS';
var CORE_LOAD_USERREPORT_FAILURE = 'CORE_LOAD_USERREPORT_FAILURE';

var CORE_LOAD_ROOMREPORT_REQUEST = 'CORE_LOAD_ROOMREPORT_REQUEST';
var CORE_LOAD_ROOMREPORT_SUCCESS = 'CORE_LOAD_ROOMREPORT_SUCCESS';
var CORE_LOAD_ROOMREPORT_FAILURE = 'CORE_LOAD_ROOMREPORT_FAILURE';

var CORE_LOAD_USERSUMMARY_REQUEST = 'CORE_LOAD_USERSUMMARY_REQUEST';
var CORE_LOAD_USERSUMMARY_SUCCESS = 'CORE_LOAD_USERSUMMARY_SUCCESS';
var CORE_LOAD_USERSUMMARY_FAILURE = 'CORE_LOAD_USERSUMMARY_FAILURE';

var CORE_LOAD_ROOMSUMMARY_REQUEST = 'CORE_LOAD_ROOMSUMMARY_REQUEST';
var CORE_LOAD_ROOMSUMMARY_SUCCESS = 'CORE_LOAD_ROOMSUMMARY_SUCCESS';
var CORE_LOAD_ROOMSUMMARY_FAILURE = 'CORE_LOAD_ROOMSUMMARY_FAILURE';

var CORE_LOAD_REPORTSUMMARY_REQUEST = 'CORE_LOAD_REPORTSUMMARY_REQUEST';
var CORE_LOAD_REPORTSUMMARY_SUCCESS = 'CORE_LOAD_REPORTSUMMARY_SUCCESS';
var CORE_LOAD_REPORTSUMMARY_FAILURE = 'CORE_LOAD_REPORTSUMMARY_FAILURE';

var CORE_LOAD_ALLAMENITY_REQUEST = 'CORE_LOAD_ALLAMENITY_REQUEST';
var CORE_LOAD_ALLAMENITY_SUCCESS = 'CORE_LOAD_ALLAMENITY_SUCCESS';
var CORE_LOAD_ALLAMENITY_FAILURE = 'CORE_LOAD_ALLAMENITY_FAILURE';

var CORE_DELETE_AMENITY_REQUEST = 'CORE_DELETE_AMENITY_REQUEST';
var CORE_DELETE_AMENITY_SUCCESS = 'CORE_DELETE_AMENITY_SUCCESS';
var CORE_DELETE_AMENITY_FAILURE = 'CORE_DELETE_AMENITY_FAILURE';

var CORE_LOAD_AMENITYINFO_REQUEST = 'CORE_LOAD_AMENITYINFO_REQUEST';
var CORE_LOAD_AMENITYINFO_SUCCESS = 'CORE_LOAD_AMENITYINFO_SUCCESS';
var CORE_LOAD_AMENITYINFO_FAILURE = 'CORE_LOAD_AMENITYINFO_FAILURE';

var CORE_CREATE_AMENITY_REQUEST = 'CORE_CREATE_AMENITY_REQUEST';
var CORE_CREATE_AMENITY_SUCCESS = 'CORE_CREATE_AMENITY_SUCCESS';
var CORE_CREATE_AMENITY_FAILURE = 'CORE_CREATE_AMENITY_FAILURE';

var CORE_UPDATE_AMENITYINFO_REQUEST = 'CORE_UPDATE_AMENITYINFO_REQUEST';
var CORE_UPDATE_AMENITYINFO_SUCCESS = 'CORE_UPDATE_AMENITYINFO_SUCCESS';
var CORE_UPDATE_AMENITYINFO_FAILURE = 'CORE_UPDATE_AMENITYINFO_FAILURE';

var CORE_LOAD_ALL_PROFILE_REQUEST = 'CORE_LOAD_ALL_PROFILE_REQUEST';
var CORE_LOAD_ALL_PROFILE_SUCCESS = 'CORE_LOAD_ALL_PROFILE_SUCCESS';
var CORE_LOAD_ALL_PROFILE_FAILURE = 'CORE_LOAD_ALL_PROFILE_FAILURE';

var CORE_LOAD_PROFILE_INFO_REQUEST = 'CORE_LOAD_PROFILE_INFO_REQUEST';
var CORE_LOAD_PROFILE_INFO_SUCCESS = 'CORE_LOAD_PROFILE_INFO_SUCCESS';
var CORE_LOAD_PROFILE_INFO_FAILURE = 'CORE_LOAD_PROFILE_INFO_FAILURE';

var CORE_CREATE_PROFILE_REQUEST = 'CORE_CREATE_PROFILE_REQUEST';
var CORE_CREATE_PROFILE_SUCCESS = 'CORE_CREATE_PROFILE_SUCCESS';
var CORE_CREATE_PROFILE_FAILURE = 'CORE_CREATE_PROFILE_FAILURE';

var CORE_UPDATE_PROFILE_REQUEST = 'CORE_UPDATE_PROFILE_REQUEST';
var CORE_UPDATE_PROFILE_SUCCESS = 'CORE_UPDATE_PROFILE_SUCCESS';
var CORE_UPDATE_PROFILE_FAILURE = 'CORE_UPDATE_PROFILE_FAILURE';

var CORE_DELETE_PROFILE_REQUEST = 'CORE_DELETE_PROFILE_REQUEST';
var CORE_DELETE_PROFILE_SUCCESS = 'CORE_DELETE_PROFILE_SUCCESS';
var CORE_DELETE_PROFILE_FAILURE = 'CORE_DELETE_PROFILE_FAILURE';

var CORE_LOAD_USERGROUPS_REQUEST = 'CORE_LOAD_USERGROUPS_REQUEST';
var CORE_LOAD_USERGROUPS_SUCCESS = 'CORE_LOAD_USERGROUPS_SUCCESS';
var CORE_LOAD_USERGROUPS_FAILURE = 'CORE_LOAD_USERGROUPS_FAILURE';

var CORE_LOAD_LIST_USERGROUPS_REQUEST = 'CORE_LOAD_LIST_USERGROUPS_REQUEST';
var CORE_LOAD_LIST_USERGROUPS_SUCCESS = 'CORE_LOAD_LIST_USERGROUPS_SUCCESS';
var CORE_LOAD_LIST_USERGROUPS_FAILURE = 'CORE_LOAD_LIST_USERGROUPS_FAILURE';

var CORE_LOAD_USERGROUP_REQUEST = 'CORE_LOAD_USERGROUP_REQUEST';
var CORE_LOAD_USERGROUP_SUCCESS = 'CORE_LOAD_USERGROUP_SUCCESS';
var CORE_LOAD_USERGROUP_FAILURE = 'CORE_LOAD_USERGROUP_FAILURE';

var CORE_CREATE_USERGROUP_REQUEST = 'CORE_CREATE_USERGROUP_REQUEST';
var CORE_CREATE_USERGROUP_SUCCESS = 'CORE_CREATE_USERGROUP_SUCCESS';
var CORE_CREATE_USERGROUP_FAILURE = 'CORE_CREATE_USERGROUP_FAILURE';

var CORE_UPDATE_USERGROUP_REQUEST = 'CORE_UPDATE_USERGROUP_REQUEST';
var CORE_UPDATE_USERGROUP_SUCCESS = 'CORE_UPDATE_USERGROUP_SUCCESS';
var CORE_UPDATE_USERGROUP_FAILURE = 'CORE_UPDATE_USERGROUP_FAILURE';

var CORE_DELETE_USERGROUP_REQUEST = 'CORE_DELETE_USERGROUP_REQUEST';
var CORE_DELETE_USERGROUP_SUCCESS = 'CORE_DELETE_USERGROUP_SUCCESS';
var CORE_DELETE_USERGROUP_FAILURE = 'CORE_DELETE_USERGROUP_FAILURE';

var CORE_LOAD_ACTIONS_REQUEST = 'CORE_LOAD_ACTIONS_REQUEST';
var CORE_LOAD_ACTIONS_SUCCESS = 'CORE_LOAD_ACTIONS_SUCCESS';
var CORE_LOAD_ACTIONS_FAILURE = 'CORE_LOAD_ACTIONS_FAILURE';

var CORE_LOAD_ALLFBS_REQUEST = 'CORE_LOAD_ALLFBS_REQUEST';
var CORE_LOAD_ALLFBS_SUCCESS = 'CORE_LOAD_ALLFBS_SUCCESS';
var CORE_LOAD_ALLFBS_FAILURE = 'CORE_LOAD_ALLFBS_FAILURE';

var CORE_DELETE_FBS_REQUEST = 'CORE_DELETE_FBS_REQUEST';
var CORE_DELETE_FBS_SUCCESS = 'CORE_DELETE_FBS_SUCCESS';
var CORE_DELETE_FBS_FAILURE = 'CORE_DELETE_FBS_FAILURE';

var CORE_LOAD_FBSINFO_REQUEST = 'CORE_LOAD_FBSINFO_REQUEST';
var CORE_LOAD_FBSINFO_SUCCESS = 'CORE_LOAD_FBSINFO_SUCCESS';
var CORE_LOAD_FBSINFO_FAILURE = 'CORE_LOAD_FBSINFO_FAILURE';

var CORE_CREATE_FBS_REQUEST = 'CORE_CREATE_FBS_REQUEST';
var CORE_CREATE_FBS_SUCCESS = 'CORE_CREATE_FBS_SUCCESS';
var CORE_CREATE_FBS_FAILURE = 'CORE_CREATE_FBS_FAILURE';

var CORE_UPDATE_FBSINFO_REQUEST = 'CORE_UPDATE_FBSINFO_REQUEST';
var CORE_UPDATE_FBSINFO_SUCCESS = 'CORE_UPDATE_FBSINFO_SUCCESS';
var CORE_UPDATE_FBSINFO_FAILURE = 'CORE_UPDATE_FBSINFO_FAILURE';

var CORE_GET_INTEGRATION_INFO_REQUEST = 'CORE_GET_INTEGRATION_INFO_REQUEST';
var CORE_GET_INTEGRATION_INFO_SUCCESS = 'CORE_GET_INTEGRATION_INFO_SUCCESS';
var CORE_GET_INTEGRATION_INFO_FAILURE = 'CORE_GET_INTEGRATION_INFO_FAILURE';

var CORE_LOAD_STATUSUSER_REQUEST = 'CORE_LOAD_STATUSUSER_REQUEST';
var CORE_LOAD_STATUSUSER_SUCCESS = 'CORE_LOAD_STATUSUSER_SUCCESS';
var CORE_LOAD_STATUSUSER_FAILURE = 'CORE_LOAD_STATUSUSER_FAILURE';

var CORE_LOAD_USERSUM_REQUEST = 'CORE_LOAD_USERSUM_REQUEST';
var CORE_LOAD_USERSUM_SUCCESS = 'CORE_LOAD_USERSUM_SUCCESS';
var CORE_LOAD_USERSUM_FAILURE = 'CORE_LOAD_USERSUM_FAILURE';

var CORE_LOAD_ROOMSUM_REQUEST = 'CORE_LOAD_ROOMSUM_REQUEST';
var CORE_LOAD_ROOMSUM_SUCCESS = 'CORE_LOAD_ROOMSUM_SUCCESS';
var CORE_LOAD_ROOMSUM_FAILURE = 'CORE_LOAD_ROOMSUM_FAILURE';

var CORE_LOAD_ROOMTEMP_REQUEST = 'CORE_LOAD_ROOMTEMP_REQUEST';
var CORE_LOAD_ROOMTEMP_SUCCESS = 'CORE_LOAD_ROOMTEMP_SUCCESS';
var CORE_LOAD_ROOMTEMP_FAILURE = 'CORE_LOAD_ROOMTEMP_FAILURE';

var CORE_LOAD_TOPROOMRESERVE_REQUEST = 'CORE_LOAD_TOPROOMRESERVE_REQUEST';
var CORE_LOAD_TOPROOMRESERVE_SUCCESS = 'CORE_LOAD_TOPROOMRESERVE_SUCCESS';
var CORE_LOAD_TOPROOMRESERVE_FAILURE = 'CORE_LOAD_TOPROOMRESERVE_FAILURE';

var CORE_LOAD_TOPUSERRESERVE_REQUEST = 'CORE_LOAD_TOPUSERRESERVE_REQUEST';
var CORE_LOAD_TOPUSERRESERVE_SUCCESS = 'CORE_LOAD_TOPUSERRESERVE_SUCCESS';
var CORE_LOAD_TOPUSERRESERVE_FAILURE = 'CORE_LOAD_TOPUSERRESERVE_FAILURE';

var CORE_LOAD_ROOMDETAIL_REQUEST = 'CORE_LOAD_ROOMDETAIL_REQUEST';
var CORE_LOAD_ROOMDETAIL_SUCCESS = 'CORE_LOAD_ROOMDETAIL_SUCCESS';
var CORE_LOAD_ROOMDETAIL_FAILURE = 'CORE_LOAD_ROOMDETAIL_FAILURE';

var CORE_LOAD_TERM_REQUEST = 'CORE_LOAD_TERM_REQUEST';
var CORE_LOAD_TERM_SUCCESS = 'CORE_LOAD_TERM_SUCCESS';
var CORE_LOAD_TERM_FAILURE = 'CORE_LOAD_TERM_FAILURE';

var CORE_UPDATE_TERM_REQUEST = 'CORE_UPDATE_TERM_REQUEST';
var CORE_UPDATE_TERM_SUCCESS = 'CORE_UPDATE_TERM_SUCCESS';
var CORE_UPDATE_TERM_FAILURE = 'CORE_UPDATE_TERM_FAILURE';

var CORE_LOAD_FAQ_REQUEST = 'CORE_LOAD_FAQ_REQUEST';
var CORE_LOAD_FAQ_SUCCESS = 'CORE_LOAD_FAQ_SUCCESS';
var CORE_LOAD_FAQ_FAILURE = 'CORE_LOAD_FAQ_FAILURE';

var CORE_UPDATE_FAQ_REQUEST = 'CORE_UPDATE_FAQ_REQUEST';
var CORE_UPDATE_FAQ_SUCCESS = 'CORE_UPDATE_FAQ_SUCCESS';
var CORE_UPDATE_FAQ_FAILURE = 'CORE_UPDATE_FAQ_FAILURE';

var CORE_LOAD_CONTACT_US_REQUEST = 'CORE_LOAD_CONTACT_US_REQUEST';
var CORE_LOAD_CONTACT_US_SUCCESS = 'CORE_LOAD_CONTACT_US_SUCCESS';
var CORE_LOAD_CONTACT_US_FAILURE = 'CORE_LOAD_CONTACT_US_FAILURE';

var CORE_UPDATE_CONTACT_US_REQUEST = 'CORE_UPDATE_CONTACT_US_REQUEST';
var CORE_UPDATE_CONTACT_US_SUCCESS = 'CORE_UPDATE_CONTACT_US_SUCCESS';
var CORE_UPDATE_CONTACT_US_FAILURE = 'CORE_UPDATE_CONTACT_US_FAILURE';

var CORE_LOAD_REPORTROOMSTATUS_REQUEST = 'CORE_LOAD_REPORTROOMSTATUS_REQUEST';
var CORE_LOAD_REPORTROOMSTATUS_SUCCESS = 'CORE_LOAD_REPORTROOMSTATUS_SUCCESS';
var CORE_LOAD_REPORTROOMSTATUS_FAILURE = 'CORE_LOAD_REPORTROOMSTATUS_FAILURE';

var CORE_LOAD_ALL_CATEGORY_REQUEST = 'CORE_LOAD_ALL_CATEGORY_REQUEST';
var CORE_LOAD_ALL_CATEGORY_SUCCESS = 'CORE_LOAD_ALL_CATEGORY_SUCCESS';
var CORE_LOAD_ALL_CATEGORY_FAILURE = 'CORE_LOAD_ALL_CATEGORY_FAILURE';

var CORE_LOAD_ALLBUILDING_REQUEST = 'CORE_LOAD_ALLBUILDING_REQUEST';
var CORE_LOAD_ALLBUILDING_SUCCESS = 'CORE_LOAD_ALLBUILDING_SUCCESS';
var CORE_LOAD_ALLBUILDING_FAILURE = 'CORE_LOAD_ALLBUILDING_FAILURE';

var CORE_DELETE_BUILDING_REQUEST = 'CORE_DELETE_BUILDING_REQUEST';
var CORE_DELETE_BUILDING_SUCCESS = 'CORE_DELETE_BUILDING_SUCCESS';
var CORE_DELETE_BUILDING_FAILURE = 'CORE_DELETE_BUILDING_FAILURE';

var CORE_LOAD_BUILDINGINFO_REQUEST = 'CORE_LOAD_BUILDINGINFO_REQUEST';
var CORE_LOAD_BUILDINGINFO_SUCCESS = 'CORE_LOAD_BUILDINGINFO_SUCCESS';
var CORE_LOAD_BUILDINGINFO_FAILURE = 'CORE_LOAD_BUILDINGINFO_FAILURE';

var CORE_UPDATE_BUILDINGINFO_REQUEST = 'CORE_UPDATE_BUILDINGINFO_REQUEST';
var CORE_UPDATE_BUILDINGINFO_SUCCESS = 'CORE_UPDATE_BUILDINGINFO_SUCCESS';
var CORE_UPDATE_BUILDINGINFO_FAILURE = 'CORE_UPDATE_BUILDINGINFO_FAILURE';

var CORE_CREATE_BUILDING_REQUEST = 'CORE_CREATE_BUILDING_REQUEST';
var CORE_CREATE_BUILDING_SUCCESS = 'CORE_CREATE_BUILDING_SUCCESS';
var CORE_CREATE_BUILDING_FAILURE = 'CORE_CREATE_BUILDING_FAILURE';

var CORE_LOAD_ALLFLOOR_REQUEST = 'CORE_LOAD_ALLFLOOR_REQUEST';
var CORE_LOAD_ALLFLOOR_SUCCESS = 'CORE_LOAD_ALLFLOOR_SUCCESS';
var CORE_LOAD_ALLFLOOR_FAILURE = 'CORE_LOAD_ALLFLOOR_FAILURE';

var CORE_DELETE_FLOOR_REQUEST = 'CORE_DELETE_FLOOR_REQUEST';
var CORE_DELETE_FLOOR_SUCCESS = 'CORE_DELETE_FLOOR_SUCCESS';
var CORE_DELETE_FLOOR_FAILURE = 'CORE_DELETE_FLOOR_FAILURE';

var CORE_LOAD_FLOORINFO_REQUEST = 'CORE_LOAD_FLOORINFO_REQUEST';
var CORE_LOAD_FLOORINFO_SUCCESS = 'CORE_LOAD_FLOORINFO_SUCCESS';
var CORE_LOAD_FLOORINFO_FAILURE = 'CORE_LOAD_FLOORINFO_FAILURE';

var CORE_UPDATE_FLOORINFO_REQUEST = 'CORE_UPDATE_FLOORINFO_REQUEST';
var CORE_UPDATE_FLOORINFO_SUCCESS = 'CORE_UPDATE_FLOORINFO_SUCCESS';
var CORE_UPDATE_FLOORINFO_FAILURE = 'CORE_UPDATE_FLOORINFO_FAILURE';

var CORE_CREATE_FLOOR_REQUEST = 'CORE_CREATE_FLOOR_REQUEST';
var CORE_CREATE_FLOOR_SUCCESS = 'CORE_CREATE_FLOOR_SUCCESS';
var CORE_CREATE_FLOOR_FAILURE = 'CORE_CREATE_FLOOR_FAILURE';

var CORE_LOAD_ALLZONE_REQUEST = 'CORE_LOAD_ALLZONE_REQUEST';
var CORE_LOAD_ALLZONE_SUCCESS = 'CORE_LOAD_ALLZONE_SUCCESS';
var CORE_LOAD_ALLZONE_FAILURE = 'CORE_LOAD_ALLZONE_FAILURE';

var CORE_DELETE_ZONE_REQUEST = 'CORE_DELETE_ZONE_REQUEST';
var CORE_DELETE_ZONE_SUCCESS = 'CORE_DELETE_ZONE_SUCCESS';
var CORE_DELETE_ZONE_FAILURE = 'CORE_DELETE_ZONE_FAILURE';

var CORE_LOAD_ZONEINFO_REQUEST = 'CORE_LOAD_ZONEINFO_REQUEST';
var CORE_LOAD_ZONEINFO_SUCCESS = 'CORE_LOAD_ZONEINFO_SUCCESS';
var CORE_LOAD_ZONEINFO_FAILURE = 'CORE_LOAD_ZONEINFO_FAILURE';

var CORE_UPDATE_ZONEINFO_REQUEST = 'CORE_UPDATE_ZONEINFO_REQUEST';
var CORE_UPDATE_ZONEINFO_SUCCESS = 'CORE_UPDATE_ZONEINFO_SUCCESS';
var CORE_UPDATE_ZONEINFO_FAILURE = 'CORE_UPDATE_ZONEINFO_FAILURE';

var CORE_CREATE_ZONE_REQUEST = 'CORE_CREATE_ZONE_REQUEST';
var CORE_CREATE_ZONE_SUCCESS = 'CORE_CREATE_ZONE_SUCCESS';
var CORE_CREATE_ZONE_FAILURE = 'CORE_CREATE_ZONE_FAILURE';

var CORE_LOAD_ALLBACKGROUND_REQUEST = 'CORE_LOAD_ALLBACKGROUND_REQUEST';
var CORE_LOAD_ALLBACKGROUND_SUCCESS = 'CORE_LOAD_ALLBACKGROUND_SUCCESS';
var CORE_LOAD_ALLBACKGROUND_FAILURE = 'CORE_LOAD_ALLBACKGROUND_FAILURE';

var CORE_DELETE_BACKGROUND_REQUEST = 'CORE_DELETE_BACKGROUND_REQUEST';
var CORE_DELETE_BACKGROUND_SUCCESS = 'CORE_DELETE_BACKGROUND_SUCCESS';
var CORE_DELETE_BACKGROUND_FAILURE = 'CORE_DELETE_BACKGROUND_FAILURE';

var CORE_LOAD_BACKGROUNDINFO_REQUEST = 'CORE_LOAD_BACKGROUNDINFO_REQUEST';
var CORE_LOAD_BACKGROUNDINFO_SUCCESS = 'CORE_LOAD_BACKGROUNDINFO_SUCCESS';
var CORE_LOAD_BACKGROUNDINFO_FAILURE = 'CORE_LOAD_BACKGROUNDINFO_FAILURE';

var CORE_UPDATE_BACKGROUNDINFO_REQUEST = 'CORE_UPDATE_BACKGROUNDINFO_REQUEST';
var CORE_UPDATE_BACKGROUNDINFO_SUCCESS = 'CORE_UPDATE_BACKGROUNDINFO_SUCCESS';
var CORE_UPDATE_BACKGROUNDINFO_FAILURE = 'CORE_UPDATE_BACKGROUNDINFO_FAILURE';

var CORE_CREATE_BACKGROUND_REQUEST = 'CORE_CREATE_BACKGROUND_REQUEST';
var CORE_CREATE_BACKGROUND_SUCCESS = 'CORE_CREATE_BACKGROUND_SUCCESS';
var CORE_CREATE_BACKGROUND_FAILURE = 'CORE_CREATE_BACKGROUND_FAILURE';

var CORE_UPDATE_DEFAULTBACKGROUND_REQUEST = 'CORE_UPDATE_DEFAULTBACKGROUND_REQUEST';
var CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS = 'CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS';
var CORE_UPDATE_DEFAULTBACKGROUND_FAILURE = 'CORE_UPDATE_DEFAULTBACKGROUND_FAILURE';

var CORE_GET_CATEGORY_INFO_REQUEST = 'CORE_GET_CATEGORY_INFO_REQUEST';
var CORE_GET_CATEGORY_INFO_SUCCESS = 'CORE_GET_CATEGORY_INFO_SUCCESS';
var CORE_GET_CATEGORY_INFO_FAILURE = 'CORE_GET_CATEGORY_INFO_FAILURE';

var CORE_UPDATE_FB_CATEGORY_REQUEST = 'CORE_UPDATE_FB_CATEGORY_REQUEST';
var CORE_UPDATE_FB_CATEGORY_SUCCESS = 'CORE_UPDATE_FB_CATEGORY_SUCCESS';
var CORE_UPDATE_FB_CATEGORY_FAILURE = 'CORE_UPDATE_FB_CATEGORY_FAILURE';

var CORE_CREATE_FB_CATEGORY_REQUEST = 'CORE_CREATE_FB_CATEGORY_REQUEST';
var CORE_CREATE_FB_CATEGORY_SUCCESS = 'CORE_CREATE_FB_CATEGORY_SUCCESS';
var CORE_CREATE_FB_CATEGORY_FAILURE = 'CORE_CREATE_FB_CATEGORY_FAILURE';

var CORE_DELETE_FB_CATEGORY_REQUEST = 'CORE_DELETE_FB_CATEGORY_REQUEST';
var CORE_DELETE_FB_CATEGORY_SUCCESS = 'CORE_DELETE_FB_CATEGORY_SUCCESS';
var CORE_DELETE_FB_CATEGORY_FAILURE = 'CORE_DELETE_FB_CATEGORY_FAILURE';

var CORE_LOAD_ALL_USERSAD_REQUEST = 'CORE_LOAD_ALL_USERSAD_REQUEST';
var CORE_LOAD_ALL_USERSAD_SUCCESS = 'CORE_LOAD_ALL_USERSAD_SUCCESS';
var CORE_LOAD_ALL_USERSAD_FAILURE = 'CORE_LOAD_ALL_USERSAD_FAILURE';

var CORE_CHECK_AD_REQUEST = 'CORE_CHECK_AD_REQUEST';
var CORE_CHECK_AD_SUCCESS = 'CORE_CHECK_AD_SUCCESS';
var CORE_CHECK_AD_FAILURE = 'CORE_CHECK_AD_FAILURE';

var CORE_CHECK_TMS_REQUEST = 'CORE_CHECK_TMS_REQUEST';
var CORE_CHECK_TMS_SUCCESS = 'CORE_CHECK_TMS_SUCCESS';
var CORE_CHECK_TMS_FAILURE = 'CORE_CHECK_TMS_FAILURE';

var CORE_CHECK_CMR_REQUEST = 'CORE_CHECK_CMR_REQUEST';
var CORE_CHECK_CMR_SUCCESS = 'CORE_CHECK_CMR_SUCCESS';
var CORE_CHECK_CMR_FAILURE = 'CORE_CHECK_CMR_FAILURE';

var CORE_CHECK_BOT_REQUEST = 'CORE_CHECK_BOT_REQUEST';
var CORE_CHECK_BOT_SUCCESS = 'CORE_CHECK_BOT_SUCCESS';
var CORE_CHECK_BOT_FAILURE = 'CORE_CHECK_BOT_FAILURE';

var CORE_LOAD_TIMEZOZE_REQUEST = 'CORE_LOAD_TIMEZOZE_REQUEST';
var CORE_LOAD_TIMEZOZE_SUCCESS = 'CORE_LOAD_TIMEZOZE_SUCCESS';
var CORE_LOAD_TIMEZOZE_FAILURE = 'CORE_LOAD_TIMEZOZE_FAILURE';

var CORE_DELETE_IOT_REQUEST = 'CORE_DELETE_IOT_REQUEST';
var CORE_DELETE_IOT_SUCCESS = 'CORE_DELETE_IOT_SUCCESS';
var CORE_DELETE_IOT_FAILURE = 'CORE_DELETE_IOT_FAILURE';

var CORE_UPDATE_IOT_REQUEST = 'CORE_UPDATE_IOT_REQUEST';
var CORE_UPDATE_IOT_SUCCESS = 'CORE_UPDATE_IOT_SUCCESS';
var CORE_UPDATE_IOT_FAILURE = 'CORE_UPDATE_IOT_FAILURE';

var CORE_CREATE_IOT_REQUEST = 'CORE_CREATE_IOT_REQUEST';
var CORE_CREATE_IOT_SUCCESS = 'CORE_CREATE_IOT_SUCCESS';
var CORE_CREATE_IOT_FAILURE = 'CORE_CREATE_IOT_FAILURE';

var CORE_LOAD_IOT_REQUEST = 'CORE_LOAD_IOT_REQUEST';
var CORE_LOAD_IOT_SUCCESS = 'CORE_LOAD_IOT_SUCCESS';
var CORE_LOAD_IOT_FAILURE = 'CORE_LOAD_IOT_FAILURE';

var CORE_GET_IOT_INFO_REQUEST = 'CORE_GET_IOT_INFO_REQUEST';
var CORE_GET_IOT_INFO_SUCCESS = 'CORE_GET_IOT_INFO_SUCCESS';
var CORE_GET_IOT_INFO_FAILURE = 'CORE_GET_IOT_INFO_FAILURE';

var CORE_EDIT_GOOGLE_INTEGRATION_REQUEST = 'CORE_EDIT_GOOGLE_INTEGRATION_REQUEST';
var CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS = 'CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS';
var CORE_EDIT_GOOGLE_INTEGRATION_FAILURE = 'CORE_EDIT_GOOGLE_INTEGRATION_FAILURE';

var CORE_UPDATE_HOTSEAT_REQUEST = 'CORE_UPDATE_HOTSEAT_REQUEST';
var CORE_UPDATE_HOTSEAT_SUCCESS = 'CORE_UPDATE_HOTSEAT_SUCCESS';
var CORE_UPDATE_HOTSEAT_FAILURE = 'CORE_UPDATE_HOTSEAT_FAILURE';

var CORE_LOAD_ALLSEAT_REQUEST = 'CORE_LOAD_ALLSEAT_REQUEST';
var CORE_LOAD_ALLSEAT_SUCCESS = 'CORE_LOAD_ALLSEAT_SUCCESS';
var CORE_LOAD_ALLSEAT_FAILURE = 'CORE_LOAD_ALLSEAT_FAILURE';

var CORE_LOAD_SEAT_ZONE_INFO_REQUEST = 'CORE_LOAD_SEAT_ZONE_INFO_REQUEST';
var CORE_LOAD_SEAT_ZONE_INFO_SUCCESS = 'CORE_LOAD_SEAT_ZONE_INFO_SUCCESS';
var CORE_LOAD_SEAT_ZONE_INFO_FAILURE = 'CORE_LOAD_SEAT_ZONE_INFO_FAILURE';

var CORE_LOAD_SEAT_INFO_REQUEST = 'CORE_LOAD_SEAT_INFO_REQUEST';
var CORE_LOAD_SEAT_INFO_SUCCESS = 'CORE_LOAD_SEAT_INFO_SUCCESS';
var CORE_LOAD_SEAT_INFO_FAILURE = 'CORE_LOAD_SEAT_INFO_FAILURE';

var CORE_LOAD_ALLDISABLESEAT_REQUEST = 'CORE_LOAD_ALLDISABLESEAT_REQUEST';
var CORE_LOAD_ALLDISABLESEAT_SUCCESS = 'CORE_LOAD_ALLDISABLESEAT_SUCCESS';
var CORE_LOAD_ALLDISABLESEAT_FAILURE = 'CORE_LOAD_ALLDISABLESEAT_FAILURE';

var CORE_CREATE_DISABLEDSEAT_REQUEST = 'CORE_CREATE_DISABLEDSEAT_REQUEST';
var CORE_CREATE_DISABLEDSEAT_SUCCESS = 'CORE_CREATE_DISABLEDSEAT_SUCCESS';
var CORE_CREATE_DISABLEDSEAT_FAILURE = 'CORE_CREATE_DISABLEDSEAT_FAILURE';

var CORE_LOAD_DISABLESEATINFO_REQUEST = 'CORE_LOAD_DISABLESEATINFO_REQUEST';
var CORE_LOAD_DISABLESEATINFO_SUCCESS = 'CORE_LOAD_DISABLESEATINFO_SUCCESS';
var CORE_LOAD_DISABLESEATINFO_FAILURE = 'CORE_LOAD_DISABLESEATINFO_FAILURE';

var CORE_UPDATE_DISABLESEATINFO_REQUEST = 'CORE_UPDATE_DISABLESEATINFO_REQUEST';
var CORE_UPDATE_DISABLESEATINFO_SUCCESS = 'CORE_UPDATE_DISABLESEATINFO_SUCCESS';
var CORE_UPDATE_DISABLESEATINFO_FAILURE = 'CORE_UPDATE_DISABLESEATINFO_FAILURE';

var CORE_DELETE_DISABLESEATINFO_REQUEST = 'CORE_DELETE_DISABLESEATINFO_REQUEST';
var CORE_DELETE_DISABLESEATINFO_SUCCESS = 'CORE_DELETE_DISABLESEATINFO_SUCCESS';
var CORE_DELETE_DISABLESEATINFO_FAILURE = 'CORE_DELETE_DISABLESEATINFO_FAILURE';

var CORE_SEARCH_ROOMS_REQUEST = 'CORE_SEARCH_ROOMS_REQUEST';
var CORE_SEARCH_ROOMS_SUCCESS = 'CORE_SEARCH_ROOMS_SUCCESS';
var CORE_SEARCH_ROOMS_FAILURE = 'CORE_SEARCH_ROOMS_FAILURE';

var CORE_SEARCH_FLOOR_REQUEST = 'CORE_SEARCH_FLOOR_REQUEST';
var CORE_SEARCH_FLOOR_SUCCESS = 'CORE_SEARCH_FLOOR_SUCCESS';
var CORE_SEARCH_FLOOR_FAILURE = 'CORE_SEARCH_FLOOR_FAILURE';

var CORE_SEARCH_ZONE_REQUEST = 'CORE_SEARCH_ZONE_REQUEST';
var CORE_SEARCH_ZONE_SUCCESS = 'CORE_SEARCH_ZONE_SUCCESS';
var CORE_SEARCH_ZONE_FAILURE = 'CORE_SEARCH_ZONE_FAILURE';

var CORE_SEARCH_IOT_REQUEST = 'CORE_SEARCH_IOT_REQUEST';
var CORE_SEARCH_IOT_SUCCESS = 'CORE_SEARCH_IOT_SUCCESS';
var CORE_SEARCH_IOT_FAILURE = 'CORE_SEARCH_IOT_FAILURE';

var CORE_SEARCH_USERS_REQUEST = 'CORE_SEARCH_USERS_REQUEST';
var CORE_SEARCH_USERS_SUCCESS = 'CORE_SEARCH_USERS_SUCCESS';
var CORE_SEARCH_USERS_FAILURE = 'CORE_SEARCH_USERS_FAILURE';

var CORE_SEARCH_FBS_REQUEST = 'CORE_SEARCH_FBS_REQUEST';
var CORE_SEARCH_FBS_SUCCESS = 'CORE_SEARCH_FBS_SUCCESS';
var CORE_SEARCH_FBS_FAILURE = 'CORE_SEARCH_FBS_FAILURE';

var CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST';
var CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS';
var CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE';

var CORE_CHECKOUT_REQUEST = 'CORE_CHECKOUT_REQUEST';
var CORE_CHECKOUT_SUCCESS = 'CORE_CHECKOUT_SUCCESS';
var CORE_CHECKOUT_FAILURE = 'CORE_CHECKOUT_FAILURE';

var CORE_DELETE_EVENT_REQUEST = 'CORE_DELETE_EVENT_REQUEST';
var CORE_DELETE_EVENT_SUCCESS = 'CORE_DELETE_EVENT_SUCCESS';
var CORE_DELETE_EVENT_FAILURE = 'CORE_DELETE_EVENT_FAILURE';

var CORE_RESET_PASSWORD_REQUEST = 'CORE_RESET_PASSWORD_REQUEST';
var CORE_RESET_PASSWORD_SUCCESS = 'CORE_RESET_PASSWORD_SUCCESS';
var CORE_RESET_PASSWORD_FAILURE = 'CORE_RESET_PASSWORD_FAILURE';

var CORE_LOAD_IOT_ROOMREGIS_REQUEST = 'CORE_LOAD_IOT_ROOMREGIS_REQUEST';
var CORE_LOAD_IOT_ROOMREGIS_SUCCESS = 'CORE_LOAD_IOT_ROOMREGIS_SUCCESS';
var CORE_LOAD_IOT_ROOMREGIS_FAILURE = 'CORE_LOAD_IOT_ROOMREGIS_FAILURE';

var CORE_GET_IOT_ROOMREGIS_INFO_REQUEST = 'CORE_GET_IOT_ROOMREGIS_INFO_REQUEST';
var CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS = 'CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS';
var CORE_GET_IOT_ROOMREGIS_INFO_FAILURE = 'CORE_GET_IOT_ROOMREGIS_INFO_FAILURE';

var CORE_CREATE_IOT_ROOMREGIS_REQUEST = 'CORE_CREATE_IOT_ROOMREGIS_REQUEST';
var CORE_CREATE_IOT_ROOMREGIS_SUCCESS = 'CORE_CREATE_IOT_ROOMREGIS_SUCCESS';
var CORE_CREATE_IOT_ROOMREGIS_FAILURE = 'CORE_CREATE_IOT_ROOMREGIS_FAILURE';

var CORE_DELETE_IOT_ROOMREGIS_REQUEST = 'CORE_DELETE_IOT_ROOMREGIS_REQUEST';
var CORE_DELETE_IOT_ROOMREGIS_SUCCESS = 'CORE_DELETE_IOT_ROOMREGIS_SUCCESS';
var CORE_DELETE_IOT_ROOMREGIS_FAILURE = 'CORE_DELETE_IOT_ROOMREGIS_FAILURE';

var CORE_LOAD_DISPLAY_REQUEST = 'CORE_LOAD_DISPLAY_REQUEST';
var CORE_LOAD_DISPLAY_SUCCESS = 'CORE_LOAD_DISPLAY_SUCCESS';
var CORE_LOAD_DISPLAY_FAILURE = 'CORE_LOAD_DISPLAY_FAILURE';

var CORE_GET_DISPLAY_INFO_REQUEST = 'CORE_GET_DISPLAY_INFO_REQUEST';
var CORE_GET_DISPLAY_INFO_SUCCESS = 'CORE_GET_DISPLAY_INFO_SUCCESS';
var CORE_GET_DISPLAY_INFO_FAILURE = 'CORE_GET_DISPLAY_INFO_FAILURE';

var CORE_CREATE_DISPLAY_REQUEST = 'CORE_CREATE_DISPLAY_REQUEST';
var CORE_CREATE_DISPLAY_SUCCESS = 'CORE_CREATE_DISPLAY_SUCCESS';
var CORE_CREATE_DISPLAY_FAILURE = 'CORE_CREATE_DISPLAY_FAILURE';

var CORE_DELETE_DISPLAY_REQUEST = 'CORE_DELETE_DISPLAY_REQUEST';
var CORE_DELETE_DISPLAY_SUCCESS = 'CORE_DELETE_DISPLAY_SUCCESS';
var CORE_DELETE_DISPLAY_FAILURE = 'CORE_DELETE_DISPLAY_FAILURE';

var CORE_UPDATE_DISPLAY_REQUEST = 'CORE_UPDATE_DISPLAY_REQUEST';
var CORE_UPDATE_DISPLAY_SUCCESS = 'CORE_UPDATE_DISPLAY_SUCCESS';
var CORE_UPDATE_DISPLAY_FAILURE = 'CORE_UPDATE_DISPLAY_FAILURE';

var PROFILE_CENTER_LOAD_INFO_REQUEST = 'PROFILE_CENTER_LOAD_INFO_REQUEST';
var PROFILE_CENTER_LOAD_INFO_SUCCESS = 'PROFILE_CENTER_LOAD_INFO_SUCCESS';
var PROFILE_CENTER_LOAD_INFO_FAILURE = 'PROFILE_CENTER_LOAD_INFO_FAILURE';

var PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST';
var PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS';
var PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE';

var PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST';
var PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS';
var PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE';

var CORE_LOAD_ALL_ROOMDISABLE_REQUEST = 'CORE_LOAD_ALL_ROOMDISABLE_REQUEST';
var CORE_LOAD_ALL_ROOMDISABLE_SUCCESS = 'CORE_LOAD_ALL_ROOMDISABLE_SUCCESS';
var CORE_LOAD_ALL_ROOMDISABLE_FAILURE = 'CORE_LOAD_ALL_ROOMDISABLE_FAILURE';

var CORE_LOAD_ROOMDISABLE_REQUEST = 'CORE_LOAD_ROOMDISABLE_REQUEST';
var CORE_LOAD_ROOMDISABLE_SUCCESS = 'CORE_LOAD_ROOMDISABLE_SUCCESS';
var CORE_LOAD_ROOMDISABLE_FAILURE = 'CORE_LOAD_ROOMDISABLE_FAILURE';

var CORE_CREATE_ROOMDISABLE_REQUEST = 'CORE_CREATE_ROOMDISABLE_REQUEST';
var CORE_CREATE_ROOMDISABLE_SUCCESS = 'CORE_CREATE_ROOMDISABLE_SUCCESS';
var CORE_CREATE_ROOMDISABLE_FAILURE = 'CORE_CREATE_ROOMDISABLE_FAILURE';

var CORE_UPDATE_ROOMDISABLE_REQUEST = 'CORE_UPDATE_ROOMDISABLE_REQUEST';
var CORE_UPDATE_ROOMDISABLE_SUCCESS = 'CORE_UPDATE_ROOMDISABLE_SUCCESS';
var CORE_UPDATE_ROOMDISABLE_FAILURE = 'CORE_UPDATE_ROOMDISABLE_FAILURE';

var CORE_DELETE_ROOMDISABLE_REQUEST = 'CORE_DELETE_ROOMDISABLE_REQUEST';
var CORE_DELETE_ROOMDISABLE_SUCCESS = 'CORE_DELETE_ROOMDISABLE_SUCCESS';
var CORE_DELETE_ROOMDISABLE_FAILURE = 'CORE_DELETE_ROOMDISABLE_FAILURE';

var CORE_LOAD_VC_LIST_REQUEST = 'CORE_LOAD_VC_LIST_REQUEST';
var CORE_LOAD_VC_LIST_SUCCESS = 'CORE_LOAD_VC_LIST_SUCCESS';
var CORE_LOAD_VC_LIST_FAILURE = 'CORE_LOAD_VC_LIST_FAILURE';

var CORE_LOAD_CONCURRENT_REQUEST = 'CORE_LOAD_CONCURRENT_REQUEST';
var CORE_LOAD_CONCURRENT_SUCCESS = 'CORE_LOAD_CONCURRENT_SUCCESS';
var CORE_LOAD_CONCURRENT_FAILURE = 'CORE_LOAD_CONCURRENT_FAILURE';

var CORE_DELETE_CONCURRENT_REQUEST = 'CORE_DELETE_CONCURRENT_REQUEST';
var CORE_DELETE_CONCURRENT_SUCCESS = 'CORE_DELETE_CONCURRENT_SUCCESS';
var CORE_DELETE_CONCURRENT_FAILURE = 'CORE_DELETE_CONCURRENT_FAILURE';

var CORE_LOAD_ROLES_REQUEST = 'CORE_LOAD_ROLES_REQUEST';
var CORE_LOAD_ROLES_SUCCESS = 'CORE_LOAD_ROLES_SUCCESS';
var CORE_LOAD_ROLES_FAILURE = 'CORE_LOAD_ROLES_FAILURE';

var CORE_CREATE_ROLE_REQUEST = 'CORE_CREATE_ROLE_REQUEST';
var CORE_CREATE_ROLE_SUCCESS = 'CORE_CREATE_ROLE_SUCCESS';
var CORE_CREATE_ROLE_FAILURE = 'CORE_CREATE_ROLE_FAILURE';

var CORE_LOAD_ROLE_INFO_REQUEST = 'CORE_LOAD_ROLE_INFO_REQUEST';
var CORE_LOAD_ROLE_INFO_SUCCESS = 'CORE_LOAD_ROLE_INFO_SUCCESS';
var CORE_LOAD_ROLE_INFO_FAILURE = 'CORE_LOAD_ROLE_INFO_FAILURE';

var CORE_UPDATE_ROLE_REQUEST = 'CORE_UPDATE_ROLE_REQUEST';
var CORE_UPDATE_ROLE_SUCCESS = 'CORE_UPDATE_ROLE_SUCCESS';
var CORE_UPDATE_ROLE_FAILURE = 'CORE_UPDATE_ROLE_FAILURE';

var CORE_DELETE_ROLE_REQUEST = 'CORE_DELETE_ROLE_REQUEST';
var CORE_DELETE_ROLE_SUCCESS = 'CORE_DELETE_ROLE_SUCCESS';
var CORE_DELETE_ROLE_FAILURE = 'CORE_DELETE_ROLE_FAILURE';

var CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST';
var CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS';
var CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE';

var CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST = 'CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST';
var CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS';
var CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE = 'CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE';

var CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST';
var CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS';
var CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE';

var CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST';
var CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS';
var CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE';

var CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST = 'CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST';
var CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS';
var CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE = 'CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE';

var CORE_LOAD_ORDER_FBS_REQUEST = 'CORE_LOAD_ORDER_FBS_REQUEST';
var CORE_LOAD_ORDER_FBS_SUCCESS = 'CORE_LOAD_ORDER_FBS_SUCCESS';
var CORE_LOAD_ORDER_FBS_FAILURE = 'CORE_LOAD_ORDER_FBS_FAILURE';

var CORE_DELETE_ORDER_FBS_REQUEST = 'CORE_DELETE_ORDER_FBS_REQUEST';
var CORE_DELETE_ORDER_FBS_SUCCESS = 'CORE_DELETE_ORDER_FBS_SUCCESS';
var CORE_DELETE_ORDER_FBS_FAILURE = 'CORE_DELETE_ORDER_FBS_FAILURE';

var CORE_LOAD_ORDER_FBS_INFO_REQUEST = 'CORE_LOAD_ORDER_FBS_INFO_REQUEST';
var CORE_LOAD_ORDER_FBS_INFO_SUCCESS = 'CORE_LOAD_ORDER_FBS_INFO_SUCCESS';
var CORE_LOAD_ORDER_FBS_INFO_FAILURE = 'CORE_LOAD_ORDER_FBS_INFO_FAILURE';

var CORE_UPDATE_ORDER_FBS_INFO_REQUEST = 'CORE_UPDATE_ORDER_FBS_INFO_REQUEST';
var CORE_UPDATE_ORDER_FBS_INFO_SUCCESS = 'CORE_UPDATE_ORDER_FBS_INFO_SUCCESS';
var CORE_UPDATE_ORDER_FBS_INFO_FAILURE = 'CORE_UPDATE_ORDER_FBS_INFO_FAILURE';

var CORE_CREATE_ORDER_FBS_REQUEST = 'CORE_CREATE_ORDER_FBS_REQUEST';
var CORE_CREATE_ORDER_FBS_SUCCESS = 'CORE_CREATE_ORDER_FBS_SUCCESS';
var CORE_CREATE_ORDER_FBS_FAILURE = 'CORE_CREATE_ORDER_FBS_FAILURE';

var CORE_LOAD_ORDER_AMENITY_REQUEST = 'CORE_LOAD_ORDER_AMENITY_REQUEST';
var CORE_LOAD_ORDER_AMENITY_SUCCESS = 'CORE_LOAD_ORDER_AMENITY_SUCCESS';
var CORE_LOAD_ORDER_AMENITY_FAILURE = 'CORE_LOAD_ORDER_AMENITY_FAILURE';

var CORE_DELETE_ORDER_AMENITY_REQUEST = 'CORE_DELETE_ORDER_AMENITY_REQUEST';
var CORE_DELETE_ORDER_AMENITY_SUCCESS = 'CORE_DELETE_ORDER_AMENITY_SUCCESS';
var CORE_DELETE_ORDER_AMENITY_FAILURE = 'CORE_DELETE_ORDER_AMENITY_FAILURE';

var CORE_LOAD_ORDER_AMENITY_INFO_REQUEST = 'CORE_LOAD_ORDER_AMENITY_INFO_REQUEST';
var CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS = 'CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS';
var CORE_LOAD_ORDER_AMENITY_INFO_FAILURE = 'CORE_LOAD_ORDER_AMENITY_INFO_FAILURE';

var CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST = 'CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST';
var CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS = 'CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS';
var CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE = 'CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE';

var O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST = 'O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST';
var O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS = 'O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS';
var O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE = 'O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE';

var CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST = 'CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST';
var CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS = 'CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS';
var CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE = 'CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE';

var CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST';
var CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS';
var CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE';

var CORE_LOAD_EVENTTYPE_REQUEST = 'CORE_LOAD_EVENTTYPE_REQUEST';
var CORE_LOAD_EVENTTYPE_SUCCESS = 'CORE_LOAD_EVENTTYPE_SUCCESS';
var CORE_LOAD_EVENTTYPE_FAILURE = 'CORE_LOAD_EVENTTYPE_FAILURE';

var CORE_LOAD_EVENTTYPE_INFO_REQUEST = 'CORE_LOAD_EVENTTYPE_INFO_REQUEST';
var CORE_LOAD_EVENTTYPE_INFO_SUCCESS = 'CORE_LOAD_EVENTTYPE_INFO_SUCCESS';
var CORE_LOAD_EVENTTYPE_INFO_FAILURE = 'CORE_LOAD_EVENTTYPE_INFO_FAILURE';

var CORE_CREATE_EVENTTYPE_REQUEST = 'CORE_CREATE_EVENTTYPE_REQUEST';
var CORE_CREATE_EVENTTYPE_SUCCESS = 'CORE_CREATE_EVENTTYPE_SUCCESS';
var CORE_CREATE_EVENTTYPE_FAILURE = 'CORE_CREATE_EVENTTYPE_FAILURE';

var CORE_UPDATE_EVENTTYPE_REQUEST = 'CORE_UPDATE_EVENTTYPE_REQUEST';
var CORE_UPDATE_EVENTTYPE_SUCCESS = 'CORE_UPDATE_EVENTTYPE_SUCCESS';
var CORE_UPDATE_EVENTTYPE_FAILURE = 'CORE_UPDATE_EVENTTYPE_FAILURE';

var CORE_DELETE_EVENTTYPE_REQUEST = 'CORE_DELETE_EVENTTYPE_REQUEST';
var CORE_DELETE_EVENTTYPE_SUCCESS = 'CORE_DELETE_EVENTTYPE_SUCCESS';
var CORE_DELETE_EVENTTYPE_FAILURE = 'CORE_DELETE_EVENTTYPE_FAILURE';

var CORE_UNREGISTER_DISPLAY_REQUEST = 'CORE_UNREGISTER_DISPLAY_REQUEST';
var CORE_UNREGISTER_DISPLAY_SUCCESS = 'CORE_UNREGISTER_DISPLAY_SUCCESS';
var CORE_UNREGISTER_DISPLAY_FAILURE = 'CORE_UNREGISTER_DISPLAY_FAILURE';

var CORE_UNREGISTER_PROFILE_REQUEST = 'CORE_UNREGISTER_PROFILE_REQUEST';
var CORE_UNREGISTER_PROFILE_SUCCESS = 'CORE_UNREGISTER_PROFILE_SUCCESS';
var CORE_UNREGISTER_PROFILE_FAILURE = 'CORE_UNREGISTER_PROFILE_FAILURE';

var CORE_UNREGISTER_IOT_REQUEST = 'CORE_UNREGISTER_IOT_REQUEST';
var CORE_UNREGISTER_IOT_SUCCESS = 'CORE_UNREGISTER_IOT_SUCCESS';
var CORE_UNREGISTER_IOT_FAILURE = 'CORE_UNREGISTER_IOT_FAILURE';

var CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST = 'CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST';
var CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS = 'CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS';
var CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE = 'CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE';

var CORE_IMPORT_USER_O365_REQUEST = 'CORE_IMPORT_USER_O365_REQUEST';
var CORE_IMPORT_USER_O365_SUCCESS = 'CORE_IMPORT_USER_O365_SUCCESS';
var CORE_IMPORT_USER_O365_FAILURE = 'CORE_IMPORT_USER_O365_FAILURE';

var CORE_SYNC_ROLE_REQUEST = 'CORE_SYNC_ROLE_REQUEST';
var CORE_SYNC_ROLE_SUCCESS = 'CORE_SYNC_ROLE_SUCCESS';
var CORE_SYNC_ROLE_FAILURE = 'CORE_SYNC_ROLE_FAILURE';

var CORE_LOAD_IOT_MODULE_REQUEST = 'CORE_LOAD_IOT_MODULE_REQUEST';
var CORE_LOAD_IOT_MODULE_SUCCESS = 'CORE_LOAD_IOT_MODULE_SUCCESS';
var CORE_LOAD_IOT_MODULE_FAILURE = 'CORE_LOAD_IOT_MODULE_FAILURE';

var CORE_CREATE_IOT_MODULE_REQUEST = 'CORE_CREATE_IOT_MODULE_REQUEST';
var CORE_CREATE_IOT_MODULE_SUCCESS = 'CORE_CREATE_IOT_MODULE_SUCCESS';
var CORE_CREATE_IOT_MODULE_FAILURE = 'CORE_CREATE_IOT_MODULE_FAILURE';

var CORE_LOAD_IOTINFO_REQUEST = 'CORE_LOAD_IOTINFO_REQUEST';
var CORE_LOAD_IOTINFO_SUCCESS = 'CORE_LOAD_IOTINFO_SUCCESS';
var CORE_LOAD_IOTINFO_FAILURE = 'CORE_LOAD_IOTINFO_FAILURE';

var CORE_UPDATE_IOTINFO_REQUEST = 'CORE_UPDATE_IOTINFO_REQUEST';
var CORE_UPDATE_IOTINFO_SUCCESS = 'CORE_UPDATE_IOTINFO_SUCCESS';
var CORE_UPDATE_IOTINFO_FAILURE = 'CORE_UPDATE_IOTINFO_FAILURE';

var CORE_GET_IOT_INFO_WITH_MODULE_REQUEST = 'CORE_GET_IOT_INFO_WITH_MODULE_REQUEST';
var CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS = 'CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS';
var CORE_GET_IOT_INFO_WITH_MODULE_FAILURE = 'CORE_GET_IOT_INFO_WITH_MODULE_FAILURE';

var CORE_GET_ALL_IOT_MODULE_REQUEST = 'CORE_GET_ALL_IOT_MODULE_REQUEST';
var CORE_GET_ALL_IOT_MODULE_SUCCESS = 'CORE_GET_ALL_IOT_MODULE_SUCCESS';
var CORE_GET_ALL_IOT_MODULE_FAILURE = 'CORE_GET_ALL_IOT_MODULE_FAILURE';

var CORE_UPDATE_IOT_DATA_REQUEST = 'CORE_UPDATE_IOT_DATA_REQUEST';
var CORE_UPDATE_IOT_DATA_SUCCESS = 'CORE_UPDATE_IOT_DATA_SUCCESS';
var CORE_UPDATE_IOT_DATA_FAILURE = 'CORE_UPDATE_IOT_DATA_FAILURE';

var CORE_LOAD_ALL_TEMPORARY_CLOSE_REQUEST = 'CORE_LOAD_ALL_TEMPORARY_CLOSE_REQUEST';
var CORE_LOAD_ALL_TEMPORARY_CLOSE_SUCCESS = 'CORE_LOAD_ALL_TEMPORARY_CLOSE_SUCCESS';
var CORE_LOAD_ALL_TEMPORARY_CLOSE_FAILURE = 'CORE_LOAD_ALL_TEMPORARY_CLOSE_FAILURE';

var CORE_CREATE_TEMP_CLOSE_REQUEST = 'CORE_CREATE_TEMP_CLOSE_REQUEST';
var CORE_CREATE_TEMP_CLOSE_SUCCESS = 'CORE_CREATE_TEMP_CLOSE_SUCCESS';
var CORE_CREATE_TEMP_CLOSE_FAILURE = 'CORE_CREATE_TEMP_CLOSE_FAILURE';

var CORE_DELETE_TEMP_CLOSE_REQUEST = 'CORE_DELETE_TEMP_CLOSE_REQUEST';
var CORE_DELETE_TEMP_CLOSE_SUCCESS = 'CORE_DELETE_TEMP_CLOSE_SUCCESS';
var CORE_DELETE_TEMP_CLOSE_FAILURE = 'CORE_DELETE_TEMP_CLOSE_FAILURE';

var CORE_LOAD_TEMPORARY_CLOSE_REQUEST = 'CORE_LOAD_TEMPORARY_CLOSE_REQUEST';
var CORE_LOAD_TEMPORARY_CLOSE_SUCCESS = 'CORE_LOAD_TEMPORARY_CLOSE_SUCCESS';
var CORE_LOAD_TEMPORARY_CLOSE_FAILURE = 'CORE_LOAD_TEMPORARY_CLOSE_FAILURE';

var CORE_UPDATE_TEMP_CLOSE_REQUEST = 'CORE_UPDATE_TEMP_CLOSE_REQUEST';
var CORE_UPDATE_TEMP_CLOSE_SUCCESS = 'CORE_UPDATE_TEMP_CLOSE_SUCCESS';
var CORE_UPDATE_TEMP_CLOSE_FAILURE = 'CORE_UPDATE_TEMP_CLOSE_FAILURE';

var CORE_LOAD_ALL_AVAILABLE_TIMESLOT_REQUEST = 'CORE_LOAD_ALL_AVAILABLE_TIMESLOT_REQUEST';
var CORE_LOAD_ALL_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_LOAD_ALL_AVAILABLE_TIMESLOT_SUCCESS';
var CORE_LOAD_ALL_AVAILABLE_TIMESLOT_FAILURE = 'CORE_LOAD_ALL_AVAILABLE_TIMESLOT_FAILURE';

var CORE_LOAD_AVAILABLE_TIMESLOT_REQUEST = 'CORE_LOAD_AVAILABLE_TIMESLOT_REQUEST';
var CORE_LOAD_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_LOAD_AVAILABLE_TIMESLOT_SUCCESS';
var CORE_LOAD_AVAILABLE_TIMESLOT_FAILURE = 'CORE_LOAD_AVAILABLE_TIMESLOT_FAILURE';

var CORE_CREATE_AVAILABLE_TIMESLOT_REQUEST = 'CORE_CREATE_AVAILABLE_TIMESLOT_REQUEST';
var CORE_CREATE_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_CREATE_AVAILABLE_TIMESLOT_SUCCESS';
var CORE_CREATE_AVAILABLE_TIMESLOT_FAILURE = 'CORE_CREATE_AVAILABLE_TIMESLOT_FAILURE';

var CORE_UPDATE_AVAILABLE_TIMESLOT_REQUEST = 'CORE_UPDATE_AVAILABLE_TIMESLOT_REQUEST';
var CORE_UPDATE_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_UPDATE_AVAILABLE_TIMESLOT_SUCCESS';
var CORE_UPDATE_AVAILABLE_TIMESLOT_FAILURE = 'CORE_UPDATE_AVAILABLE_TIMESLOT_FAILURE';

var CORE_DELETE_AVAILABLE_TIMESLOT_REQUEST = 'CORE_DELETE_AVAILABLE_TIMESLOT_REQUEST';
var CORE_DELETE_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_DELETE_AVAILABLE_TIMESLOT_SUCCESS';
var CORE_DELETE_AVAILABLE_TIMESLOT_FAILURE = 'CORE_DELETE_AVAILABLE_TIMESLOT_FAILURE';

var CORE_CREATE_HOTDESK_ROLE_REQUEST = 'CORE_CREATE_HOTDESK_ROLE_REQUEST';
var CORE_CREATE_HOTDESK_ROLE_SUCCESS = 'CORE_CREATE_HOTDESK_ROLE_SUCCESS';
var CORE_CREATE_HOTDESK_ROLE_FAILURE = 'CORE_CREATE_HOTDESK_ROLE_FAILURE';

var CORE_UPDATE_HOTDESK_ROLE_REQUEST = 'CORE_UPDATE_HOTDESK_ROLE_REQUEST';
var CORE_UPDATE_HOTDESK_ROLE_SUCCESS = 'CORE_UPDATE_HOTDESK_ROLE_SUCCESS';
var CORE_UPDATE_HOTDESK_ROLE_FAILURE = 'CORE_UPDATE_HOTDESK_ROLE_FAILURE';

var CORE_DELETE_HOTDESK_ROLE_REQUEST = 'CORE_DELETE_HOTDESK_ROLE_REQUEST';
var CORE_DELETE_HOTDESK_ROLE_SUCCESS = 'CORE_DELETE_HOTDESK_ROLE_SUCCESS';
var CORE_DELETE_HOTDESK_ROLE_FAILURE = 'CORE_DELETE_HOTDESK_ROLE_FAILURE';

var CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST = 'CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST';
var CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS = 'CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS';
var CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE = 'CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE';

var CORE_LOAD_HOTDESK_ROLE_REQUEST = 'CORE_LOAD_HOTDESK_ROLE_REQUEST';
var CORE_LOAD_HOTDESK_ROLE_SUCCESS = 'CORE_LOAD_HOTDESK_ROLE_SUCCESS';
var CORE_LOAD_HOTDESK_ROLE_FAILURE = 'CORE_LOAD_HOTDESK_ROLE_FAILURE';

var CORE_LOAD_ALL_CONTROL_REQUEST = 'CORE_LOAD_ALL_CONTROL_REQUEST';
var CORE_LOAD_ALL_CONTROL_SUCCESS = 'CORE_LOAD_ALL_CONTROL_SUCCESS';
var CORE_LOAD_ALL_CONTROL_FAILURE = 'CORE_LOAD_ALL_CONTROL_FAILURE';

var CORE_LOAD_ALL_IOT_ROOMINFO_REQUEST = 'CORE_LOAD_ALL_IOT_ROOMINFO_REQUEST';
var CORE_LOAD_ALL_IOT_ROOMINFO_SUCCESS = 'CORE_LOAD_ALL_IOT_ROOMINFO_SUCCESS';
var CORE_LOAD_ALL_IOT_ROOMINFO_FAILURE = 'CORE_LOAD_ALL_IOT_ROOMINFO_FAILURE';

var CORE_UPDATE_DOUT_REQUEST = 'CORE_UPDATE_DOUT_REQUEST';
var CORE_UPDATE_DOUT_SUCCESS = 'CORE_UPDATE_DOUT_SUCCESS';
var CORE_UPDATE_DOUT_FAILURE = 'CORE_UPDATE_DOUT_FAILURE';

var CORE_UPDATE_DALI_REQUEST = 'CORE_UPDATE_DALI_REQUEST';
var CORE_UPDATE_DALI_SUCCESS = 'CORE_UPDATE_DALI_SUCCESS';
var CORE_UPDATE_DALI_FAILURE = 'CORE_UPDATE_DALI_FAILURE';

var CORE_UPDATE_DMX_REQUEST = 'CORE_UPDATE_DMX_REQUEST';
var CORE_UPDATE_DMX_SUCCESS = 'CORE_UPDATE_DMX_SUCCESS';
var CORE_UPDATE_DMX_FAILURE = 'CORE_UPDATE_DMX_FAILURE';

var CORE_GET_ALL_LOCATION_INFO_REQUEST = 'CORE_GET_ALL_LOCATION_INFO_REQUEST';
var CORE_GET_ALL_LOCATION_INFO_SUCCESS = 'CORE_GET_ALL_LOCATION_INFO_SUCCESS';
var CORE_GET_ALL_LOCATION_INFO_FAILURE = 'CORE_GET_ALL_LOCATION_INFO_FAILURE';
var CORE_LOAD_ALL_AD_LIST_REQUEST = 'CORE_LOAD_ALL_AD_LIST_REQUEST';
var CORE_LOAD_ALL_AD_LIST_SUCCESS = 'CORE_LOAD_ALL_AD_LIST_SUCCESS';
var CORE_LOAD_ALL_AD_LIST_FAILURE = 'CORE_LOAD_ALL_AD_LIST_FAILURE';

var CORE_IMPORT_USER_AD_REQUEST = 'CORE_IMPORT_USER_AD_REQUEST';
var CORE_IMPORT_USER_AD_SUCCESS = 'CORE_IMPORT_USER_AD_SUCCESS';
var CORE_IMPORT_USER_AD_FAILURE = 'CORE_IMPORT_USER_AD_FAILURE';

var CORE_SYNC_365_USERS_REQUEST = 'CORE_SYNC_365_USERS_REQUEST';
var CORE_SYNC_365_USERS_SUCCESS = 'CORE_SYNC_365_USERS_SUCCESS';
var CORE_SYNC_365_USERS_FAILURE = 'CORE_SYNC_365_USERS_FAILURE';

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIsLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLoggedInO365;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUserInfo;
/* unused harmony export getUserEmail */
function getIsLoggedIn(state) {
    return !!state.auth.bsrsToken;
}

function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token;
}

function getUserInfo(state) {
    return state.auth.user;
}

function getUserEmail(state) {
    return state.auth.user.email;
}

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 413, 500];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(function (json) {
					var message = "";
					for (var key in json) {
						if (json.hasOwnProperty(key)) {
							var element = json[key];
							for (var k in element) {
								if (element.hasOwnProperty(k)) {
									var ele = element[k];
									message += "" + ele.msg;
									if (ele.param) message += "Param : " + ele.param + " ";
									message += "\n";
								}
							}
						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					});
				});
			} else if (res.status === 404) {
				return reject({
					statusText: 404, data: {
						code: "404",
						message: "404 (Not Found)"
					}
				});
			} else {
				return res.json().then(function (data) {
					return reject({ statusText: res.statusText, data: data });
				});
			}
		}

		if ((typeof type === "undefined" ? "undefined" : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);
				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);
			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();

			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					callBack(action);
					next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, errorData: err.data });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, errorData: err.data });
				});
			}
		};
	};
});
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(519);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(39);

// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];
            var currentTime = moment_timezone_default()().format(lib["Z" /* timeFormat */]);

            var expires = Object(lib["B" /* getExpiresToken */])();

            var duration = moment_timezone_default.a.duration(moment_timezone_default.a.unix(expires).diff(currentTime));
            var minutes = duration.asMinutes();

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);
            if (minutes < 15 && minutes > 0) {
                fetch(lib["b" /* CORE_API_ENDPOINT */] + '/user/newtoken', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'id': Object(lib["L" /* getUserId */])()
                    })
                }).then(function (res) {
                    return res.json();
                }).then(function (json) {
                    return Object(lib["U" /* setRefreshToken */])(json);
                }).then(function () {
                    return next(action);
                });
            } else if (minutes <= 0) {
                if (window.location.pathname !== "/sessionExpire") window.location.replace('/sessionExpire');
            } else {
                next(action);
            }
            // }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = void 0;
            var entryType = entry.types[0];
            if (entryType.startsWith("CORE") || entryType.startsWith("O365")) {
                token = Object(lib["x" /* getBSRSToken */])();
            }
            // else if (entryType.startsWith("O365")) {
            //   const { service_token } = getServiceToken()
            //   token = service_token
            // }

            // if(entryType.startsWith("CORE")){
            //   token = getBSRSToken()
            // }else if(entry.types[0].startsWith("O365")){ 
            //   if(typeof(entry.tokentype) !== undefined && entry.tokentype === 'service' ){ 
            //     const { service_token } = getServiceToken()
            //     token = service_token
            //   }
            //   else token = getAccessToken()
            // }

            if (!token) return next(action);

            // entry.headers = {
            //     ...entry.headers,
            //     "Authorization": `Bearer ${token}`
            // }
            entry.headers = _extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
                entry.headers["Access-Control-Allow-Origin"] = "*";
                entry.headers["Access-Control-Allow-Methods"] = "DELETE, POST, GET, OPTIONS";
                entry.headers["Access-Control-Allow-Headers"] = "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With";
            }

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(494);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(523);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__(524);
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// CONCATENATED MODULE: ./src/lib/auth.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var BSRS_ACCESS_TOKEN = 'bsrs_access_token';
var ACCESS_TOKEN = 'access_token';
var EXPIRES_ON = 'expires_on';
var REFRESH_TOKEN = 'refresh_token';
var SERVICE_TOKEN = 'service_token';
var ROOM = 'room';
var API_URL = 'api_server_url';
var CLIENT_ID = 'client_id';
var SERVICE_TOKEN_EXPIRES = 'service_token_expires_on';
var IS_INTEGRATION = 'isIntegration';
var USER_ID = 'id';
var LIMIT_USERS = 'limitUser';
var FIRST_NAME = 'firstName';
var EMAIL = 'email';
var IS_USER_AD = 'isUserActiveDirectory';
var SYSTEM = 'system';
var COMPANY_CODE = 'companyCode';
var IS_REMEMBER = 'isRemember';
var IS_ENABLE_IOT_MODULE = 'isEnableIOTModule';

var IS_IMPORTUSERFROMO365 = 'isImportUserFromO365';
var IS_IMPORTUSERFROMEXCEL = 'isImportUserFromExcel';
var IS_IMPORTUSERFROMAD = 'isImportUserFromAD';
var BACKEND_FOOTER = 'backendFooter';
var IS_SYNCROLEANDPOLICY = 'isSyncRoleAndPolicy';

var expiresDay = 7;

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value, expires) {
    if (expires) {
        js_cookie_default.a.set(key, value, { expires: expires });
    } else {
        js_cookie_default.a.set(key, value);
    }
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getAccessToken() {
    return getCookie(ACCESS_TOKEN);
}

function getRoom() {
    return getCookie(ROOM);
}

function getService() {
    return getCookie({ CLIENT_ID: CLIENT_ID, API_URL: API_URL });
}

function getAllToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {};
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    };
}

function getExpiresToken() {
    return getCookie(EXPIRES_ON);
}

function setToken(_ref) {
    var access_token = _ref.access_token,
        expires_on = _ref.expires_on,
        refresh_token = _ref.refresh_token;

    setCookie(ACCESS_TOKEN, access_token);
    setCookie(EXPIRES_ON, expires_on);
    setCookie(REFRESH_TOKEN, refresh_token);
}
function setClientId(client_id) {
    setCookie(CLIENT_ID, client_id);
}
function clearToken() {
    removeCookie(ACCESS_TOKEN);
    removeCookie(EXPIRES_ON);
    removeCookie(REFRESH_TOKEN);
    removeCookie(SERVICE_TOKEN);
    removeCookie(SERVICE_TOKEN_EXPIRES);
    removeCookie(ROOM);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);

    removeCookie(IS_IMPORTUSERFROMO365);
    removeCookie(IS_IMPORTUSERFROMEXCEL);
    removeCookie(IS_IMPORTUSERFROMAD);
}

function getServiceToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {};
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION)
    };
}

function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD);
}

function setServiceToken(_ref2) {
    var token = _ref2.token,
        expires_on = _ref2.expires_on;

    if ((typeof token === 'undefined' ? 'undefined' : _typeof(token)) !== undefined) setCookie(SERVICE_TOKEN, token);
    if ((typeof expires_on === 'undefined' ? 'undefined' : _typeof(expires_on)) !== undefined) setCookie(SERVICE_TOKEN_EXPIRES, expires_on);
}

function getIsRemember() {
    var isRemember = getCookie(IS_REMEMBER) === 'true' || getCookie(IS_REMEMBER) === true ? true : false;
    return isRemember;
}

function resetExpire() {
    var isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false;
    if (isRemember === true) {
        var keys = Object.keys(js_cookie_default.a.get());
        keys.forEach(function (key) {
            return setCookie(key, getCookie(key), expiresDay);
        });
    }
}

function setRefreshToken(res) {
    if (res.value) {
        var _res$value = res.value,
            token = _res$value.token,
            expires_on = _res$value.expires_on;

        var isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false;
        var expires = null;
        if (isRemember === true) {
            expires = expiresDay;
        }
        if (token) {
            setCookie(BSRS_ACCESS_TOKEN, token, expires);
        }
        if (expires_on) {
            setCookie(EXPIRES_ON, expires_on, expires);
        }
    }
}

function getUserInfo(access_token) {
    if (!access_token) return {};

    var _jwt$decode = jsonwebtoken_default.a.decode(access_token),
        iat = _jwt$decode.iat,
        exp = _jwt$decode.exp,
        appid = _jwt$decode.appid,
        name = _jwt$decode.name,
        email = _jwt$decode.unique_name;

    return {
        iat: iat,
        exp: exp,
        appid: appid,
        name: name,
        email: email
    };
}

function getUserId() {
    return getCookie(USER_ID);
}

function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN);
}

function setBSRSToken(bsrsToken) {
    var isRemember = bsrsToken.isRemember,
        isIntegration = bsrsToken.isIntegration,
        expires_on = bsrsToken.expires_on,
        token = bsrsToken.token,
        id = bsrsToken.id,
        company = bsrsToken.company,
        firstName = bsrsToken.firstName,
        email = bsrsToken.email,
        isUserActiveDirectory = bsrsToken.isUserActiveDirectory,
        system_key = bsrsToken.system_key,
        companyCode = bsrsToken.companyCode,
        isUseActiveDirectory = bsrsToken.isUseActiveDirectory,
        isImportUserFromO365 = bsrsToken.isImportUserFromO365,
        isImportUserFromExcel = bsrsToken.isImportUserFromExcel,
        isImportUserFromAD = bsrsToken.isImportUserFromAD,
        isEnableIOTModule = bsrsToken.isEnableIOTModule,
        isSyncRoleAndPolicy = bsrsToken.isSyncRoleAndPolicy;

    var limitUser = 0,
        expires = null,
        setIsRemember = false;
    if (company && company.limitUser) {
        if (Number.isInteger(parseInt(company.limitUser, 10))) {
            limitUser = parseInt(company.limitUser, 10);
        }
    }

    if (typeof isRemember === 'boolean' && isRemember === true) {
        setIsRemember = true;
        expires = expiresDay;
    }

    setCookie(BSRS_ACCESS_TOKEN, token, expires);
    setCookie(EXPIRES_ON, expires_on, expires);
    setCookie(IS_INTEGRATION, isIntegration, expires);
    setCookie(USER_ID, id, expires);
    setCookie(LIMIT_USERS, limitUser, expires);
    setCookie(FIRST_NAME, firstName, expires);
    setCookie(EMAIL, email, expires);
    setCookie(IS_USER_AD, isUserActiveDirectory, expires);
    setCookie(SYSTEM, system_key, expires);
    setCookie(COMPANY_CODE, companyCode, expires);
    setCookie(IS_REMEMBER, setIsRemember, expires);
    setCookie(IS_ENABLE_IOT_MODULE, isEnableIOTModule, expires);

    setCookie(IS_IMPORTUSERFROMO365, typeof isImportUserFromO365 === 'boolean' ? isImportUserFromO365 : false, expires);
    setCookie(IS_IMPORTUSERFROMEXCEL, typeof isImportUserFromExcel === 'boolean' ? isImportUserFromExcel : false, expires);
    setCookie(IS_IMPORTUSERFROMAD, typeof isImportUserFromAD === 'boolean' ? isImportUserFromAD : false, expires);
    setCookie(IS_SYNCROLEANDPOLICY, typeof isSyncRoleAndPolicy === 'boolean' ? isSyncRoleAndPolicy : false, expires);
}

function getLimitUser() {
    var get = getCookie(LIMIT_USERS);
    var dataReturn = -1;
    if (get && Number.isInteger(parseInt(get, 10))) {
        dataReturn = parseInt(get, 10);
    }
    return dataReturn;
}

function getSystem() {
    var system = getCookie(SYSTEM);
    return system ? system : '';
}

function getCompanyCode() {
    return getCookie(COMPANY_CODE);
}

function getUserFirstName() {
    return getCookie(FIRST_NAME);
}
function getIsEnableIOTmodule() {
    return getCookie(IS_ENABLE_IOT_MODULE);
}
function setRoomToken(room, client_id, api_server_url) {
    setCookie(ROOM, room);
    setCookie(CLIENT_ID, client_id);
    setCookie(API_URL, api_server_url);
}

function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN);
    removeCookie(USER_ID);
    removeCookie(IS_INTEGRATION);
    removeCookie(LIMIT_USERS);
    removeCookie(FIRST_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_USER_AD);
    removeCookie(SYSTEM);
    removeCookie(COMPANY_CODE);
    removeCookie(IS_REMEMBER);
    removeCookie(EXPIRES_ON);
    removeCookie(IS_ENABLE_IOT_MODULE);
    removeCookie(IS_IMPORTUSERFROMO365);
    removeCookie(IS_IMPORTUSERFROMEXCEL);
    removeCookie(IS_IMPORTUSERFROMAD);
    removeCookie(IS_SYNCROLEANDPOLICY);
    removeCookie(BACKEND_FOOTER);
}

function getResultPerPage() {
    return 10;
}
function setBackgroundFooter(backendFooter) {
    setCookie(BACKEND_FOOTER, backendFooter);
}
function getBackendFooter() {
    return getCookie(BACKEND_FOOTER);
}
function getImport() {
    var isImportUserFromO365 = false,
        isImportUserFromExcel = false,
        isImportUserFromAD = false;

    if (getCookie(IS_IMPORTUSERFROMO365) === 'true' || getCookie(IS_IMPORTUSERFROMO365) === true) {
        isImportUserFromO365 = true;
    }

    if (getCookie(IS_IMPORTUSERFROMEXCEL) === 'true' || getCookie(IS_IMPORTUSERFROMEXCEL) === true) {
        isImportUserFromExcel = true;
    }

    if (getCookie(IS_IMPORTUSERFROMAD) === 'true' || getCookie(IS_IMPORTUSERFROMAD) === true) {
        isImportUserFromAD = true;
    }

    return {
        isImportUserFromO365: isImportUserFromO365,
        isImportUserFromExcel: isImportUserFromExcel,
        isImportUserFromAD: isImportUserFromAD
    };
}
function getIsSyncRoleAndPolicy() {
    var isSyncRoleAndPolicy = false;

    if (getCookie(IS_SYNCROLEANDPOLICY) === 'true' || getCookie(IS_SYNCROLEANDPOLICY) === true) {
        isSyncRoleAndPolicy = true;
    }

    return isSyncRoleAndPolicy;
}
// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var dateFormatView = "ddd DD  MMMM YYYY";
var timeFormatView = "HH:mm";
var dateTimeFormatView = "ddd DD  MMMM YYYY HH:mm";
var dateFormat = "YYYY-MM-DD";

var daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var weekly = ['First', 'Second', 'Third', 'Fourth', 'Last'];

var dateDisplay = 'DD, MMM YYYY';
var dateTimeDisplay = 'DD, MMM YYYY, HH:mm';
var timeDisplay = 'HH:mm';

var groupFBSbyCatagory = function groupFBSbyCatagory(fbsList) {
    var result = [];
    if (fbsList && fbsList.length > 0) {
        fbsList.forEach(function (element) {
            var fbCategoryId = element.fbCategoryId;

            var _ref = fbCategoryId ? fbCategoryId : null,
                name = _ref.name,
                _id = _ref._id;

            var findIndexCategory = result.findIndex(function (r) {
                return r.fbCategoryId === _id;
            });
            if (findIndexCategory > -1) {
                var data = result[findIndexCategory].data;
                result[findIndexCategory].data = data.concat(element);
            } else result.push({ fbCategoryId: _id, name: name, data: [element] });
        });
    }
    return result;
};

var defaultEventPinEmail = "<p>You've been invited to the meeting at <u>{{eventDate}}</u></p>" + "<p>Invited by: {{organizerName}}</p>" + "<p>Subject: {{subject}}</p>" + '<p>Your PIN Code: <b><u> {{pinCode}}</u></b></p>' + '<p>Your QR Code:</p>' + '{{qrCodeImage}}' + '<p>Note: You can use the PIN or QR Code to perform any transaction at the meeting room.</p>' + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultCheckinEmail = "<p>Dear. {{attendeeName}}</p>" + "<p>You've successfully checked in the meeting at  <u>{{checkinTime}}</u> </p>" + "<p>Invited by: {{organizerName}} </p>" + "<p>Subject: {{subject}} </p>" + "<p>Welcome to the meeting room.</p>" + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultCheckoutEmail = "<p>Dear. {{attendeeName}}</p>" + "<p>You've successfully checked out the meeting at  <u>{{checkinTime}}</u> </p>" + "<p>Invited by: {{organizerName}} </p>" + "<p>Subject: {{subject}} </p>" + "<p>Have a good day.</p>" + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultReminderEmail = "<p>Dear {{fullName}} </p>" + "<p>This is to remind you that you have a meeting at {{eventDateTime}} at {{location}}</p>" + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultApproveEmail = "";

var defaultForgotPassword = "<p>Dear. {{fullname}}</p>" + "<p> You received this email because you requested forgot password on<u> {{requestDateTime}}</u> </p>" + "<p>Please click link below for confirm your request.</p>" + '<a href = "{{resetUrl}}">Click Here</a>' + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultResetPassword = "<p>Dear. {{fullname}}</p>" + "<p> You received this email because you requested for reset password on<u>{{requestDateTime}}</u> </p>" + "<p>Please use below Username and Password at frontend.</p>" + '<p><b>User: </b/>{{userEmail}}</p>' + '<p><b>Password: </b/>{{newPassword}}</p>' + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultAdminResetPassword = "<p>Dear. {{fullname}}</p>" + "<p>You are receiving this email because you're request for reset password on <u>{{requestDateTime}}</u> </p>" + "<p>Please log on at Frontend by this username , password as below.</p>" + '<p><b>User: </b/>{{userEmail}}</p>' + '<p><b>Password: </b/>{{newPassword}}</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var defaultEventRecurrentPinEmail = "<p>You've been invited to the meeting at <u>{{eventDateTime}}</u></p>" + "<p>Invited by: {{organizerName}}</p>" + "<p>Subject: {{subject}}</p>" + '<p>Your PIN Code: <b><u> {{pinCode}}</u></b></p>' + '<p>Your QR Code:</p>' + '{{qrCodeImage}}' + '<p>Note: You can use the PIN or QR Code to perform any transaction at the meeting room.</p>' + '<p>If you have any question or need further support, please contact administrator at {{administratorTel}}.</p>' + "<p><br/><p>Sincerely, <br/>Administrator Team</p>";

var xxx11 = {
    "value": {
        "zone": null,
        "floor": { "_id": "5ddb4696d290d969af8b3d19", "name": "1" },
        "building": { "_id": "5ddb4602d290d969af8b3d17", "name": "B1" },
        "roomId": "5de48b65b3044c5513fb4122",
        "roomName": "Room 2",
        "roomEmail": "rm11@bainisysstg.onmicrosoft.com",
        "status": [{ "module": "bacnet",
            "type": null,
            "controllers": [{ "mac": "00:30:de:45:ae:06",
                "values": [{ "value": null, "code": ["17"] }]
            }] }, { "module": "din",
            "type": "MOTION",
            "controllers": [{ "mac": "00:30:de:45:ad:ee",
                "values": [{ "value": null, "serial": [1, 2] }]
            }, { "mac": "00:30:de:41:3b:7d",
                "values": [{ "serial": [1], "value": "ON" }] }] }, { "module": "dout",
            "type": "LIGHT",
            "controllers": [{ "mac": "00:30:de:45:ad:ee",
                "values": [{ "value": null, "serial": [1, 4] }] }] }, { "module": "dmx",
            "type": null,
            "controllers": [{ "mac": "00:30:de:41:3b:7d",
                "values": [{ "serial": [1], "value": { "r": "56", "g": "80", "b": "223" } }] }] }, { "module": "dali",
            "type": null,
            "controllers": [{ "mac": "00:30:de:41:3b:7d",
                "values": [{ "serial": [1], "value": "100" }] }] }] }
};

var xxx10 = {
    "value": {
        "zone": null,
        "floor": { "_id": "5ddb4696d290d969af8b3d19", "name": "1" },
        "building": { "_id": "5ddb4602d290d969af8b3d17", "name": "B1" },
        "roomId": "5de48b65b3044c5513fb4122",
        "roomName": "Room 10",
        "roomEmail": "rm10@bainisysstg.onmicrosoft.com",
        "status": [{ "module": "bacnet",
            "type": null,
            "controllers": [{ "mac": "00:30:de:45:ae:06",
                "values": [{ "value": null, "code": ["16"] }]
            }] }, { "module": "din",
            "type": "MOTION",
            "controllers": [{ "mac": "00:30:de:45:ad:ee",
                "values": [{ "value": null, "serial": [1, 2] }]
            }, { "mac": "00:30:de:41:3b:7d",
                "values": [{ "serial": [1], "value": "ON" }] }] }, { "module": "dout",
            "type": "LIGHT",
            "controllers": [{ "mac": "00:30:de:45:ad:ee",
                "values": [{ "value": null, "serial": [1, 4] }] }] }, { "module": "dmx",
            "type": null,
            "controllers": [{ "mac": "00:30:de:41:3b:7d",
                "values": [{ "serial": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], "value": { "r": "0", "g": "0", "b": "0" } }] }] }, { "module": "dali",
            "type": null,
            "controllers": [{ "mac": "00:30:de:41:3b:7d",
                "values": [{ "serial": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], "value": "100" }] }] }] }
};
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(21);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var react_router_dom_es = __webpack_require__(57);

// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(58);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(121);

// CONCATENATED MODULE: ./src/lib/withAuthCheck.js






var withAuthCheck_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/login' });
};
var withAuthCheck_withAuthCheck = function withAuthCheck(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheck = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheck'), Object(es["connect"])(function (state) {
    return { isLoggedIn: Object(selectors["a" /* getIsLoggedIn */])(state) };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn;
  }, withAuthCheck_withAuthCheck, Object(Recompose["d" /* renderComponent */])(withAuthCheck_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withAuthCheckO365.js






var withAuthCheckO365_RedirectToLogin = function RedirectToLogin() {
  return react_default.a.createElement(react_router_dom_es["c" /* Redirect */], { to: '/logino365' });
};
var withAuthCheckO365_withAuthCheckO365 = function withAuthCheckO365(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, props);
  };
};

/* harmony default export */ var lib_withAuthCheckO365 = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withAuthCheckO365'), Object(es["connect"])(function (state) {
    return {
      isLoggedInO365: Object(selectors["b" /* getIsLoggedInO365 */])(state)
    };
  }), Object(Recompose["a" /* branch */])(function (_ref) {
    var isLoggedInO365 = _ref.isLoggedInO365;
    return isLoggedInO365;
  }, withAuthCheckO365_withAuthCheckO365, Object(Recompose["d" /* renderComponent */])(withAuthCheckO365_RedirectToLogin)))(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/withO365UserInfo.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var withO365UserInfo_withO365UserInfo = function withO365UserInfo(WrappedComponent) {
  return function (props) {
    return react_default.a.createElement(WrappedComponent, _extends({}, props, { O365UserInfo: props.userInfo }));
  };
};

/* harmony default export */ var lib_withO365UserInfo = (function (WrappedComponent) {
  return Object(Recompose["b" /* compose */])(Object(Recompose["e" /* setDisplayName */])('withO365UserInfo'), Object(es["connect"])(function (state) {
    return {
      userInfo: Object(selectors["c" /* getUserInfo */])(state)
    };
  }), withO365UserInfo_withO365UserInfo)(WrappedComponent);
});
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return api["g" /* PROFILE_CENTER_URL */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api["b" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return api["f" /* O365_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return api["e" /* NOTI_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["c" /* IS_SYNC_O365_GROUP_AND_PERMISSION */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "P", function() { return api["h" /* pageTitle */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* COPYRIGHT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return api["d" /* LOGO_THEME */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "A", function() { return getCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "T", function() { return setCookie; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Q", function() { return removeCookie; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getAccessToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "G", function() { return getRoom; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "H", function() { return getService; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return getAllToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "B", function() { return getExpiresToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "X", function() { return setToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "S", function() { return setClientId; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "I", function() { return getServiceToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "E", function() { return getIsUserActiveDirectory; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "W", function() { return setServiceToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getIsRemember; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return resetExpire; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "U", function() { return setRefreshToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "M", function() { return getUserInfo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "L", function() { return getUserId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return getBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "R", function() { return setBSRSToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getLimitUser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "J", function() { return getSystem; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return getCompanyCode; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "K", function() { return getUserFirstName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "C", function() { return getIsEnableIOTmodule; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "V", function() { return setRoomToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return clearBSRSToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "F", function() { return getResultPerPage; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return setBackgroundFooter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return getBackendFooter; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getImport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "D", function() { return getIsSyncRoleAndPolicy; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Z", function() { return timeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return dateFormatView; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_0", function() { return timeFormatView; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return dateTimeFormatView; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return dateFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return daysInWeek; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "O", function() { return month; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "_1", function() { return weekly; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return dateDisplay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return dateTimeDisplay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Y", function() { return timeDisplay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "N", function() { return groupFBSbyCatagory; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return defaultEventPinEmail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return defaultCheckinEmail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return defaultCheckoutEmail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return defaultReminderEmail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return defaultApproveEmail; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return defaultForgotPassword; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return defaultResetPassword; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return defaultAdminResetPassword; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return defaultEventRecurrentPinEmail; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return xxx11; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return xxx10; });
/* unused concated harmony import withAuthCheck */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheck; });
/* unused concated harmony import withAuthCheckO365 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withAuthCheckO365; });
/* unused concated harmony import withO365UserInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lib_withO365UserInfo; });







/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loading = function Loading() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["f" /* Dimmer */],
        { active: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (function (opts) {
    return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()(_extends({
        loading: Loading
    }, opts));
});

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getSettingInfo;
/* harmony export (immutable) */ __webpack_exports__["a"] = getADSuccess;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTimezone;
/* harmony export (immutable) */ __webpack_exports__["d"] = getIsTMS;
/* harmony export (immutable) */ __webpack_exports__["c"] = getIsCMR;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsBOT;
function getSettingInfo(state, props) {
    return state.setting;
}

function getADSuccess(state, props) {
    return state.AD;
}

function getTimezone(state, props) {
    return state.timezone;
}

function getIsTMS(state, props) {
    return state.TMS;
}

function getIsCMR(state, props) {
    return state.CMR;
}

function getIsBOT(state, props) {
    return state.BOT;
}

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = findSettingInfo;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeSetting;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkConnectAD;
/* harmony export (immutable) */ __webpack_exports__["e"] = checkConnectTMS;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkConnectCMR;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkConnectBOT;
/* harmony export (immutable) */ __webpack_exports__["g"] = loadAllTimeZone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Middlewares__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Lib__ = __webpack_require__(39);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function findSettingInfo() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/setting/info',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_355" /* CORE_LOAD_SETTING_INFO_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_356" /* CORE_LOAD_SETTING_INFO_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_354" /* CORE_LOAD_SETTING_INFO_FAILURE */]]
    });
}
function changeSetting(body) {
    var isUpdateLogo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/setting',
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["k" /* CORE_CHANGE_SETTING_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["l" /* CORE_CHANGE_SETTING_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json;
                });
            },
            callBack: function callBack() {
                window.location.reload();
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["j" /* CORE_CHANGE_SETTING_FAILURE */]]
    });
}

function checkConnectAD(setting) {
    var activeDirectoryAdminPassword = setting.activeDirectoryAdminPassword,
        activeDirectoryAdminUser = setting.activeDirectoryAdminUser,
        activeDirectoryBaseDN = setting.activeDirectoryBaseDN,
        activeDirectoryIP = setting.activeDirectoryIP,
        activeDirectoryPort = setting.activeDirectoryPort;

    var body = {
        "url": "ldap://" + activeDirectoryIP + ":" + activeDirectoryPort,
        "baseDN": activeDirectoryBaseDN,
        "username": activeDirectoryAdminUser,
        "password": activeDirectoryAdminPassword
    };

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/user/verifyAD',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["t" /* CORE_CHECK_AD_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["u" /* CORE_CHECK_AD_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["s" /* CORE_CHECK_AD_FAILURE */]]
    });
}

function checkConnectTMS(setting) {
    var tms_server = setting.tms_server,
        tms_user = setting.tms_user,
        tms_password = setting.tms_password,
        tms_user_prefix = setting.tms_user_prefix,
        tms_conference_type = setting.tms_conference_type;

    var body = {
        tms_server: tms_server,
        tms_user: tms_user,
        tms_password: tms_password,
        tms_user_prefix: tms_user_prefix,
        tms_conference_type: tms_conference_type
    };

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/setting/connectTMS',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["C" /* CORE_CHECK_TMS_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["D" /* CORE_CHECK_TMS_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["B" /* CORE_CHECK_TMS_FAILURE */]]
    });
}

function checkConnectCMR(setting) {
    var cmr_server_url = setting.cmr_server_url,
        cmr_user = setting.cmr_user,
        cmr_password = setting.cmr_password,
        cmr_site_name = setting.cmr_site_name;

    var body = {
        cmr_server_url: cmr_server_url,
        cmr_user: cmr_user,
        cmr_password: cmr_password,
        cmr_site_name: cmr_site_name
    };

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/setting/connectCMR',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["z" /* CORE_CHECK_CMR_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["A" /* CORE_CHECK_CMR_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["y" /* CORE_CHECK_CMR_FAILURE */]]
    });
}

function checkConnectBOT(setting) {
    var bot_web_hook_url = setting.bot_web_hook_url;

    var body = {
        bot_web_hook_url: bot_web_hook_url
    };

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/setting/connectBOT',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["w" /* CORE_CHECK_BOT_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["x" /* CORE_CHECK_BOT_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["v" /* CORE_CHECK_BOT_FAILURE */]]
    });
}

function loadAllTimeZone() {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_2_Lib__["b" /* CORE_API_ENDPOINT */] + '/timezone/list',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_367" /* CORE_LOAD_TIMEZOZE_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_368" /* CORE_LOAD_TIMEZOZE_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    return json.value;
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_366" /* CORE_LOAD_TIMEZOZE_FAILURE */]]
    });
}

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROFILE_CENTER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return O365_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTI_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SYNC_O365_GROUP_AND_PERMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pageTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COPYRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGO_THEME; });
// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'
// export const NOTI_API_ENDPOINT = 'https://www.bainisysstg.com/notification'

// export const CORE_API_ENDPOINT = 'http://10.0.10.17:2000/core'
// export const O365_API_ENDPOINT = 'http://10.0.10.17:3000/o365'
// export const NOTI_API_ENDPOINT = 'http://10.0.10.17:3001/notification'

var PROFILE_CENTER_URL = 'https://backoffice.bsrsprofile.com/api';

// export const CORE_API_ENDPOINT = 'https://back26.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back26.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back26.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://back23.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back23.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back23.rmbainisys.com/notification'

// server 10.0.30.9
var CORE_API_ENDPOINT = '/core';
var O365_API_ENDPOINT = '/o365';
var NOTI_API_ENDPOINT = '/notification';

// export const CORE_API_ENDPOINT = 'https://frontgg.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://frontgg.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://frontgg.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://backssr.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backssr.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backssr.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'http://localhost:2140/core'
// export const O365_API_ENDPOINT = 'http://localhost:2141/o365'
// export const NOTI_API_ENDPOINT = 'http://localhost:2142/notification'

// export const CORE_API_ENDPOINT = 'https://siricampusmeetingrm.sansiri.com/core'
// export const O365_API_ENDPOINT = 'https://siricampusmeetingrm.sansiri.com/o365'
// export const NOTI_API_ENDPOINT = 'https://siricampusmeetingrm.sansiri.com/notification'


//// จะ ปิด เมนู role room ที่ user หรือไม่
var IS_SYNC_O365_GROUP_AND_PERMISSION = false;
// FUJITSU Smart Workplace Meeto
// Bainisys Smart Reservation System(BSRS)
var pageTitle = "Bainisys Smart Reservation System(BSRS)";

// BAINISYS
//FUJITSU
var COPYRIGHT = '© 2019 BAINISYS';

//// meetup, central, roomminister
var LOGO_THEME = "roomminister";

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = authorizeO365;
/* unused harmony export authorizeProfile */
/* harmony export (immutable) */ __webpack_exports__["a"] = authorizeBSRS;
/* harmony export (immutable) */ __webpack_exports__["c"] = authorizeServiceToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Lib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Middlewares__ = __webpack_require__(160);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function authorizeO365(code) {
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["b" /* CORE_API_ENDPOINT */] + '/o365/token',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_584" /* O365_REGISTER_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_585" /* O365_REGISTER_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var access_token = json.access_token,
                        expires_on = json.expires_on,
                        refresh_token = json.refresh_token;


                    var token = {
                        access_token: access_token,
                        expires_on: expires_on,
                        refresh_token: refresh_token
                    };

                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["X" /* setToken */])(token);
                    return { token: token };
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_583" /* O365_REGISTER_FAILURE */]]
    });
}

function authorizeProfile(_ref2) {
    var email = _ref2.email,
        password = _ref2.password;

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: 'https://www.bsrsprofile.com/center/profile/verify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email, password: password }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["_599" /* PROFILE_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["_600" /* PROFILE_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var _json$profile = json.profile,
                        room = _json$profile.room,
                        appMeta = _json$profile.appMeta;
                    var client_id = appMeta.client_id,
                        api_server_url = appMeta.api_server_url;

                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["V" /* setRoomToken */])(room, client_id, api_server_url);
                    return { room: room };
                });
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["_598" /* PROFILE_LOGIN_FAILURE */]]
    });
}

function authorizeBSRS(_ref4, isRemember) {
    var emailaddress = _ref4.emailaddress,
        password = _ref4.password;

    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["b" /* CORE_API_ENDPOINT */] + '/user/adminverify',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: emailaddress, password: password }),
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["b" /* BSRS_LOGIN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* BSRS_LOGIN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var isIntegration = json.isIntegration,
                        isUserActiveDirectory = json.isUserActiveDirectory,
                        token = json.token,
                        user = json.user,
                        company = json.company,
                        companyCode = json.companyCode,
                        system_key = json.system_key,
                        expires_on = json.expires_on,
                        isEnableIOTModule = json.isEnableIOTModule,
                        isImportUserFromO365 = json.isImportUserFromO365,
                        isImportUserFromExcel = json.isImportUserFromExcel,
                        isImportUserFromAD = json.isImportUserFromAD;
                    var id = user.id,
                        firstName = user.firstName,
                        email = user.email;


                    var bsrsToken = {
                        isIntegration: isIntegration,
                        token: token,
                        id: id,
                        company: company,
                        firstName: firstName,
                        email: email,
                        companyCode: companyCode,
                        expires_on: expires_on,
                        isRemember: isRemember,
                        isUserActiveDirectory: isUserActiveDirectory ? isUserActiveDirectory : false,
                        system_key: system_key,
                        isEnableIOTModule: isEnableIOTModule,
                        isImportUserFromO365: isImportUserFromO365,
                        isImportUserFromExcel: isImportUserFromExcel,
                        isImportUserFromAD: isImportUserFromAD
                    };
                    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["R" /* setBSRSToken */])(bsrsToken);
                    return { bsrsToken: bsrsToken };
                });
            },
            callBack: function callBack(data) {
                var payload = data.payload;
                if (payload.bsrsToken) {
                    window.location.replace('/');
                }
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* BSRS_LOGIN_FAILURE */]]
    });
}

function authorizeServiceToken(history) {
    var bsrsToken = Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["x" /* getBSRSToken */])();
    return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2_Middlewares__["a" /* CALL_API */], {
        endpoint: __WEBPACK_IMPORTED_MODULE_1_Lib__["b" /* CORE_API_ENDPOINT */] + '/o365/service_token',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bsrsToken
        },
        types: [__WEBPACK_IMPORTED_MODULE_0__types__["e" /* BSRS_SERVICE_TOKEN_REQUEST */], {
            type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* BSRS_SERVICE_TOKEN_SUCCESS */],
            payload: function payload(action, state, res) {
                return res.json().then(function (json) {
                    var token = json.token,
                        expires_on = json.expires_on;

                    var serviceToken = {
                        token: token,
                        expires_on: expires_on
                    };
                    if (typeof token === 'undefined') history.push('/settings/integration');else {
                        Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["W" /* setServiceToken */])(serviceToken);
                        return { serviceToken: serviceToken };
                    }
                });
            },
            callBack: function callBack() {
                // history.push(`/room`)
            }
        }, __WEBPACK_IMPORTED_MODULE_0__types__["d" /* BSRS_SERVICE_TOKEN_FAILURE */]]
    });
}

function logout() {
    Object(__WEBPACK_IMPORTED_MODULE_1_Lib__["h" /* clearBSRSToken */])();
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__types__["_543" /* LOGOUT */]
    };
}

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(10);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js
/* harmony export (immutable) */ __webpack_exports__["a"] = setError;





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


	var defaultError = {
		code: "00010000",
		message: src_error ? src_error["00010000"] : ""
	};

	if (typeof error === 'string' && error in src_error) {
		defaultError = {
			code: error,
			message: src_error[error]
		};
	} else if (error !== null && error !== undefined && error.code !== undefined && error.message !== undefined) {
		defaultError = error;
	} else if (error === null || hasError === false) {
		defaultError = null;
	}

	return {
		type: types["_601" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_switch_lang__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_switch_lang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_switch_lang__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_country_flag__ = __webpack_require__(890);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var handleSetLanguage = function handleSetLanguage(e, key) {
   Object(__WEBPACK_IMPORTED_MODULE_1_react_switch_lang__["setLanguage"])(key);
   e.preventDefault();
};

var Tab = function (_Component) {
   _inherits(Tab, _Component);

   function Tab(props) {
      _classCallCheck(this, Tab);

      return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));
   }

   _createClass(Tab, [{
      key: 'render',
      value: function render() {
         var _React$createElement, _React$createElement2;

         var cl = Object(__WEBPACK_IMPORTED_MODULE_1_react_switch_lang__["getLanguage"])();
         return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tab-switch-language' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_country_flag__["a" /* default */], (_React$createElement = {
               svg: true,
               countryCode: 'US'
            }, _defineProperty(_React$createElement, 'svg', true), _defineProperty(_React$createElement, 'style', {
               fontSize: '35px',
               lineHeight: '2em'
            }), _defineProperty(_React$createElement, 'onClick', function onClick(e) {
               return handleSetLanguage(e, 'en');
            }), _defineProperty(_React$createElement, 'className', 'tsl-li' + (cl === 'en' ? ' tsl-li-active' : '')), _React$createElement)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_country_flag__["a" /* default */], (_React$createElement2 = {
               svg: true,
               countryCode: 'TH'
            }, _defineProperty(_React$createElement2, 'svg', true), _defineProperty(_React$createElement2, 'style', {
               fontSize: '35px',
               lineHeight: '2em'
            }), _defineProperty(_React$createElement2, 'onClick', function onClick(e) {
               return handleSetLanguage(e, 'th');
            }), _defineProperty(_React$createElement2, 'className', 'tsl-li' + (cl === 'th' ? ' tsl-li-active' : '')), _React$createElement2))
         );
      }
   }]);

   return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(500);


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(108);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(505);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./src/features/ui/components/Root.js
var Root = __webpack_require__(507);
var Root_default = /*#__PURE__*/__webpack_require__.n(Root);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(161);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./src/wording/pages/login/ENG.json
var ENG = __webpack_require__(893);
var ENG_default = /*#__PURE__*/__webpack_require__.n(ENG);

// EXTERNAL MODULE: ./src/wording/pages/button/ENG.json
var button_ENG = __webpack_require__(894);
var button_ENG_default = /*#__PURE__*/__webpack_require__.n(button_ENG);

// EXTERNAL MODULE: ./src/wording/pages/header/ENG.json
var header_ENG = __webpack_require__(895);
var header_ENG_default = /*#__PURE__*/__webpack_require__.n(header_ENG);

// EXTERNAL MODULE: ./src/wording/pages/room/ENG.json
var room_ENG = __webpack_require__(896);
var room_ENG_default = /*#__PURE__*/__webpack_require__.n(room_ENG);

// EXTERNAL MODULE: ./src/wording/pages/advanceSearch/ENG.json
var advanceSearch_ENG = __webpack_require__(897);
var advanceSearch_ENG_default = /*#__PURE__*/__webpack_require__.n(advanceSearch_ENG);

// EXTERNAL MODULE: ./src/wording/pages/location/ENG.json
var location_ENG = __webpack_require__(898);
var location_ENG_default = /*#__PURE__*/__webpack_require__.n(location_ENG);

// EXTERNAL MODULE: ./src/wording/pages/user/ENG.json
var user_ENG = __webpack_require__(899);
var user_ENG_default = /*#__PURE__*/__webpack_require__.n(user_ENG);

// EXTERNAL MODULE: ./src/wording/pages/role/ENG.json
var role_ENG = __webpack_require__(900);
var role_ENG_default = /*#__PURE__*/__webpack_require__.n(role_ENG);

// EXTERNAL MODULE: ./src/wording/pages/profile/ENG.json
var profile_ENG = __webpack_require__(901);
var profile_ENG_default = /*#__PURE__*/__webpack_require__.n(profile_ENG);

// EXTERNAL MODULE: ./src/wording/pages/bg/ENG.json
var bg_ENG = __webpack_require__(902);
var bg_ENG_default = /*#__PURE__*/__webpack_require__.n(bg_ENG);

// EXTERNAL MODULE: ./src/wording/pages/facNfood/ENG.json
var facNfood_ENG = __webpack_require__(903);
var facNfood_ENG_default = /*#__PURE__*/__webpack_require__.n(facNfood_ENG);

// EXTERNAL MODULE: ./src/wording/pages/iot/ENG.json
var iot_ENG = __webpack_require__(904);
var iot_ENG_default = /*#__PURE__*/__webpack_require__.n(iot_ENG);

// EXTERNAL MODULE: ./src/wording/pages/event/ENG.json
var event_ENG = __webpack_require__(905);
var event_ENG_default = /*#__PURE__*/__webpack_require__.n(event_ENG);

// EXTERNAL MODULE: ./src/wording/pages/order/ENG.json
var order_ENG = __webpack_require__(906);
var order_ENG_default = /*#__PURE__*/__webpack_require__.n(order_ENG);

// EXTERNAL MODULE: ./src/wording/pages/setting/ENG.json
var setting_ENG = __webpack_require__(907);
var setting_ENG_default = /*#__PURE__*/__webpack_require__.n(setting_ENG);

// EXTERNAL MODULE: ./src/wording/pages/report/ENG.json
var report_ENG = __webpack_require__(908);
var report_ENG_default = /*#__PURE__*/__webpack_require__.n(report_ENG);

// EXTERNAL MODULE: ./src/wording/pages/Monitor/ENG.json
var Monitor_ENG = __webpack_require__(909);
var Monitor_ENG_default = /*#__PURE__*/__webpack_require__.n(Monitor_ENG);

// EXTERNAL MODULE: ./src/wording/pages/hotdesk/ENG.json
var hotdesk_ENG = __webpack_require__(910);
var hotdesk_ENG_default = /*#__PURE__*/__webpack_require__.n(hotdesk_ENG);

// EXTERNAL MODULE: ./src/wording/pages/error/ENG.json
var error_ENG = __webpack_require__(911);
var error_ENG_default = /*#__PURE__*/__webpack_require__.n(error_ENG);

// CONCATENATED MODULE: ./src/wording/en.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















/* harmony default export */ var en = ({
    login: _extends({}, ENG_default.a),
    button: _extends({}, button_ENG_default.a),
    header: _extends({}, header_ENG_default.a),
    room: _extends({}, room_ENG_default.a),
    advanceSearch: _extends({}, advanceSearch_ENG_default.a),
    location: _extends({}, location_ENG_default.a),
    user: _extends({}, user_ENG_default.a),
    role: _extends({}, role_ENG_default.a),
    profile: _extends({}, profile_ENG_default.a),
    bg: _extends({}, bg_ENG_default.a),
    facNfood: _extends({}, facNfood_ENG_default.a),
    iot: _extends({}, iot_ENG_default.a),
    event: _extends({}, event_ENG_default.a),
    order: _extends({}, order_ENG_default.a),
    setting: _extends({}, setting_ENG_default.a),
    report: _extends({}, report_ENG_default.a),
    monitor: _extends({}, Monitor_ENG_default.a),
    noResult: "No Result",
    hotdesk: _extends({}, hotdesk_ENG_default.a),
    error: _extends({}, error_ENG_default.a),
    home: "Home"
});
// EXTERNAL MODULE: ./src/wording/pages/login/TH.json
var TH = __webpack_require__(912);
var TH_default = /*#__PURE__*/__webpack_require__.n(TH);

// EXTERNAL MODULE: ./src/wording/pages/button/TH.json
var button_TH = __webpack_require__(913);
var button_TH_default = /*#__PURE__*/__webpack_require__.n(button_TH);

// EXTERNAL MODULE: ./src/wording/pages/header/TH.json
var header_TH = __webpack_require__(914);
var header_TH_default = /*#__PURE__*/__webpack_require__.n(header_TH);

// EXTERNAL MODULE: ./src/wording/pages/room/TH.json
var room_TH = __webpack_require__(915);
var room_TH_default = /*#__PURE__*/__webpack_require__.n(room_TH);

// EXTERNAL MODULE: ./src/wording/pages/advanceSearch/TH.json
var advanceSearch_TH = __webpack_require__(916);
var advanceSearch_TH_default = /*#__PURE__*/__webpack_require__.n(advanceSearch_TH);

// EXTERNAL MODULE: ./src/wording/pages/location/TH.json
var location_TH = __webpack_require__(917);
var location_TH_default = /*#__PURE__*/__webpack_require__.n(location_TH);

// EXTERNAL MODULE: ./src/wording/pages/user/TH.json
var user_TH = __webpack_require__(918);
var user_TH_default = /*#__PURE__*/__webpack_require__.n(user_TH);

// EXTERNAL MODULE: ./src/wording/pages/role/TH.json
var role_TH = __webpack_require__(919);
var role_TH_default = /*#__PURE__*/__webpack_require__.n(role_TH);

// EXTERNAL MODULE: ./src/wording/pages/profile/TH.json
var profile_TH = __webpack_require__(920);
var profile_TH_default = /*#__PURE__*/__webpack_require__.n(profile_TH);

// EXTERNAL MODULE: ./src/wording/pages/bg/TH.json
var bg_TH = __webpack_require__(921);
var bg_TH_default = /*#__PURE__*/__webpack_require__.n(bg_TH);

// EXTERNAL MODULE: ./src/wording/pages/facNfood/TH.json
var facNfood_TH = __webpack_require__(922);
var facNfood_TH_default = /*#__PURE__*/__webpack_require__.n(facNfood_TH);

// EXTERNAL MODULE: ./src/wording/pages/iot/TH.json
var iot_TH = __webpack_require__(923);
var iot_TH_default = /*#__PURE__*/__webpack_require__.n(iot_TH);

// EXTERNAL MODULE: ./src/wording/pages/event/TH.json
var event_TH = __webpack_require__(924);
var event_TH_default = /*#__PURE__*/__webpack_require__.n(event_TH);

// EXTERNAL MODULE: ./src/wording/pages/order/TH.json
var order_TH = __webpack_require__(925);
var order_TH_default = /*#__PURE__*/__webpack_require__.n(order_TH);

// EXTERNAL MODULE: ./src/wording/pages/setting/TH.json
var setting_TH = __webpack_require__(926);
var setting_TH_default = /*#__PURE__*/__webpack_require__.n(setting_TH);

// EXTERNAL MODULE: ./src/wording/pages/report/TH.json
var report_TH = __webpack_require__(927);
var report_TH_default = /*#__PURE__*/__webpack_require__.n(report_TH);

// EXTERNAL MODULE: ./src/wording/pages/Monitor/TH.json
var Monitor_TH = __webpack_require__(928);
var Monitor_TH_default = /*#__PURE__*/__webpack_require__.n(Monitor_TH);

// EXTERNAL MODULE: ./src/wording/pages/hotdesk/TH.json
var hotdesk_TH = __webpack_require__(929);
var hotdesk_TH_default = /*#__PURE__*/__webpack_require__.n(hotdesk_TH);

// EXTERNAL MODULE: ./src/wording/pages/error/TH.json
var error_TH = __webpack_require__(930);
var error_TH_default = /*#__PURE__*/__webpack_require__.n(error_TH);

// CONCATENATED MODULE: ./src/wording/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















/* harmony default export */ var th = ({
    login: th__extends({}, TH_default.a),
    button: th__extends({}, button_TH_default.a),
    header: th__extends({}, header_TH_default.a),
    room: th__extends({}, room_TH_default.a),
    advanceSearch: th__extends({}, advanceSearch_TH_default.a),
    location: th__extends({}, location_TH_default.a),
    user: th__extends({}, user_TH_default.a),
    role: th__extends({}, role_TH_default.a),
    profile: th__extends({}, profile_TH_default.a),
    bg: th__extends({}, bg_TH_default.a),
    facNfood: th__extends({}, facNfood_TH_default.a),
    iot: th__extends({}, iot_TH_default.a),
    event: th__extends({}, event_TH_default.a),
    order: th__extends({}, order_TH_default.a),
    setting: th__extends({}, setting_TH_default.a),
    report: th__extends({}, report_TH_default.a),
    monitor: th__extends({}, Monitor_TH_default.a),
    noResult: "ไม่พบข้อมูล",
    hotdesk: th__extends({}, hotdesk_TH_default.a),
    error: th__extends({}, error_TH_default.a),
    home: "หน้าหลัก"
});
// CONCATENATED MODULE: ./src/index.js










Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('th');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    return react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root_default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(508);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 29 modules
var es = __webpack_require__(57);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var react_redux_es = __webpack_require__(21);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(515);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(516);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(58);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(73);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getError(state) {
    return state.ui.error;
}

function getHasBSRSLoginFail(state) {
    return state.ui.hasBSRSLoginFail === true;
}
// EXTERNAL MODULE: ./src/features/ui/actions.js + 1 modules
var actions = __webpack_require__(497);

// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ErrorMessageDialog_ErrorMessage = function (_React$Component) {
	_inherits(ErrorMessage, _React$Component);

	function ErrorMessage() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessage);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessage, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				dist_es["u" /* Modal */],
				{ open: this.state.open, onClose: this.close },
				react_default.a.createElement(
					dist_es["u" /* Modal */].Header,
					null,
					'System Message'
				),
				react_default.a.createElement(
					dist_es["u" /* Modal */].Content,
					null,
					this.props.hasError && this.props.error && this.props.error.code !== undefined && this.props.error.message !== undefined ? react_default.a.createElement(
						dist_es["u" /* Modal */].Description,
						null,
						react_default.a.createElement(
							'p',
							null,
							'Error Code : ',
							this.props.error.code
						),
						react_default.a.createElement(
							'p',
							null,
							'Error Message : ',
							this.props.error.message
						)
					) : react_default.a.createElement(
						'p',
						null,
						'Something went wrong.'
					)
				),
				react_default.a.createElement(
					dist_es["u" /* Modal */].Actions,
					null,
					react_default.a.createElement(dist_es["b" /* Button */], {
						positive: true,
						icon: 'checkmark',
						labelPosition: 'right',
						content: 'Ok',
						onClick: this.close,
						onClose: this.close
					})
				)
			);
		}
	}]);

	return ErrorMessage;
}(react_default.a.Component);

/* harmony default export */ var ErrorMessageDialog = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(Object(actions["a" /* setError */])(false));
		}
	};
}))(ErrorMessageDialog_ErrorMessage));
// CONCATENATED MODULE: ./src/features/ui/components/Loading.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Loading_LoadingComponent = function LoadingComponent(props) {
    return react_default.a.createElement('div', null);
    // props.isLoading ?
    // 	<Dimmer active>
    // 		<Loader size='large'>Loading</Loader>
    // 	</Dimmer>
    // 	:
    // ""
};

/* harmony default export */ var Loading = (Object(Recompose["b" /* compose */])(Object(react_redux_es["connect"])(function (state) {
    return {
        isLoading: getIsLoading(state)
    };
}), Object(Recompose["f" /* withProps */])(function (props) {
    return _extends({}, props);
}))(Loading_LoadingComponent));
// EXTERNAL MODULE: ./src/features/auth/actions.js
var auth_actions = __webpack_require__(496);

// EXTERNAL MODULE: ./src/features/auth/selectors.js
var selectors = __webpack_require__(121);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var lib = __webpack_require__(39);

// EXTERNAL MODULE: ./src/features/ui/components/Item/tabSwitchLanguageNoBG.js
var tabSwitchLanguageNoBG = __webpack_require__(498);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(161);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// CONCATENATED MODULE: ./src/features/ui/components/Header.js
var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var header = {
    textDecoration: 'underline',
    fontSize: '1em'
};

var Header_NoAuthHeader = function NoAuthHeader() {
    return react_default.a.createElement('div', null);
};

// const AuthHeader = ({ logout }) => (

var Header_AuthHeader = function (_React$Component) {
    Header__inherits(AuthHeader, _React$Component);

    function AuthHeader(props) {
        Header__classCallCheck(this, AuthHeader);

        // const bsrs = getServiceToken()
        var _this = Header__possibleConstructorReturn(this, (AuthHeader.__proto__ || Object.getPrototypeOf(AuthHeader)).call(this, props));

        var firstName = Object(lib["K" /* getUserFirstName */])();
        var isUseAD = Object(lib["E" /* getIsUserActiveDirectory */])();
        var system = Object(lib["J" /* getSystem */])();
        _this.state = {
            logout: props.logout,
            firstName: typeof firstName !== 'undefined' ? firstName : '',
            isUseAD: isUseAD ? isUseAD : false,
            system: system,
            isEnableIotModule: Object(lib["C" /* getIsEnableIOTmodule */])()
        };
        return _this;
    }

    Header__createClass(AuthHeader, [{
        key: 'render',
        value: function render() {
            var linkToInt = '';
            if (Object(lib["J" /* getSystem */])() === 'o365') linkToInt = '/integration';else if (Object(lib["J" /* getSystem */])() === 'exchange2013') linkToInt = '/exchangeIntegration';else if (Object(lib["J" /* getSystem */])() === 'google') linkToInt = '/googleIntegration';
            // const { isEnableIotModule } = this.state
            var isEnableIotModule = "true";

            var user_id = Object(lib["L" /* getUserId */])();
            var isProfile = false;
            if (user_id === 'profile_user') {
                isProfile = true;
            }
            var t = this.props.t;

            return react_default.a.createElement(
                dist_es["s" /* Menu */],
                { secondary: true, fixed: 'top', style: { backgroundColor: "rgb(51, 51, 51)" } },
                react_default.a.createElement(
                    dist_es["e" /* Container */],
                    { style: { width: "100%", padding: "0px 15px", margin: 0 } },
                    react_default.a.createElement(
                        dist_es["s" /* Menu */].Item,
                        { as: es["b" /* Link */], to: '/', className: 'menuImage' },
                        react_default.a.createElement(
                            'div',
                            { style: { height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                            react_default.a.createElement(dist_es["n" /* Image */]
                            // size='small'
                            , { src: '/assets/images/logo_' + lib["d" /* LOGO_THEME */] + '.png',
                                style: { display: 'inline-block', maxHeight: '100%' }
                            })
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["h" /* Dropdown */],
                        { item: true, text: t('header.masterData'), id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["h" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.rooms') },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/room/system' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'window restore' }),
                                        t('header.roomMail')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/room/core' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'database' }),
                                        t('header.roomRegis')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/room/subscribe' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'bell' }),
                                        t('header.roomSub')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/roomdisable' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'ban' }),
                                        t('header.roomDis')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/roomformat' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'sitemap' }),
                                        t('header.roomFormat')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/eventtype' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'tasks' }),
                                        t('header.eventType')
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.location') },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/building' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'building' }),
                                        t('header.building')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/floor' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'hashtag' }),
                                        t('header.floor')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/zone' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'star' }),
                                        t('header.zone')
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.Users'), id: 'menuHover' },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    this.state.isUseAD === 'true' && react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/user/ad' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'adn' }),
                                        t('header.adUsers')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/user/core' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'database' }),
                                        t('header.userRegis')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/user/group/list' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'users' }),
                                        t('header.Department')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/user/concurrent' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'users' }),
                                        t('header.userConcur')
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.permission'), id: 'menuHover' },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/role/list' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'address book' }),
                                        t('header.Role')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/profile/list' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'user' }),
                                        t('header.Profile')
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.Facilitites') },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/amenity' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'briefcase' }),
                                        t('header.Facilitites')
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.food') },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/fbsCategory' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'coffee' }),
                                        t('header.Category')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/fbs' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'coffee' }),
                                        t('header.Foods')
                                    )
                                )
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */],
                                { item: true, text: t('header.device') },
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Menu,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/background' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'flag' }),
                                        t('header.Background')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/logo' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'flag' }),
                                        t('header.logo')
                                    ),
                                    react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/display' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'at' }),
                                        t('header.iotDisplay')
                                    ),
                                    isEnableIotModule && isEnableIotModule === 'true' && react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/iot' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'at' }),
                                        t('header.iotRegis')
                                    ),
                                    isEnableIotModule && isEnableIotModule === 'true' && react_default.a.createElement(
                                        dist_es["h" /* Dropdown */].Item,
                                        { as: es["b" /* Link */], to: '/allcontrol' },
                                        react_default.a.createElement(dist_es["m" /* Icon */], { name: 'tag' }),
                                        t('header.iotRoomConfig')
                                    )
                                )
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["h" /* Dropdown */],
                        { item: true, text: t('header.Events'), id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["h" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/events' },
                                react_default.a.createElement(dist_es["m" /* Icon */], { name: 'calendar' }),
                                t('header.viewEvents')
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["h" /* Dropdown */],
                        { item: true, text: t('header.Settings'), id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["h" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/setting' },
                                react_default.a.createElement(dist_es["m" /* Icon */], { name: 'setting' }),
                                t('header.globalSetting')
                            ),
                            isProfile && react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: linkToInt },
                                react_default.a.createElement(dist_es["m" /* Icon */], { name: 'cogs' }),
                                t('header.Integration')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/term' },
                                react_default.a.createElement(dist_es["m" /* Icon */], { name: 'setting' }),
                                t('header.Terms')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/faq' },
                                react_default.a.createElement(dist_es["m" /* Icon */], { name: 'setting' }),
                                t('header.FAQ')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/contact' },
                                react_default.a.createElement(dist_es["m" /* Icon */], { name: 'setting' }),
                                t('header.Contact')
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["h" /* Dropdown */],
                        { item: true, text: t('header.Report'), id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["h" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Header,
                                { style: header },
                                t('header.Summary')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/roomsummary' },
                                t('header.roomSummary')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/usersummary' },
                                t('header.userSummary')
                            ),
                            react_default.a.createElement(dist_es["h" /* Dropdown */].Divider, null),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Header,
                                { style: header },
                                t('header.reserveNotUse')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/notuse/room' },
                                t('header.Room')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/notuse/user' },
                                t('header.User')
                            ),
                            react_default.a.createElement(dist_es["h" /* Dropdown */].Divider, null),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Header,
                                { style: header },
                                t('header.Detail')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/roomreport' },
                                t('header.roomDetails')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/userreport' },
                                t('header.userDetails')
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["h" /* Dropdown */],
                        { item: true, text: t('header.Monitor'), id: 'menuHover' },
                        react_default.a.createElement(
                            dist_es["h" /* Dropdown */].Menu,
                            null,
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Header,
                                { style: header },
                                t('header.Summary')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/statussummary' },
                                t('header.Overview')
                            ),
                            react_default.a.createElement(dist_es["h" /* Dropdown */].Divider, null),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Header,
                                { style: header },
                                t('header.Status')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/overview' },
                                t('header.Room')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/overview/user/day' },
                                t('header.topUser')
                            ),
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Item,
                                { as: es["b" /* Link */], to: '/report/overview/room/day' },
                                t('header.topRooms')
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["s" /* Menu */].Menu,
                        { position: 'right' },
                        react_default.a.createElement(
                            dist_es["h" /* Dropdown */],
                            { item: true, text: t('header.Hello') + (', ' + this.state.firstName), id: 'lastMenuHover' },
                            react_default.a.createElement(
                                dist_es["h" /* Dropdown */].Menu,
                                null,
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Item,
                                    { as: es["b" /* Link */], to: '/UserInfo' },
                                    t('header.UserInformation')
                                ),
                                react_default.a.createElement(
                                    dist_es["h" /* Dropdown */].Item,
                                    { onClick: this.state.logout },
                                    '  ',
                                    react_default.a.createElement(dist_es["m" /* Icon */], { name: 'power' }),
                                    t('header.SignOut')
                                )
                            )
                        ),
                        react_default.a.createElement(tabSwitchLanguageNoBG["a" /* default */], null)
                    )
                )
            );
        }
    }]);

    return AuthHeader;
}(react_default.a.Component);

var Header_Header = function Header(_ref) {
    var isLoggedIn = _ref.isLoggedIn,
        logout = _ref.logout,
        t = _ref.t;
    return react_default.a.createElement(
        'div',
        null,
        isLoggedIn ? react_default.a.createElement(Header_AuthHeader, { logout: logout, t: t }) : react_default.a.createElement(Header_NoAuthHeader, null)
    );
};

/* harmony default export */ var components_Header = (Object(Recompose["b" /* compose */])(es["f" /* withRouter */], Object(react_redux_es["connect"])(function (state) {
    return { isLoggedIn: Object(selectors["a" /* getIsLoggedIn */])(state) };
}, function (dispatch, props) {
    return {
        logout: function logout() {

            dispatch(Object(auth_actions["d" /* logout */])());
            props.history.push('/login');
        }
    };
}))(Object(react_switch_lang["translate"])(Header_Header)));
// EXTERNAL MODULE: ./src/features/ui/components/Loadable.js
var Loadable = __webpack_require__(479);

// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Auth = {
	isAuthenticated: function isAuthenticated() {
		var bsrsToken = Object(lib["x" /* getBSRSToken */])();
		// const serviceToken = getServiceToken()

		return !!bsrsToken; /*&& !!serviceToken.service_token*/
	},
	isIntegration: function isIntegration() {
		return true;
	}
};

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/login' });
			}

			if (Auth.isIntegration() === false && props.match.url !== "/integration") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/integration' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(es["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			if (Auth.isAuthenticated() === true && props.match.url === "/login") {
				return react_default.a.createElement(es["c" /* Redirect */], { to: '/' });
			}

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};

/* harmony default export */ var routePermission = ({
	PrivateRoute: routePermission_PrivateRoute,
	PublicRoute: routePermission_PublicRoute
});
// CONCATENATED MODULE: ./src/features/ui/components/Routes.js





var AsyncHome = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1466));
	}
});

var AsyncNotFound = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 1467));
	}
});

var AsyncLoginBSRS = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(148).then(__webpack_require__.bind(null, 1468));
	}
});

var AsyncSettings = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 1469));
	}
});

var AsyncSettingsIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 1470));
	}
});

var AsyncCreateRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1473));
	}
});

var AsyncUpdateRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1474));
	}
});

var AsyncSettingsRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1475));
	}
});

var AsyncLoginO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(147).then(__webpack_require__.bind(null, 1476));
	}
});

var AsyncAuthorizeO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(149).then(__webpack_require__.bind(null, 1477));
	}
});

var AsyncCheckRoomInCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1478));
	}
});

var AsyncRoomInCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1479));
	}
});

var AsyncUserList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1480));
	}
});

var AsyncUserAdd = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 1481));
	}
});

var AsyncUserEdit = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 1482));
	}
});

var AsyncUserchangePass = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1483));
	}
});

var AsyncUserInfo = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 1484));
	}
});

var AsyncUserChangePassword = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 1485));
	}
});

var AsyncReportSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1486));
	}
});

var AsyncUserReport = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 1487));
	}
});

var AsyncRoomReportNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1488));
	}
});

var AsyncUserSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 1489));
	}
});

var AsyncRoomSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1490));
	}
});

var AsyncFacilitySummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(143).then(__webpack_require__.bind(null, 1491));
	}
});

var AsyncReserveNotUseByUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, 1492));
	}
});

var AsyncReserveNotUseByRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, 1493));
	}
});

var AsyncFoodSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, 1494));
	}
});

var AsyncDeleteEventSummary = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, 1495));
	}
});

// const AsyncSetting = Loadable({
// 	loader: () => import('../../setting/components/updateSetting')
// })

var AsyncSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1496));
	}
});

// const AsyncChangeSetting = Loadable({
// 	loader: () => import('../../setting/components/updateSetting')
// })

var AsyncListRoomsO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1497));
	}
});

var AsyncListRoomsCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1498));
	}
});

var AsyncListRoomsSubscribe = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1499));
	}
});

var AsyncCreateRoomNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1500));
	}
});

var AsyncUpdateRoomNew = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1501));
	}
});

var AsyncViewRoomCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1502));
	}
});

var AsyncListUsersCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1503));
	}
});

var AsyncListUsersO365 = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 1504));
	}
});

var AsyncListUsersAD = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1505));
	}
});

var AsyncCreateUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 1506));
	}
});

var AsyncUpdateUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1507));
	}
});

var AsyncViewUserCore = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1508));
	}
});

var AsyncAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1509));
	}
});

var AsyncAmenityUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 1510));
	}
});

var AsyncViewAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 1511));
	}
});

var AsyncAmenityCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, 1512));
	}
});

var AsyncBuildingCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1513));
	}
});
var AsyncBuildingUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1514));
	}
});
var AsyncViewBuilding = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1515));
	}
});
var AsyncBuilding = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1516));
	}
});

var AsyncBackgroundCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, 1517));
	}
});
var AsyncBackgroundUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 1518));
	}
});
var AsyncViewBackground = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1519));
	}
});
var AsyncBackground = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1520));
	}
});

var AsyncFloorCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1521));
	}
});
var AsyncFloorUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1522));
	}
});
var AsyncViewFloor = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1523));
	}
});
var AsyncFloor = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1524));
	}
});

var AsyncZoneCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1525));
	}
});
var AsyncZoneUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1526));
	}
});
var AsyncViewZone = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1527));
	}
});
var AsyncZone = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1528));
	}
});

var AsyncFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1529));
	}
});

var AsyncFbsUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 1530));
	}
});

var AsyncViewFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1531));
	}
});

var AsyncFbsCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1532));
	}
});

var AsyncListUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1533));
	}
});

var AsyncCreateUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 1534));
	}
});

var AsyncUpdateUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1535));
	}
});

var AsyncViewUserGroup = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1536));
	}
});

var AsyncCreateProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1537));
	}
});

var AsyncListProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1538));
	}
});

var AsyncUpdateProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1539));
	}
});

var AsyncViewProfile = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1540));
	}
});

var AsyncIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 1541));
	}
});

var AsyncReportOverview = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1542));
	}
});

var AsyncReportByRoom = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 1543));
	}
});

var AsyncReportByUser = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1544));
	}
});

var AsyncReportRoomDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1545));
	}
});

var AsyncReportUserDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1546));
	}
});

var AsyncReportOverviewDetail = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1547));
	}
});

var AsyncTerm = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1548));
	}
});

var AsyncEditTerm = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1549));
	}
});

var AsyncFaq = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1550));
	}
});

var AsyncEditFaq = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1551));
	}
});

var AsyncContactUs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1552));
	}
});

var AsyncEditContactUs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1553));
	}
});

var AsyncFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1554));
	}
});

var AsyncUpdateFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 1555));
	}
});

var AsyncCreateFbsCategory = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(146).then(__webpack_require__.bind(null, 1556));
	}
});
var AsyncFbsCategoryView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 1557));
	}
});

var AsyncIot = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1558));
	}
});

var AsyncIotView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1559));
	}
});

var AsyncIotUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1560));
	}
});

var AsyncExchangeIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 1561));
	}
});

var AsyncGoogleIntegrations = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 1562));
	}
});

var AsyncSettingsGoogleIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1563));
	}
});

var AsyncSettingsExchangeIntegration = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1564));
	}
});

var AsyncRegisterSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1565));
	}
});

// const AsyncDisableSeat = Loadable({
// 	loader: () => import('../../hotseat/components/pages/disableHotseatList')
// })

// const AsyncDisableSeatCreate = Loadable({
// 	loader: () => import('../../hotseat/components/pages/createDisableSeat')
// })

// const AsyncDisableSeatUpdate = Loadable({
// 	loader: () => import('../../hotseat/components/pages/updateDisableSeat')
// })

var AsyncUpdateRegisterSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 1566));
	}
});

var AsyncSeatQRCode = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1567));
	}
});

var AsyncCreateRegisterSeat = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, 1568));
	}
});

var AsyncRoomQRCode = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1569));
	}
});

var AsyncAdminViewEvents = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1570));
	}
});

var AsyncIotRoomRegis = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1571));
	}
});

var AsyncIotRoomRegisUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1572));
	}
});

var AsyncIotRoomRegisView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1573));
	}
});

var AsyncIotRoomRegisCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1574));
	}
});

var AsyncDisplayList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1575));
	}
});

var AsyncRoomDisableList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1576));
	}
});

var AsyncRoomDisableCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1577));
	}
});

var AsyncRoomDisableUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1578));
	}
});

var AsyncRoomDisableView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1579));
	}
});

var AsyncConcurrentList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1580));
	}
});

var AsyncRoleList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1581));
	}
});

var AsyncRoleCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 1582));
	}
});

var AsyncRoleView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1583));
	}
});

var AsyncRoleUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1584));
	}
});

var AsyncRoomFormatList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1585));
	}
});

var AsyncRoomFormatListCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 1586));
	}
});

var AsyncRoomFormatListView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1587));
	}
});

var AsyncRoomFormatListUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 1588));
	}
});

var AsyncOrderFbsList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1589));
	}
});

var AsyncOrderFbsUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1590));
	}
});

var AsyncOrderCreateFbs = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1591));
	}
});

var AsyncOrderCreateAmenity = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1592));
	}
});

var AsyncOrderAmenityList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1593));
	}
});

var AsyncOrderAmenityUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1594));
	}
});

var AsyncReportFoodSummaryByEvent = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1595));
	}
});

var AsyncReportFacilitySummaryByEvent = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1596));
	}
});

var AsyncViewEventsOrder = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1597));
	}
});

var AsyncEventTypeList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1598));
	}
});

var AsyncEventTypeView = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1599));
	}
});

var AsyncEventTypeCreate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, 1600));
	}
});

var AsyncEventTypeUpdate = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 1601));
	}
});

var AsyncHotdeskViewTemporaryClosedList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1602));
	}
});

var AsyncHotdeskViewTemporaryClosed = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1603));
	}
});

var AsyncHotdeskCreateTemporaryClosed = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1604));
	}
});

var AsyncHotdeskUpdateTemporaryClosed = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1605));
	}
});

var AsyncHotdeskCreateRole = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 1606));
	}
});
var AsyncHotdeskUpdateRole = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 1607));
	}
});
var AsyncHotdeskViewRole = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 1608));
	}
});
var AsyncHotdeskRoleList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, 1609));
	}
});

var AsyncAvailableTimeSlotList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(145).then(__webpack_require__.bind(null, 1610));
	}
});
var AsyncCreateAvailableTimeSlot = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, 1611));
	}
});
var AsyncUpdateAvailableTimeSlot = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, 1612));
	}
});
var AsyncViewAvailableTimeSlot = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, 1613));
	}
});

var AsyncAllControlList = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1614));
	}
});
var LogoSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 1615));
	}
});

var LogoUpdateSetting = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 1616));
	}
});
var SessionExpire = Object(Loadable["a" /* default */])({
	loader: function loader() {
		return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, 1617));
	}
});
/* harmony default export */ var Routes = (function () {
	return react_default.a.createElement(
		es["e" /* Switch */],
		null,
		react_default.a.createElement(routePermission.PrivateRoute, { exact: true, path: '/', component: AsyncHome }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/integration', component: AsyncIntegrations }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/exchangeIntegration', component: AsyncExchangeIntegrations }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/googleIntegration', component: AsyncGoogleIntegrations }),
		react_default.a.createElement(routePermission.PublicRoute, { path: '/login', component: AsyncLoginBSRS }),
		react_default.a.createElement(routePermission.PublicRoute, { path: '/sessionExpire', component: SessionExpire }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/integration', component: AsyncSettingsIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/googleIntegration', component: AsyncSettingsGoogleIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/exchangeIntegration', component: AsyncSettingsExchangeIntegration }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/room/create/:email', component: AsyncCreateRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings/room/update/:email', component: AsyncUpdateRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/term', component: AsyncTerm }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editterm', component: AsyncEditTerm }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/regisseat/create/:id', component: AsyncCreateRegisterSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/regisseat/update/:id', component: AsyncUpdateRegisterSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/regisseat/qrcode/:id', component: AsyncSeatQRCode }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/registerseat', component: AsyncRegisterSeat }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/faq', component: AsyncFaq }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editfaq', component: AsyncEditFaq }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/contact', component: AsyncContactUs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/editcontact', component: AsyncEditContactUs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting', component: AsyncSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/system', component: AsyncListRoomsO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/core/qrcode/:email', component: AsyncRoomQRCode }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/core', component: AsyncListRoomsCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/subscribe', component: AsyncListRoomsSubscribe }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/create', component: AsyncCreateRoomNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/update/:email', component: AsyncUpdateRoomNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/view/:email', component: AsyncViewRoomCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/o365', component: AsyncListUsersO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/ad', component: AsyncListUsersAD }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/core', component: AsyncListUsersCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/create', component: AsyncCreateUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/update/:id', component: AsyncUpdateUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/view/:id', component: AsyncViewUserCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/list', component: AsyncListUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/create', component: AsyncCreateUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/update/:id', component: AsyncUpdateUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/group/view/:id', component: AsyncViewUserGroup }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/list', component: AsyncListProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/create', component: AsyncCreateProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/update/:id', component: AsyncUpdateProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/profile/view/:id', component: AsyncViewProfile }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/create', component: AsyncAmenityCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/update/:id', component: AsyncAmenityUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity/view/:id', component: AsyncViewAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/amenity', component: AsyncAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/create', component: AsyncBuildingCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/update/:id', component: AsyncBuildingUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building/view/:id', component: AsyncViewBuilding }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/building', component: AsyncBuilding }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/create', component: AsyncBackgroundCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/update/:id', component: AsyncBackgroundUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background/view/:id', component: AsyncViewBackground }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/background', component: AsyncBackground }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/create', component: AsyncFloorCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/update/:id', component: AsyncFloorUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor/view/:id', component: AsyncViewFloor }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/floor', component: AsyncFloor }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/create', component: AsyncZoneCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/update/:id', component: AsyncZoneUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone/view/:id', component: AsyncViewZone }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/zone', component: AsyncZone }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype/create', component: AsyncEventTypeCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype/update/:id', component: AsyncEventTypeUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype/view/:id', component: AsyncEventTypeView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/eventtype', component: AsyncEventTypeList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/view/:id', component: AsyncRoleView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/update/:id', component: AsyncRoleUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/list', component: AsyncRoleList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/role/create', component: AsyncRoleCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/update/:id', component: AsyncUpdateFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/create', component: AsyncCreateFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory/:id', component: AsyncFbsCategoryView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbsCategory', component: AsyncFbsCategory }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/create', component: AsyncFbsCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/update/:id', component: AsyncFbsUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs/view/:id', component: AsyncViewFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/fbs', component: AsyncFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/settings', component: AsyncSettings }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/room/list', component: AsyncSettingsRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/logino365', component: AsyncLoginO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/authorize', component: AsyncAuthorizeO365 }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/checkroom/:email', component: AsyncCheckRoomInCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/userInfo', component: AsyncUserInfo }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/changepassword/:id', component: AsyncUserChangePassword }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/core/myroom', component: AsyncRoomInCore }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview/:type/:range', component: AsyncReportOverviewDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/user/:id', component: AsyncReportUserDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/room/:email', component: AsyncReportRoomDetail }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/statussummary', component: AsyncReportSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/overview', component: AsyncReportOverview }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/byroom', component: AsyncReportByRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/byuser', component: AsyncReportByUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/roomreport', component: AsyncRoomReportNew }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/userreport', component: AsyncUserReport }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/usersummary', component: AsyncUserSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/roomsummary', component: AsyncRoomSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/deleteeventsummary', component: AsyncDeleteEventSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/foodsummary', component: AsyncFoodSummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/facilitysummary', component: AsyncFacilitySummary }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/foodsummarybyevent', component: AsyncReportFoodSummaryByEvent }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/facilitysummarybyevent', component: AsyncReportFacilitySummaryByEvent }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/notuse/user', component: AsyncReserveNotUseByUser }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/report/notuse/room', component: AsyncReserveNotUseByRoom }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/list', component: AsyncUserList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/add', component: AsyncUserAdd }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/edit/:id', component: AsyncUserEdit }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/setting/user/changepass/:id', component: AsyncUserchangePass }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iotView/:id', component: AsyncIotView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iotUpdate/:id', component: AsyncIotUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iot', component: AsyncIot }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iotRoom/update/:id', component: AsyncIotRoomRegisUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iotRoom/view/:id', component: AsyncIotRoomRegisView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iotRoom/create', component: AsyncIotRoomRegisCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/iotRoom', component: AsyncIotRoomRegis }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/display', component: AsyncDisplayList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable/update/:id', component: AsyncRoomDisableUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable/view/:id', component: AsyncRoomDisableView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable/create', component: AsyncRoomDisableCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomdisable', component: AsyncRoomDisableList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/user/concurrent', component: AsyncConcurrentList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat/view/:id', component: AsyncRoomFormatListView }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat/update/:id', component: AsyncRoomFormatListUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat/create', component: AsyncRoomFormatListCreate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/roomformat', component: AsyncRoomFormatList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderfbs/create/:icaluid/:roomemail', component: AsyncOrderCreateFbs }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderfbs/update/:id', component: AsyncOrderFbsUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/order', component: AsyncOrderFbsList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity/create/:icaluid/:roomemail', component: AsyncOrderCreateAmenity }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity/update/:id', component: AsyncOrderAmenityUpdate }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/orderamenity', component: AsyncOrderAmenityList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/events/order', component: AsyncViewEventsOrder }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/events', component: AsyncAdminViewEvents }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/temporaryclosed/update/:id', component: AsyncHotdeskUpdateTemporaryClosed }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/temporaryclosed/create', component: AsyncHotdeskCreateTemporaryClosed }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/temporaryclosed/:id', component: AsyncHotdeskViewTemporaryClosed }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/temporaryclosed', component: AsyncHotdeskViewTemporaryClosedList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/role/view/:id', component: AsyncHotdeskViewRole }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/role/update/:id', component: AsyncHotdeskUpdateRole }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/role/create', component: AsyncHotdeskCreateRole }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/role', component: AsyncHotdeskRoleList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/availabletimeslot/view/:id', component: AsyncViewAvailableTimeSlot }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/availabletimeslot/update/:id', component: AsyncUpdateAvailableTimeSlot }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/availabletimeslot/create', component: AsyncCreateAvailableTimeSlot }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/hotdesk/availabletimeslot', component: AsyncAvailableTimeSlotList }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/logo/update', component: LogoUpdateSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/logo', component: LogoSetting }),
		react_default.a.createElement(routePermission.PrivateRoute, { path: '/allcontrol', component: AsyncAllControlList }),
		react_default.a.createElement(routePermission.PrivateRoute, { component: AsyncNotFound })
	);
});
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(892);
var package_default = /*#__PURE__*/__webpack_require__.n(package_0);

// CONCATENATED MODULE: ./src/features/ui/components/Footer.js





/* harmony default export */ var Footer = (function (props) {
    return react_default.a.createElement(
        dist_es["s" /* Menu */],
        { secondary: true, fixed: 'bottom', style: { height: '55px' } },
        react_default.a.createElement(
            dist_es["k" /* Grid */],
            { style: { margin: '1em 0em 0em', backgroundColor: "#333", color: '#ccc', width: '100%', textAlign: 'right' } },
            react_default.a.createElement(
                dist_es["k" /* Grid */].Row,
                null,
                react_default.a.createElement(
                    dist_es["k" /* Grid */].Column,
                    { width: '9' },
                    props.setting ? props.setting.backendFooter : lib["a" /* COPYRIGHT */]
                ),
                react_default.a.createElement(
                    dist_es["k" /* Grid */].Column,
                    { width: '7' },
                    react_default.a.createElement(
                        'div',
                        null,
                        'Version',
                        ' ' + package_0["version"]
                    )
                )
            )
        )
    );
});
// EXTERNAL MODULE: ./src/features/setting/actions.js
var setting_actions = __webpack_require__(485);

// EXTERNAL MODULE: ./src/features/setting/selectors.js
var setting_selectors = __webpack_require__(481);

// CONCATENATED MODULE: ./src/features/ui/components/App.js
var App__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function App__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function App__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function App__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// export default () => (
//     <div>
//         <Header />
//         <Container style={{ minHeight: '219px',marginBottom: '5rem' }}>
//             <Routes />
//         </Container>
//         <Footer />
//     </div>
// )

var App_App = function (_React$Component) {
    App__inherits(App, _React$Component);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        App__classCallCheck(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = App__possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
            document.title = lib["P" /* pageTitle */];
        }, _temp), App__possibleConstructorReturn(_this, _ret);
    }

    App__createClass(App, [{
        key: 'render',
        value: function render() {
            return react_default.a.createElement(
                'div',
                null,
                react_default.a.createElement(components_Header, null),
                react_default.a.createElement(
                    dist_es["e" /* Container */],
                    { style: { minHeight: '219px', marginBottom: '5rem' } },
                    react_default.a.createElement(Routes, null)
                ),
                react_default.a.createElement(Footer, { setting: this.props.setting })
            );
        }
    }]);

    return App;
}(react_default.a.Component);
// export default (App)


/* harmony default export */ var components_App = (Object(Recompose["b" /* compose */])(es["f" /* withRouter */], Object(react_redux_es["connect"])(function (state, props) {
    return {
        setting: Object(setting_selectors["e" /* getSettingInfo */])(state)
    };
}, function (dispatch, history) {
    return {
        findSettingInfo: function findSettingInfo() {
            dispatch(Object(setting_actions["f" /* findSettingInfo */])());
        }
    };
}), Object(Recompose["c" /* lifecycle */])({
    componentDidMount: function componentDidMount() {
        if (!Object(lib["y" /* getBackendFooter */])() && Object(lib["x" /* getBSRSToken */])()) this.props.findSettingInfo();
    }
}))(App_App));
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js








var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
	return react_default.a.createElement(
		react_redux_es["Provider"],
		{ store: store },
		react_default.a.createElement(
			'div',
			null,
			react_default.a.createElement(
				es["a" /* BrowserRouter */],
				null,
				react_default.a.createElement(components_App, null)
			),
			react_default.a.createElement(ErrorMessageDialog, null),
			react_default.a.createElement(Loading, null)
		)
	);
});

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(517);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(90);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(518);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(160);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(495);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(630);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(10);

// EXTERNAL MODULE: ./src/lib/index.js + 5 modules
var src_lib = __webpack_require__(39);

// CONCATENATED MODULE: ./src/features/auth/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var allToken = Object(src_lib["w" /* getAllToken */])();
var bsrsToken = Object(src_lib["x" /* getBSRSToken */])();
var serviceToken = Object(src_lib["I" /* getServiceToken */])();

var reducer_initialState = {
  token: allToken,
  bsrsToken: bsrsToken,
  user: Object(src_lib["M" /* getUserInfo */])(allToken.access_token),
  serviceToken: serviceToken
};

/* harmony default export */ var reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
  var action = arguments[1];

  switch (action.type) {
    case types["_585" /* O365_REGISTER_SUCCESS */]:
      {
        return _extends({}, state, {
          token: _extends({}, action.payload.token),
          user: Object(src_lib["M" /* getUserInfo */])(action.payload.token.access_token)
        });
      }
    case types["c" /* BSRS_LOGIN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken
        });
      }
    case types["f" /* BSRS_SERVICE_TOKEN_SUCCESS */]:
      {
        return _extends({}, state, {
          bsrsToken: action.payload.bsrsToken,
          serviceToken: action.payload.serviceToken
        });
      }
    case types["_543" /* LOGOUT */]:
      return _extends({}, state, {
        bsrsToken: undefined
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/features/ui/reducer.js
var reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var ui_reducer_initialState = {
    hasError: false,
    isLoading: false,
    error: null
};

/* harmony default export */ var ui_reducer = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
        case types["_18" /* CORE_CREATE_ORDER_REQUEST */]:
        case types["_395" /* CORE_LOAD_USER_INFO_REQUEST */]:
        case types["_584" /* O365_REGISTER_REQUEST */]:
        case types["_102" /* CORE_DELETE_ROOM_REQUEST */]:
        case types["_563" /* O365_LOAD_EVENTS_REQUEST */]:
        case types["_566" /* O365_LOAD_EVENT_REQUEST */]:
        case types["_581" /* O365_LOAD_USER_INFO_REQUEST */]:
        case types["_548" /* O365_CREATE_EVENT_REQUEST */]:
        case types["_557" /* O365_DELETE_EVENT_REQUEST */]:
        case types["_545" /* O365_ACCEPT_EVENT_REQUEST */]:
        case types["_587" /* O365_TENTATIVE_EVENT_REQUEST */]:
        case types["_554" /* O365_DECLINE_EVENT_REQUEST */]:
        case types["_292" /* CORE_LOAD_ORDERS_REQUEST */]:
        case types["_120" /* CORE_FIND_ROOM_REQUEST */]:
        case types["_397" /* CORE_LOAD_USER_REQUEST */]:
        case types["_535" /* CORE_UPDATE_USER_REQUEST */]:
        case types["_111" /* CORE_DELETE_USER_REQUEST */]:
        case types["_391" /* CORE_LOAD_USERS_REQUEST */]:
        case types["_337" /* CORE_LOAD_ROOMS_REQUEST */]:
        case types["_523" /* CORE_UPDATE_ROOM_REQUEST */]:
        case types["_355" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
        case types["_364" /* CORE_LOAD_TERM_REQUEST */]:
        case types["_529" /* CORE_UPDATE_TERM_REQUEST */]:
        case types["_259" /* CORE_LOAD_FAQ_REQUEST */]:
        case types["_238" /* CORE_LOAD_CONTACT_US_REQUEST */]:
        case types["_310" /* CORE_LOAD_REPORTROOMSTATUS_REQUEST */]:
        case types["_325" /* CORE_LOAD_ROOMDETAIL_REQUEST */]:
        case types["b" /* BSRS_LOGIN_REQUEST */]:
        case types["_196" /* CORE_LOAD_ALL_CATEGORY_REQUEST */]:
        case types["_262" /* CORE_LOAD_FBSINFO_REQUEST */]:
        case types["_72" /* CORE_DELETE_FBS_REQUEST */]:
        case types["_289" /* CORE_LOAD_LOCATIONS_REQUEST */]:
        case types["_223" /* CORE_LOAD_AMENITYINFO_REQUEST */]:
        case types["_181" /* CORE_LOAD_ALLFLOOR_REQUEST */]:
        case types["_265" /* CORE_LOAD_FLOORINFO_REQUEST */]:
        case types["_172" /* CORE_LOAD_ALLBUILDING_REQUEST */]:
        case types["_232" /* CORE_LOAD_BUILDINGINFO_REQUEST */]:
        case types["_169" /* CORE_LOAD_ALLBACKGROUND_REQUEST */]:
        case types["_51" /* CORE_DELETE_BACKGROUND_REQUEST */]:
        case types["_229" /* CORE_LOAD_BACKGROUNDINFO_REQUEST */]:
        case types["_448" /* CORE_UPDATE_BACKGROUNDINFO_REQUEST */]:
        case types["L" /* CORE_CREATE_BACKGROUND_REQUEST */]:
        case types["_54" /* CORE_DELETE_BUILDING_REQUEST */]:
        case types["_451" /* CORE_UPDATE_BUILDINGINFO_REQUEST */]:
        case types["O" /* CORE_CREATE_BUILDING_REQUEST */]:
        case types["_78" /* CORE_DELETE_FLOOR_REQUEST */]:
        case types["_490" /* CORE_UPDATE_FLOORINFO_REQUEST */]:
        case types["_6" /* CORE_CREATE_FLOOR_REQUEST */]:
        case types["_187" /* CORE_LOAD_ALLZONE_REQUEST */]:
        case types["_114" /* CORE_DELETE_ZONE_REQUEST */]:
        case types["_403" /* CORE_LOAD_ZONEINFO_REQUEST */]:
        case types["_538" /* CORE_UPDATE_ZONEINFO_REQUEST */]:
        case types["_42" /* CORE_CREATE_ZONE_REQUEST */]:
        case types["_487" /* CORE_UPDATE_FB_CATEGORY_REQUEST */]:
        case types["_129" /* CORE_GET_CATEGORY_INFO_REQUEST */]:
        case types["_3" /* CORE_CREATE_FB_CATEGORY_REQUEST */]:
        case types["_75" /* CORE_DELETE_FB_CATEGORY_REQUEST */]:
        case types["_30" /* CORE_CREATE_ROOM_REQUEST */]:
        case types["_575" /* O365_LOAD_ROOMS_REQUEST */]:
        case types["_339" /* CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST */]:
        case types["_560" /* O365_DELETE_ROOM_SUBSCRIBE_REQUEST */]:
        case types["_551" /* O365_CREATE_ROOM_SUBSCRIBE_REQUEST */]:
        case types["_178" /* CORE_LOAD_ALLFBS_REQUEST */]:
        case types["_484" /* CORE_UPDATE_FBSINFO_REQUEST */]:
        case types["_0" /* CORE_CREATE_FBS_REQUEST */]:
        case types["_376" /* CORE_LOAD_USERGROUPS_REQUEST */]:
        case types["_283" /* CORE_LOAD_LIST_USERGROUPS_REQUEST */]:
        case types["_379" /* CORE_LOAD_USERGROUP_REQUEST */]:
        case types["_36" /* CORE_CREATE_USERGROUP_REQUEST */]:
        case types["_532" /* CORE_UPDATE_USERGROUP_REQUEST */]:
        case types["_108" /* CORE_DELETE_USERGROUP_REQUEST */]:
        case types["k" /* CORE_CHANGE_SETTING_REQUEST */]:
        case types["t" /* CORE_CHECK_AD_REQUEST */]:
        case types["_39" /* CORE_CREATE_USER_REQUEST */]:
        case types["h" /* CORE_CHANGE_PASSWORD_REQUEST */]:
        case types["_578" /* O365_LOAD_USERS_REQUEST */]:
        case types["_220" /* CORE_LOAD_ALL_USERSAD_REQUEST */]:
        case types["_211" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        case types["_21" /* CORE_CREATE_PROFILE_REQUEST */]:
        case types["_93" /* CORE_DELETE_PROFILE_REQUEST */]:
        case types["_307" /* CORE_LOAD_PROFILE_INFO_REQUEST */]:
        case types["_514" /* CORE_UPDATE_PROFILE_REQUEST */]:
        case types["_460" /* CORE_UPDATE_DEFAULTBACKGROUND_REQUEST */]:
        case types["_166" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        case types["_45" /* CORE_DELETE_AMENITY_REQUEST */]:
        case types["_442" /* CORE_UPDATE_AMENITYINFO_REQUEST */]:
        case types["F" /* CORE_CREATE_AMENITY_REQUEST */]:
        case types["_313" /* CORE_LOAD_REPORTSUMMARY_REQUEST */]:
        case types["_352" /* CORE_LOAD_SEAT_ZONE_INFO_REQUEST */]:
        case types["_60" /* CORE_DELETE_DISABLESEATINFO_REQUEST */]:
        case types["_418" /* CORE_SEARCH_ROOMS_REQUEST */]:
        case types["_412" /* CORE_SEARCH_FLOOR_REQUEST */]:
        case types["_424" /* CORE_SEARCH_ZONE_REQUEST */]:
        case types["_415" /* CORE_SEARCH_IOT_REQUEST */]:
        case types["_421" /* CORE_SEARCH_USERS_REQUEST */]:
        case types["_409" /* CORE_SEARCH_FBS_REQUEST */]:
        case types["n" /* CORE_CHECKIN_REQUEST */]:
        case types["_66" /* CORE_DELETE_EVENT_REQUEST */]:
        case types["q" /* CORE_CHECKOUT_REQUEST */]:
        case types["_406" /* CORE_RESET_PASSWORD_REQUEST */]:
        case types["_279" /* CORE_LOAD_IOT_ROOMREGIS_REQUEST */]:
        case types["_143" /* CORE_GET_IOT_ROOMREGIS_INFO_REQUEST */]:
        case types["_15" /* CORE_CREATE_IOT_ROOMREGIS_REQUEST */]:
        case types["_84" /* CORE_DELETE_IOT_ROOMREGIS_REQUEST */]:
        case types["_244" /* CORE_LOAD_DISPLAY_REQUEST */]:
        case types["_466" /* CORE_UPDATE_DISPLAY_REQUEST */]:
        case types["_214" /* CORE_LOAD_ALL_ROOMDISABLE_REQUEST */]:
        case types["_328" /* CORE_LOAD_ROOMDISABLE_REQUEST */]:
        case types["_27" /* CORE_CREATE_ROOMDISABLE_REQUEST */]:
        case types["_520" /* CORE_UPDATE_ROOMDISABLE_REQUEST */]:
        case types["_99" /* CORE_DELETE_ROOMDISABLE_REQUEST */]:
        case types["_57" /* CORE_DELETE_CONCURRENT_REQUEST */]:
        case types["C" /* CORE_CHECK_TMS_REQUEST */]:
        case types["z" /* CORE_CHECK_CMR_REQUEST */]:
        case types["w" /* CORE_CHECK_BOT_REQUEST */]:
        case types["_298" /* CORE_LOAD_ORDER_AMENITY_REQUEST */]:
        case types["_572" /* O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST */]:
        case types["_275" /* CORE_LOAD_IOT_MODULE_REQUEST */]:
        case types["_12" /* CORE_CREATE_IOT_MODULE_REQUEST */]:
        case types["_271" /* CORE_LOAD_IOTINFO_REQUEST */]:
        case types["_499" /* CORE_UPDATE_IOTINFO_REQUEST */]:
        case types["_140" /* CORE_GET_IOT_INFO_WITH_MODULE_REQUEST */]:
        case types["_123" /* CORE_GET_ALL_IOT_MODULE_REQUEST */]:
        case types["_33" /* CORE_CREATE_TEMP_CLOSE_REQUEST */]:
        case types["_9" /* CORE_CREATE_HOTDESK_ROLE_REQUEST */]:
        case types["_493" /* CORE_UPDATE_HOTDESK_ROLE_REQUEST */]:
        case types["_81" /* CORE_DELETE_HOTDESK_ROLE_REQUEST */]:
        case types["_202" /* CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST */]:
        case types["_268" /* CORE_LOAD_HOTDESK_ROLE_REQUEST */]:
            return reducer__extends({}, state, {
                isLoading: true,
                hasError: false,
                error: null
            });
        case types["_19" /* CORE_CREATE_ORDER_SUCCESS */]:
        case types["_396" /* CORE_LOAD_USER_INFO_SUCCESS */]:
        case types["_585" /* O365_REGISTER_SUCCESS */]:
        case types["_564" /* O365_LOAD_EVENTS_SUCCESS */]:
        case types["_567" /* O365_LOAD_EVENT_SUCCESS */]:
        case types["_582" /* O365_LOAD_USER_INFO_SUCCESS */]:
        case types["_549" /* O365_CREATE_EVENT_SUCCESS */]:
        case types["_558" /* O365_DELETE_EVENT_SUCCESS */]:
        case types["_546" /* O365_ACCEPT_EVENT_SUCCESS */]:
        case types["_588" /* O365_TENTATIVE_EVENT_SUCCESS */]:
        case types["_555" /* O365_DECLINE_EVENT_SUCCESS */]:
        case types["_293" /* CORE_LOAD_ORDERS_SUCCESS */]:
        case types["_121" /* CORE_FIND_ROOM_SUCCESS */]:
        case types["_103" /* CORE_DELETE_ROOM_SUCCESS */]:
        case types["_398" /* CORE_LOAD_USER_SUCCESS */]:
        case types["_536" /* CORE_UPDATE_USER_SUCCESS */]:
        case types["_112" /* CORE_DELETE_USER_SUCCESS */]:
        case types["_392" /* CORE_LOAD_USERS_SUCCESS */]:
        case types["_341" /* CORE_LOAD_ROOMS_SUCCESS */]:
        case types["_524" /* CORE_UPDATE_ROOM_SUCCESS */]:
        case types["_356" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
        case types["_365" /* CORE_LOAD_TERM_SUCCESS */]:
        case types["_530" /* CORE_UPDATE_TERM_SUCCESS */]:
        case types["_260" /* CORE_LOAD_FAQ_SUCCESS */]:
        case types["_239" /* CORE_LOAD_CONTACT_US_SUCCESS */]:
        case types["_311" /* CORE_LOAD_REPORTROOMSTATUS_SUCCESS */]:
        case types["_326" /* CORE_LOAD_ROOMDETAIL_SUCCESS */]:
        case types["_197" /* CORE_LOAD_ALL_CATEGORY_SUCCESS */]:
        case types["_263" /* CORE_LOAD_FBSINFO_SUCCESS */]:
        case types["_73" /* CORE_DELETE_FBS_SUCCESS */]:
        case types["_290" /* CORE_LOAD_LOCATIONS_SUCCESS */]:
        case types["_224" /* CORE_LOAD_AMENITYINFO_SUCCESS */]:
        case types["_182" /* CORE_LOAD_ALLFLOOR_SUCCESS */]:
        case types["_266" /* CORE_LOAD_FLOORINFO_SUCCESS */]:
        case types["_173" /* CORE_LOAD_ALLBUILDING_SUCCESS */]:
        case types["_233" /* CORE_LOAD_BUILDINGINFO_SUCCESS */]:
        case types["_170" /* CORE_LOAD_ALLBACKGROUND_SUCCESS */]:
        case types["_52" /* CORE_DELETE_BACKGROUND_SUCCESS */]:
        case types["_230" /* CORE_LOAD_BACKGROUNDINFO_SUCCESS */]:
        case types["_449" /* CORE_UPDATE_BACKGROUNDINFO_SUCCESS */]:
        case types["M" /* CORE_CREATE_BACKGROUND_SUCCESS */]:
        case types["_55" /* CORE_DELETE_BUILDING_SUCCESS */]:
        case types["_452" /* CORE_UPDATE_BUILDINGINFO_SUCCESS */]:
        case types["P" /* CORE_CREATE_BUILDING_SUCCESS */]:
        case types["_79" /* CORE_DELETE_FLOOR_SUCCESS */]:
        case types["_491" /* CORE_UPDATE_FLOORINFO_SUCCESS */]:
        case types["_7" /* CORE_CREATE_FLOOR_SUCCESS */]:
        case types["_188" /* CORE_LOAD_ALLZONE_SUCCESS */]:
        case types["_115" /* CORE_DELETE_ZONE_SUCCESS */]:
        case types["_404" /* CORE_LOAD_ZONEINFO_SUCCESS */]:
        case types["_539" /* CORE_UPDATE_ZONEINFO_SUCCESS */]:
        case types["_43" /* CORE_CREATE_ZONE_SUCCESS */]:
        case types["_488" /* CORE_UPDATE_FB_CATEGORY_SUCCESS */]:
        case types["_130" /* CORE_GET_CATEGORY_INFO_SUCCESS */]:
        case types["_4" /* CORE_CREATE_FB_CATEGORY_SUCCESS */]:
        case types["_76" /* CORE_DELETE_FB_CATEGORY_SUCCESS */]:
        case types["_31" /* CORE_CREATE_ROOM_SUCCESS */]:
        case types["_576" /* O365_LOAD_ROOMS_SUCCESS */]:
        case types["_340" /* CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS */]:
        case types["_561" /* O365_DELETE_ROOM_SUBSCRIBE_SUCCESS */]:
        case types["_552" /* O365_CREATE_ROOM_SUBSCRIBE_SUCCESS */]:
        case types["_179" /* CORE_LOAD_ALLFBS_SUCCESS */]:
        case types["_485" /* CORE_UPDATE_FBSINFO_SUCCESS */]:
        case types["_1" /* CORE_CREATE_FBS_SUCCESS */]:
        case types["_377" /* CORE_LOAD_USERGROUPS_SUCCESS */]:
        case types["_284" /* CORE_LOAD_LIST_USERGROUPS_SUCCESS */]:
        case types["_380" /* CORE_LOAD_USERGROUP_SUCCESS */]:
        case types["_37" /* CORE_CREATE_USERGROUP_SUCCESS */]:
        case types["_533" /* CORE_UPDATE_USERGROUP_SUCCESS */]:
        case types["_109" /* CORE_DELETE_USERGROUP_SUCCESS */]:
        case types["l" /* CORE_CHANGE_SETTING_SUCCESS */]:
        case types["u" /* CORE_CHECK_AD_SUCCESS */]:
        case types["_40" /* CORE_CREATE_USER_SUCCESS */]:
        case types["i" /* CORE_CHANGE_PASSWORD_SUCCESS */]:
        case types["_579" /* O365_LOAD_USERS_SUCCESS */]:
        case types["_221" /* CORE_LOAD_ALL_USERSAD_SUCCESS */]:
        case types["_212" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        case types["_22" /* CORE_CREATE_PROFILE_SUCCESS */]:
        case types["_94" /* CORE_DELETE_PROFILE_SUCCESS */]:
        case types["_308" /* CORE_LOAD_PROFILE_INFO_SUCCESS */]:
        case types["_515" /* CORE_UPDATE_PROFILE_SUCCESS */]:
        case types["_461" /* CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS */]:
        case types["_167" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        case types["_46" /* CORE_DELETE_AMENITY_SUCCESS */]:
        case types["_443" /* CORE_UPDATE_AMENITYINFO_SUCCESS */]:
        case types["G" /* CORE_CREATE_AMENITY_SUCCESS */]:
        case types["_314" /* CORE_LOAD_REPORTSUMMARY_SUCCESS */]:
        case types["_353" /* CORE_LOAD_SEAT_ZONE_INFO_SUCCESS */]:
        case types["_61" /* CORE_DELETE_DISABLESEATINFO_SUCCESS */]:
        case types["_419" /* CORE_SEARCH_ROOMS_SUCCESS */]:
        case types["_413" /* CORE_SEARCH_FLOOR_SUCCESS */]:
        case types["_425" /* CORE_SEARCH_ZONE_SUCCESS */]:
        case types["_416" /* CORE_SEARCH_IOT_SUCCESS */]:
        case types["_422" /* CORE_SEARCH_USERS_SUCCESS */]:
        case types["_410" /* CORE_SEARCH_FBS_SUCCESS */]:
        case types["o" /* CORE_CHECKIN_SUCCESS */]:
        case types["_70" /* CORE_DELETE_EVENT_SUCCESS */]:
        case types["r" /* CORE_CHECKOUT_SUCCESS */]:
        case types["_407" /* CORE_RESET_PASSWORD_SUCCESS */]:
        case types["_280" /* CORE_LOAD_IOT_ROOMREGIS_SUCCESS */]:
        case types["_144" /* CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS */]:
        case types["_16" /* CORE_CREATE_IOT_ROOMREGIS_SUCCESS */]:
        case types["_85" /* CORE_DELETE_IOT_ROOMREGIS_SUCCESS */]:
        case types["_245" /* CORE_LOAD_DISPLAY_SUCCESS */]:
        case types["_467" /* CORE_UPDATE_DISPLAY_SUCCESS */]:
        case types["_215" /* CORE_LOAD_ALL_ROOMDISABLE_SUCCESS */]:
        case types["_329" /* CORE_LOAD_ROOMDISABLE_SUCCESS */]:
        case types["_28" /* CORE_CREATE_ROOMDISABLE_SUCCESS */]:
        case types["_521" /* CORE_UPDATE_ROOMDISABLE_SUCCESS */]:
        case types["_100" /* CORE_DELETE_ROOMDISABLE_SUCCESS */]:
        case types["_58" /* CORE_DELETE_CONCURRENT_SUCCESS */]:
        case types["D" /* CORE_CHECK_TMS_SUCCESS */]:
        case types["A" /* CORE_CHECK_CMR_SUCCESS */]:
        case types["x" /* CORE_CHECK_BOT_SUCCESS */]:
        case types["_299" /* CORE_LOAD_ORDER_AMENITY_SUCCESS */]:
        case types["_573" /* O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS */]:
        case types["_276" /* CORE_LOAD_IOT_MODULE_SUCCESS */]:
        case types["_13" /* CORE_CREATE_IOT_MODULE_SUCCESS */]:
        case types["_272" /* CORE_LOAD_IOTINFO_SUCCESS */]:
        case types["_500" /* CORE_UPDATE_IOTINFO_SUCCESS */]:
        case types["_141" /* CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS */]:
        case types["_124" /* CORE_GET_ALL_IOT_MODULE_SUCCESS */]:
        case types["_34" /* CORE_CREATE_TEMP_CLOSE_SUCCESS */]:
        case types["_10" /* CORE_CREATE_HOTDESK_ROLE_SUCCESS */]:
        case types["_494" /* CORE_UPDATE_HOTDESK_ROLE_SUCCESS */]:
        case types["_82" /* CORE_DELETE_HOTDESK_ROLE_SUCCESS */]:
        case types["_203" /* CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS */]:
        case types["_269" /* CORE_LOAD_HOTDESK_ROLE_SUCCESS */]:
            return reducer__extends({}, state, {
                isLoading: false
                // hasError: false,
                // error: null,
            });
        case types["_17" /* CORE_CREATE_ORDER_FAILURE */]:
        case types["_394" /* CORE_LOAD_USER_INFO_FAILURE */]:
        case types["_580" /* O365_LOAD_USER_INFO_FAILURE */]:
        case types["_565" /* O365_LOAD_EVENT_FAILURE */]:
        case types["_562" /* O365_LOAD_EVENTS_FAILURE */]:
        case types["_547" /* O365_CREATE_EVENT_FAILURE */]:
        case types["_556" /* O365_DELETE_EVENT_FAILURE */]:
        case types["_544" /* O365_ACCEPT_EVENT_FAILURE */]:
        case types["_586" /* O365_TENTATIVE_EVENT_FAILURE */]:
        case types["_553" /* O365_DECLINE_EVENT_FAILURE */]:
        case types["_291" /* CORE_LOAD_ORDERS_FAILURE */]:
        case types["_119" /* CORE_FIND_ROOM_FAILURE */]:
        case types["_101" /* CORE_DELETE_ROOM_FAILURE */]:
        case types["_393" /* CORE_LOAD_USER_FAILURE */]:
        case types["_534" /* CORE_UPDATE_USER_FAILURE */]:
        case types["_110" /* CORE_DELETE_USER_FAILURE */]:
        case types["_390" /* CORE_LOAD_USERS_FAILURE */]:
        case types["_336" /* CORE_LOAD_ROOMS_FAILURE */]:
        case types["_522" /* CORE_UPDATE_ROOM_FAILURE */]:
        case types["_354" /* CORE_LOAD_SETTING_INFO_FAILURE */]:
        case types["_363" /* CORE_LOAD_TERM_FAILURE */]:
        case types["_528" /* CORE_UPDATE_TERM_FAILURE */]:
        case types["_258" /* CORE_LOAD_FAQ_FAILURE */]:
        case types["_237" /* CORE_LOAD_CONTACT_US_FAILURE */]:
        case types["_309" /* CORE_LOAD_REPORTROOMSTATUS_FAILURE */]:
        case types["_324" /* CORE_LOAD_ROOMDETAIL_FAILURE */]:
        case types["a" /* BSRS_LOGIN_FAILURE */]:
        case types["_195" /* CORE_LOAD_ALL_CATEGORY_FAILURE */]:
        case types["_261" /* CORE_LOAD_FBSINFO_FAILURE */]:
        case types["_71" /* CORE_DELETE_FBS_FAILURE */]:
        case types["_285" /* CORE_LOAD_LOCATIONS_FAILURE */]:
        case types["_222" /* CORE_LOAD_AMENITYINFO_FAILURE */]:
        case types["_180" /* CORE_LOAD_ALLFLOOR_FAILURE */]:
        case types["_264" /* CORE_LOAD_FLOORINFO_FAILURE */]:
        case types["_171" /* CORE_LOAD_ALLBUILDING_FAILURE */]:
        case types["_231" /* CORE_LOAD_BUILDINGINFO_FAILURE */]:
        case types["_168" /* CORE_LOAD_ALLBACKGROUND_FAILURE */]:
        case types["_50" /* CORE_DELETE_BACKGROUND_FAILURE */]:
        case types["_228" /* CORE_LOAD_BACKGROUNDINFO_FAILURE */]:
        case types["_447" /* CORE_UPDATE_BACKGROUNDINFO_FAILURE */]:
        case types["K" /* CORE_CREATE_BACKGROUND_FAILURE */]:
        case types["_53" /* CORE_DELETE_BUILDING_FAILURE */]:
        case types["_450" /* CORE_UPDATE_BUILDINGINFO_FAILURE */]:
        case types["N" /* CORE_CREATE_BUILDING_FAILURE */]:
        case types["_77" /* CORE_DELETE_FLOOR_FAILURE */]:
        case types["_489" /* CORE_UPDATE_FLOORINFO_FAILURE */]:
        case types["_5" /* CORE_CREATE_FLOOR_FAILURE */]:
        case types["_186" /* CORE_LOAD_ALLZONE_FAILURE */]:
        case types["_113" /* CORE_DELETE_ZONE_FAILURE */]:
        case types["_402" /* CORE_LOAD_ZONEINFO_FAILURE */]:
        case types["_537" /* CORE_UPDATE_ZONEINFO_FAILURE */]:
        case types["_41" /* CORE_CREATE_ZONE_FAILURE */]:
        case types["_486" /* CORE_UPDATE_FB_CATEGORY_FAILURE */]:
        case types["_128" /* CORE_GET_CATEGORY_INFO_FAILURE */]:
        case types["_2" /* CORE_CREATE_FB_CATEGORY_FAILURE */]:
        case types["_74" /* CORE_DELETE_FB_CATEGORY_FAILURE */]:
        case types["_29" /* CORE_CREATE_ROOM_FAILURE */]:
        case types["_574" /* O365_LOAD_ROOMS_FAILURE */]:
        case types["_338" /* CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE */]:
        case types["_559" /* O365_DELETE_ROOM_SUBSCRIBE_FAILURE */]:
        case types["_550" /* O365_CREATE_ROOM_SUBSCRIBE_FAILURE */]:
        case types["_177" /* CORE_LOAD_ALLFBS_FAILURE */]:
        case types["_483" /* CORE_UPDATE_FBSINFO_FAILURE */]:
        case types["Z" /* CORE_CREATE_FBS_FAILURE */]:
        case types["_375" /* CORE_LOAD_USERGROUPS_FAILURE */]:
        case types["_282" /* CORE_LOAD_LIST_USERGROUPS_FAILURE */]:
        case types["_378" /* CORE_LOAD_USERGROUP_FAILURE */]:
        case types["_35" /* CORE_CREATE_USERGROUP_FAILURE */]:
        case types["_531" /* CORE_UPDATE_USERGROUP_FAILURE */]:
        case types["_107" /* CORE_DELETE_USERGROUP_FAILURE */]:
        case types["j" /* CORE_CHANGE_SETTING_FAILURE */]:
        case types["s" /* CORE_CHECK_AD_FAILURE */]:
        case types["_38" /* CORE_CREATE_USER_FAILURE */]:
        case types["g" /* CORE_CHANGE_PASSWORD_FAILURE */]:
        case types["_577" /* O365_LOAD_USERS_FAILURE */]:
        case types["_219" /* CORE_LOAD_ALL_USERSAD_FAILURE */]:
        case types["_210" /* CORE_LOAD_ALL_PROFILE_FAILURE */]:
        case types["_20" /* CORE_CREATE_PROFILE_FAILURE */]:
        case types["_92" /* CORE_DELETE_PROFILE_FAILURE */]:
        case types["_306" /* CORE_LOAD_PROFILE_INFO_FAILURE */]:
        case types["_513" /* CORE_UPDATE_PROFILE_FAILURE */]:
        case types["_459" /* CORE_UPDATE_DEFAULTBACKGROUND_FAILURE */]:
        case types["_165" /* CORE_LOAD_ALLAMENITY_FAILURE */]:
        case types["_44" /* CORE_DELETE_AMENITY_FAILURE */]:
        case types["_441" /* CORE_UPDATE_AMENITYINFO_FAILURE */]:
        case types["E" /* CORE_CREATE_AMENITY_FAILURE */]:
        case types["_312" /* CORE_LOAD_REPORTSUMMARY_FAILURE */]:
        case types["_351" /* CORE_LOAD_SEAT_ZONE_INFO_FAILURE */]:
        case types["_59" /* CORE_DELETE_DISABLESEATINFO_FAILURE */]:
        case types["_417" /* CORE_SEARCH_ROOMS_FAILURE */]:
        case types["_411" /* CORE_SEARCH_FLOOR_FAILURE */]:
        case types["_423" /* CORE_SEARCH_ZONE_FAILURE */]:
        case types["_414" /* CORE_SEARCH_IOT_FAILURE */]:
        case types["_420" /* CORE_SEARCH_USERS_FAILURE */]:
        case types["_408" /* CORE_SEARCH_FBS_FAILURE */]:
        case types["m" /* CORE_CHECKIN_FAILURE */]:
        case types["_65" /* CORE_DELETE_EVENT_FAILURE */]:
        case types["p" /* CORE_CHECKOUT_FAILURE */]:
        case types["_405" /* CORE_RESET_PASSWORD_FAILURE */]:
        case types["_278" /* CORE_LOAD_IOT_ROOMREGIS_FAILURE */]:
        case types["_142" /* CORE_GET_IOT_ROOMREGIS_INFO_FAILURE */]:
        case types["_14" /* CORE_CREATE_IOT_ROOMREGIS_FAILURE */]:
        case types["_83" /* CORE_DELETE_IOT_ROOMREGIS_FAILURE */]:
        case types["_243" /* CORE_LOAD_DISPLAY_FAILURE */]:
        case types["_465" /* CORE_UPDATE_DISPLAY_FAILURE */]:
        case types["_213" /* CORE_LOAD_ALL_ROOMDISABLE_FAILURE */]:
        case types["_327" /* CORE_LOAD_ROOMDISABLE_FAILURE */]:
        case types["_26" /* CORE_CREATE_ROOMDISABLE_FAILURE */]:
        case types["_519" /* CORE_UPDATE_ROOMDISABLE_FAILURE */]:
        case types["_98" /* CORE_DELETE_ROOMDISABLE_FAILURE */]:
        case types["_56" /* CORE_DELETE_CONCURRENT_FAILURE */]:
        case types["B" /* CORE_CHECK_TMS_FAILURE */]:
        case types["y" /* CORE_CHECK_CMR_FAILURE */]:
        case types["v" /* CORE_CHECK_BOT_FAILURE */]:
        case types["_294" /* CORE_LOAD_ORDER_AMENITY_FAILURE */]:
        case types["_571" /* O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE */]:
        case types["_274" /* CORE_LOAD_IOT_MODULE_FAILURE */]:
        case types["_11" /* CORE_CREATE_IOT_MODULE_FAILURE */]:
        case types["_270" /* CORE_LOAD_IOTINFO_FAILURE */]:
        case types["_498" /* CORE_UPDATE_IOTINFO_FAILURE */]:
        case types["_139" /* CORE_GET_IOT_INFO_WITH_MODULE_FAILURE */]:
        case types["_122" /* CORE_GET_ALL_IOT_MODULE_FAILURE */]:
        case types["_32" /* CORE_CREATE_TEMP_CLOSE_FAILURE */]:
        case types["_8" /* CORE_CREATE_HOTDESK_ROLE_FAILURE */]:
        case types["_492" /* CORE_UPDATE_HOTDESK_ROLE_FAILURE */]:
        case types["_80" /* CORE_DELETE_HOTDESK_ROLE_FAILURE */]:
        case types["_201" /* CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE */]:
        case types["_267" /* CORE_LOAD_HOTDESK_ROLE_FAILURE */]:
        case types["_189" /* CORE_LOAD_ALL_AD_LIST_FAILURE */]:
        case types["_148" /* CORE_IMPORT_USER_AD_FAILURE */]:
            return reducer__extends({}, state, {
                isLoading: false,
                hasError: true,
                error: action.payload.data
            });
        case types["_601" /* SET_ERROR */]:
            return reducer__extends({}, state, {
                hasError: action.hasError,
                error: action.error
            });
        default:
            return state;
    }
});
// CONCATENATED MODULE: ./src/features/settings/integration/reducer.js
var integration_reducer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var noMessage = {
    success: "",
    error: ""
};
var _initialState = integration_reducer__extends({
    step: 1,
    o365: {
        tenant_id: "",
        client_id: ""
    }
}, noMessage);

/* harmony default export */ var integration_reducer = ({
    initialState: function initialState() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {

            case types["_157" /* CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID */]:
                {
                    return _initialState;
                }

            case types["_158" /* CORE_INTEGRATION_O365_GO_ADMIN_CONSENT */]:
                {
                    var _action$payload = action.payload,
                        step = _action$payload.step,
                        client_id = _action$payload.client_id;

                    return integration_reducer__extends({
                        step: step,
                        o365: integration_reducer__extends({}, state.o365, {
                            client_id: client_id
                        })
                    }, noMessage);
                }

            case types["_159" /* CORE_INTEGRATION_O365_GO_SAVE_DATA */]:
                {
                    var _action$payload2 = action.payload,
                        _step = _action$payload2.step,
                        _client_id = _action$payload2.client_id,
                        tenant_id = _action$payload2.tenant_id;

                    return integration_reducer__extends({
                        step: _step,
                        o365: {
                            tenant_id: tenant_id,
                            client_id: _client_id
                        }
                    }, noMessage);
                }

            case types["_154" /* CORE_INTEGRATION_O365_ADD_CLIENT_ID */]:
                {
                    var _action$payload3 = action.payload,
                        _step2 = _action$payload3.step,
                        _client_id2 = _action$payload3.client_id;

                    return integration_reducer__extends({
                        step: _step2,
                        o365: integration_reducer__extends({}, state.o365, {
                            client_id: _client_id2
                        })
                    }, noMessage);
                }

            case types["_155" /* CORE_INTEGRATION_O365_ADMIN_CONSENT */]:
                {
                    var _action$payload4 = action.payload,
                        _step3 = _action$payload4.step,
                        _tenant_id = _action$payload4.tenant_id;

                    return integration_reducer__extends({
                        step: _step3,
                        o365: integration_reducer__extends({}, state.o365, {
                            tenant_id: _tenant_id
                        })
                    }, noMessage);
                }
            case types["_161" /* CORE_INTEGRATION_O365_SUCCESS */]:
                return integration_reducer__extends({}, _initialState, {
                    success: "Connect Successfully"
                });

            case types["_156" /* CORE_INTEGRATION_O365_FAILURE */]:
                return integration_reducer__extends({}, _initialState, {
                    step: 3,
                    success: "",
                    error: "Connect failed. Please check your data"
                });
            default:
                return state;
        }
    },
    ini: function ini() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_135" /* CORE_GET_INTEGRATION_REQUEST */]:
                return _initialState;

            case types["_136" /* CORE_GET_INTEGRATION_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    integrationInfo: function integrationInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_133" /* CORE_GET_INTEGRATION_INFO_REQUEST */]:
                return _initialState;

            case types["_134" /* CORE_GET_INTEGRATION_INFO_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/rooms/reducer.js


var rooms_reducer_initialState = [];
/* harmony default export */ var rooms_reducer = ({
    roomsO365: function roomsO365() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_575" /* O365_LOAD_ROOMS_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_576" /* O365_LOAD_ROOMS_SUCCESS */]:
                return action.payload;
            case types["_572" /* O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST */]:
                return false;
            case types["_573" /* O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS */]:
                if (action.payload && Array.isArray(action.payload)) return true;else return false;
            default:
                return state;
        }
    },
    roomsCore: function roomsCore() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_337" /* CORE_LOAD_ROOMS_REQUEST */]:
            case types["_418" /* CORE_SEARCH_ROOMS_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_341" /* CORE_LOAD_ROOMS_SUCCESS */]:
            case types["_419" /* CORE_SEARCH_ROOMS_SUCCESS */]:
                if (action.payload) return action.payload;else return [];
            default:
                return state;
        }
    },
    vcList: function vcList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case types["_400" /* CORE_LOAD_VC_LIST_REQUEST */]:
                return [];
            case types["_401" /* CORE_LOAD_VC_LIST_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    roomCore: function roomCore() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_120" /* CORE_FIND_ROOM_REQUEST */]:
                return {};
            case types["_121" /* CORE_FIND_ROOM_SUCCESS */]:
                if (action.payload) return action.payload;else return {};
            default:
                return state;
        }
    },
    roomsSubscribe: function roomsSubscribe() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_339" /* CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_340" /* CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS */]:
                if (action.payload) return action.payload;else return [];
            default:
                return state;
        }
    },
    allLocation: function allLocation() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rooms_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_126" /* CORE_GET_ALL_LOCATION_INFO_REQUEST */]:
                return rooms_reducer_initialState;
            case types["_127" /* CORE_GET_ALL_LOCATION_INFO_SUCCESS */]:
                if (action.payload) return action.payload;else return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/report/reducer.js


var report_reducer_initialState = [];
/* harmony default export */ var report_reducer = ({
  coreRoom: function coreRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_287" /* CORE_LOAD_LOCATIONS_REPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_288" /* CORE_LOAD_LOCATIONS_REPORT_SUCCESS */]:
        if (action.payload[0]) {
          var payload = action.payload[0];
          var locations = [];
          for (var i = 0; i < payload.length; i++) {
            locations.push({
              value: payload[i].email,
              key: i,
              text: payload[i].name,
              name: payload[i].name
            });
          }
          return locations;
        } else return [{}];

      default:
        return state;
    }
  },
  statusSum: function statusSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_313" /* CORE_LOAD_REPORTSUMMARY_REQUEST */]:
        return state;

      case types["_314" /* CORE_LOAD_REPORTSUMMARY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomReports: function roomReports() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_316" /* CORE_LOAD_REPORT_REQUEST */]:
        return report_reducer_initialState;
      case types["_317" /* CORE_LOAD_REPORT_SUCCESS */]:
        var data = [];
        if (action.payload !== '') {
          var actionlog = action.payload;
          actionlog.data.forEach(function (payload) {
            var createEvent = false;
            var updateEvent = false;
            var deleteEvent = false;
            var type = payload.meta.type;
            if (type === "CREATE_EVENT") createEvent = true;else if (type === "UPDATE_EVENT") updateEvent = true;else deleteEvent = true;
            data.push({
              startDateTimeThai: payload.meta.data.startDateTimeThai,
              endDateTimeThai: payload.meta.data.endDateTimeThai,
              organizerAddress: payload.meta.data.organizer.emailAddress.name,
              subject: payload.meta.data.subject,
              _id: payload._id,
              createEvent: createEvent,
              updateEvent: updateEvent,
              deleteEvent: deleteEvent,
              message: payload.meta.message,
              meetnow: payload.meta.meetnow ? true : false
            });
          });
          return data;
        }
        return action.payload;

      default:
        return state;
    }
  },
  userReport: function userReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_382" /* CORE_LOAD_USERREPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_383" /* CORE_LOAD_USERREPORT_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data
        });
        return status;

      default:
        return state;
    }
  },
  roomReport: function roomReport() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_331" /* CORE_LOAD_ROOMREPORT_REQUEST */]:
        return report_reducer_initialState;

      case types["_332" /* CORE_LOAD_ROOMREPORT_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data
        });
        return status;

      default:
        return state;
    }
  },
  userSum: function userSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_385" /* CORE_LOAD_USERSUMMARY_REQUEST */]:
        return report_reducer_initialState;

      case types["_386" /* CORE_LOAD_USERSUMMARY_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data,
          summary: payload.summary
        });
        return status;

      default:
        return state;
    }
  },
  roomSum: function roomSum() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_334" /* CORE_LOAD_ROOMSUMMARY_REQUEST */]:
        return report_reducer_initialState;

      case types["_335" /* CORE_LOAD_ROOMSUMMARY_SUCCESS */]:
        var payload = action.payload;
        var status = [];
        status.push({
          reportHeader: payload.reportHeader,
          data: payload.data,
          summary: payload.summary
        });
        return status;

      default:
        return state;
    }
  },
  userStatus: function userStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_358" /* CORE_LOAD_STATUSUSER_REQUEST */]:
        return report_reducer_initialState;

      case types["_359" /* CORE_LOAD_STATUSUSER_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  userSummary: function userSummary() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_388" /* CORE_LOAD_USERSUM_REQUEST */]:
        return report_reducer_initialState;

      case types["_389" /* CORE_LOAD_USERSUM_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomsStatus: function roomsStatus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_310" /* CORE_LOAD_REPORTROOMSTATUS_REQUEST */]:
        return report_reducer_initialState;

      case types["_311" /* CORE_LOAD_REPORTROOMSTATUS_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomTemp: function roomTemp() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_343" /* CORE_LOAD_ROOMTEMP_REQUEST */]:
        return report_reducer_initialState;

      case types["_344" /* CORE_LOAD_ROOMTEMP_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  topRoom: function topRoom() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_370" /* CORE_LOAD_TOPROOMRESERVE_REQUEST */]:
        return report_reducer_initialState;

      case types["_371" /* CORE_LOAD_TOPROOMRESERVE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  topUser: function topUser() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_373" /* CORE_LOAD_TOPUSERRESERVE_REQUEST */]:
        return report_reducer_initialState;

      case types["_374" /* CORE_LOAD_TOPUSERRESERVE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  roomDetail: function roomDetail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : report_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_325" /* CORE_LOAD_ROOMDETAIL_REQUEST */]:
        return state;

      case types["_326" /* CORE_LOAD_ROOMDETAIL_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/user/reducer.js


var user_reducer_initialState = [];

/* harmony default export */ var user_reducer = ({
    users: function users() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_391" /* CORE_LOAD_USERS_REQUEST */]:
            case types["_421" /* CORE_SEARCH_USERS_REQUEST */]:
                return [];
            case types["_392" /* CORE_LOAD_USERS_SUCCESS */]:
            case types["_422" /* CORE_SEARCH_USERS_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    usersO365: function usersO365() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_578" /* O365_LOAD_USERS_REQUEST */]:
                return [];
            case types["_579" /* O365_LOAD_USERS_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    usersAD: function usersAD() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_220" /* CORE_LOAD_ALL_USERSAD_REQUEST */]:
                return [];
            case types["_221" /* CORE_LOAD_ALL_USERSAD_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_395" /* CORE_LOAD_USER_INFO_REQUEST */]:
                return {};
            case types["_396" /* CORE_LOAD_USER_INFO_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    resetPassword: function resetPassword() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_406" /* CORE_RESET_PASSWORD_REQUEST */]:
                return {};
            case types["_407" /* CORE_RESET_PASSWORD_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    importUserO365: function importUserO365() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case types["_205" /* CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST */]:
                return [];
            case types["_206" /* CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    usersADList: function usersADList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_190" /* CORE_LOAD_ALL_AD_LIST_REQUEST */]:
                return 'REQUEST';
            case types["_191" /* CORE_LOAD_ALL_AD_LIST_SUCCESS */]:
                var result = [];
                if (Array.isArray(action.payload)) {
                    result = action.payload;
                }
                return result;
            case types["_189" /* CORE_LOAD_ALL_AD_LIST_FAILURE */]:
                return user_reducer_initialState;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/setting/reducer.js


// const initialState = []

/* harmony default export */ var setting_reducer = ({
    setting: function setting() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_355" /* CORE_LOAD_SETTING_INFO_REQUEST */]:
            case types["k" /* CORE_CHANGE_SETTING_REQUEST */]:
                return state;
            case types["_356" /* CORE_LOAD_SETTING_INFO_SUCCESS */]:
            case types["l" /* CORE_CHANGE_SETTING_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    AD: function AD() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["t" /* CORE_CHECK_AD_REQUEST */]:
                return {};
            case types["u" /* CORE_CHECK_AD_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    TMS: function TMS() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["C" /* CORE_CHECK_TMS_REQUEST */]:
                return 'request';
            case types["D" /* CORE_CHECK_TMS_SUCCESS */]:
                if (action) {
                    if (typeof action.payload === 'boolean') return action.payload;else {
                        if (action.payload.toLowerCase() === 'true') return true;else return false;
                    }
                } else return false;
            case types["B" /* CORE_CHECK_TMS_FAILURE */]:
                return false;
            default:
                return state;
        }
    },
    BOT: function BOT() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["w" /* CORE_CHECK_BOT_REQUEST */]:
                return 'request';
            case types["x" /* CORE_CHECK_BOT_SUCCESS */]:
                if (action) {
                    if (typeof action.payload === 'boolean') return action.payload;else {
                        if (action.payload.toLowerCase() === 'true') return true;else return false;
                    }
                } else return false;
            case types["v" /* CORE_CHECK_BOT_FAILURE */]:
                return false;
            default:
                return state;
        }
    },
    CMR: function CMR() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["z" /* CORE_CHECK_CMR_REQUEST */]:
                return 'request';
            case types["A" /* CORE_CHECK_CMR_SUCCESS */]:
                if (action) {
                    if (typeof action.payload === 'boolean') return action.payload;else {
                        if (action.payload.toLowerCase() === 'true') return true;else return false;
                    }
                } else return false;
            case types["y" /* CORE_CHECK_CMR_FAILURE */]:
                return false;
            default:
                return state;
        }
    },
    timezone: function timezone() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_367" /* CORE_LOAD_TIMEZOZE_REQUEST */]:
                return [];
            case types["_368" /* CORE_LOAD_TIMEZOZE_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/settings/amenity/reducer.js


var amenity_reducer_initialState = [];
/* harmony default export */ var amenity_reducer = ({
  amenity: function amenity() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_166" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        return amenity_reducer_initialState;

      case types["_167" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  amenityMaster: function amenityMaster() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "REQUEST";
    var action = arguments[1];

    switch (action.type) {
      case types["_166" /* CORE_LOAD_ALLAMENITY_REQUEST */]:
        return "REQUEST";
      case types["_167" /* CORE_LOAD_ALLAMENITY_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_165" /* CORE_LOAD_ALLAMENITY_FAILURE */]:
        return [];
      default:
        return state;
    }
  },
  amenityInfo: function amenityInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : amenity_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_223" /* CORE_LOAD_AMENITYINFO_REQUEST */]:
        return amenity_reducer_initialState;

      case types["_224" /* CORE_LOAD_AMENITYINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/term/reducer.js


var term_reducer_initialState = {};
/* harmony default export */ var term_reducer = ({
  term: function term() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : term_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_364" /* CORE_LOAD_TERM_REQUEST */]:
      case types["_529" /* CORE_UPDATE_TERM_REQUEST */]:
        return term_reducer_initialState;

      case types["_365" /* CORE_LOAD_TERM_SUCCESS */]:
      case types["_530" /* CORE_UPDATE_TERM_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/faq/reducer.js


var faq_reducer_initialState = {};
/* harmony default export */ var faq_reducer = ({
  faq: function faq() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : faq_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_259" /* CORE_LOAD_FAQ_REQUEST */]:
      case types["_481" /* CORE_UPDATE_FAQ_REQUEST */]:
        return faq_reducer_initialState;

      case types["_260" /* CORE_LOAD_FAQ_SUCCESS */]:
      case types["_482" /* CORE_UPDATE_FAQ_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/contact/reducer.js


var contact_reducer_initialState = {};
/* harmony default export */ var contact_reducer = ({
  contactus: function contactus() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contact_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_238" /* CORE_LOAD_CONTACT_US_REQUEST */]:
      case types["_454" /* CORE_UPDATE_CONTACT_US_REQUEST */]:
        return contact_reducer_initialState;

      case types["_239" /* CORE_LOAD_CONTACT_US_SUCCESS */]:
      case types["_455" /* CORE_UPDATE_CONTACT_US_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/profile/reducer.js


var profile_reducer_initialState = [];
/* harmony default export */ var profile_reducer = ({
  profileList: function profileList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profile_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_211" /* CORE_LOAD_ALL_PROFILE_REQUEST */]:
        return profile_reducer_initialState;
      case types["_212" /* CORE_LOAD_ALL_PROFILE_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  profileInfo: function profileInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profile_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_307" /* CORE_LOAD_PROFILE_INFO_REQUEST */]:
        return profile_reducer_initialState;
      case types["_308" /* CORE_LOAD_PROFILE_INFO_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/usergroup/reducer.js


var usergroup_reducer_initialState = [];
/* harmony default export */ var usergroup_reducer = ({
  usergroups: function usergroups() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usergroup_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_376" /* CORE_LOAD_USERGROUPS_REQUEST */]:
      case types["_283" /* CORE_LOAD_LIST_USERGROUPS_REQUEST */]:
        return usergroup_reducer_initialState;
      case types["_377" /* CORE_LOAD_USERGROUPS_SUCCESS */]:
      case types["_284" /* CORE_LOAD_LIST_USERGROUPS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  },
  usergroup: function usergroup() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usergroup_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_379" /* CORE_LOAD_USERGROUP_REQUEST */]:
        return {};
      case types["_380" /* CORE_LOAD_USERGROUP_SUCCESS */]:
        if (action.payload) return action.payload;else return {};
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/action/reducer.js


var action_reducer_initialState = [];
/* harmony default export */ var action_reducer = ({
  actions: function actions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : action_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_163" /* CORE_LOAD_ACTIONS_REQUEST */]:
        return action_reducer_initialState;
      case types["_164" /* CORE_LOAD_ACTIONS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/fbs/reducer.js


var fbs_reducer_initialState = [];
/* harmony default export */ var fbs_reducer = ({
  fbs: function fbs() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_178" /* CORE_LOAD_ALLFBS_REQUEST */]:
      case types["_409" /* CORE_SEARCH_FBS_REQUEST */]:
        return fbs_reducer_initialState;
      case types["_179" /* CORE_LOAD_ALLFBS_SUCCESS */]:
      case types["_410" /* CORE_SEARCH_FBS_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  fbsMaster: function fbsMaster() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "REQUEST";
    var action = arguments[1];

    switch (action.type) {
      case types["_178" /* CORE_LOAD_ALLFBS_REQUEST */]:
        return "REQUEST";
      case types["_179" /* CORE_LOAD_ALLFBS_SUCCESS */]:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload;
        } else return [];
      case types["_177" /* CORE_LOAD_ALLFBS_FAILURE */]:
        return [];
      default:
        return state;
    }
  },
  fbsInfo: function fbsInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_262" /* CORE_LOAD_FBSINFO_REQUEST */]:
        return {};
      case types["_263" /* CORE_LOAD_FBSINFO_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },

  fbCategory: function fbCategory() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbs_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_196" /* CORE_LOAD_ALL_CATEGORY_REQUEST */]:
        return fbs_reducer_initialState;

      case types["_197" /* CORE_LOAD_ALL_CATEGORY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/settings/location/reducer.js


var location_reducer_initialState = [];
/* harmony default export */ var location_reducer = ({
  coreLocations: function coreLocations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_289" /* CORE_LOAD_LOCATIONS_REQUEST */]:
        return location_reducer_initialState;
      case types["_290" /* CORE_LOAD_LOCATIONS_SUCCESS */]:
        if (action.payload) return action.payload;else return [];
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/building/reducer.js


var building_reducer_initialState = [];
/* harmony default export */ var building_reducer = ({
  building: function building() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : building_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_172" /* CORE_LOAD_ALLBUILDING_REQUEST */]:
        return building_reducer_initialState;

      case types["_173" /* CORE_LOAD_ALLBUILDING_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  buildingInfo: function buildingInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : building_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_232" /* CORE_LOAD_BUILDINGINFO_REQUEST */]:
        return building_reducer_initialState;

      case types["_233" /* CORE_LOAD_BUILDINGINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/floor/reducer.js


var floor_reducer_initialState = [];
/* harmony default export */ var floor_reducer = ({
  floor: function floor() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floor_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_181" /* CORE_LOAD_ALLFLOOR_REQUEST */]:
      case types["_412" /* CORE_SEARCH_FLOOR_REQUEST */]:
        return floor_reducer_initialState;

      case types["_182" /* CORE_LOAD_ALLFLOOR_SUCCESS */]:
      case types["_413" /* CORE_SEARCH_FLOOR_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  floorInfo: function floorInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : floor_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_265" /* CORE_LOAD_FLOORINFO_REQUEST */]:
        return floor_reducer_initialState;
      case types["_266" /* CORE_LOAD_FLOORINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/location/zone/reducer.js


var zone_reducer_initialState = [];
/* harmony default export */ var zone_reducer = ({
  zone: function zone() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zone_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_187" /* CORE_LOAD_ALLZONE_REQUEST */]:
      case types["_424" /* CORE_SEARCH_ZONE_REQUEST */]:
        return zone_reducer_initialState;

      case types["_188" /* CORE_LOAD_ALLZONE_SUCCESS */]:
      case types["_425" /* CORE_SEARCH_ZONE_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  zoneInfo: function zoneInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : zone_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_403" /* CORE_LOAD_ZONEINFO_REQUEST */]:
        return {};
      case types["_404" /* CORE_LOAD_ZONEINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/background/reducer.js


var background_reducer_initialState = [];
/* harmony default export */ var background_reducer = ({
  background: function background() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : background_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_169" /* CORE_LOAD_ALLBACKGROUND_REQUEST */]:
        return background_reducer_initialState;

      case types["_170" /* CORE_LOAD_ALLBACKGROUND_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  backgroundInfo: function backgroundInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_229" /* CORE_LOAD_BACKGROUNDINFO_REQUEST */]:
        return {};

      case types["_230" /* CORE_LOAD_BACKGROUNDINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/fbCategory/reducer.js


var fbCategory_reducer_initialState = [];
/* harmony default export */ var fbCategory_reducer = ({
  fbCategoryInfo: function fbCategoryInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fbCategory_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_129" /* CORE_GET_CATEGORY_INFO_REQUEST */]:
        return {};

      case types["_130" /* CORE_GET_CATEGORY_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/iot/reducer.js


var iot_reducer_initialState = [];
/* harmony default export */ var iot_reducer = ({

    iots: function iots() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iot_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_277" /* CORE_LOAD_IOT_REQUEST */]:
            case types["_415" /* CORE_SEARCH_IOT_REQUEST */]:
                return [];
            case types["_281" /* CORE_LOAD_IOT_SUCCESS */]:
            case types["_416" /* CORE_SEARCH_IOT_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    iot: function iot() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iot_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_137" /* CORE_GET_IOT_INFO_REQUEST */]:
                return {};

            case types["_138" /* CORE_GET_IOT_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    iotWithModule: function iotWithModule() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iot_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_140" /* CORE_GET_IOT_INFO_WITH_MODULE_REQUEST */]:
                return {};

            case types["_141" /* CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    iotModule: function iotModule() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iot_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_123" /* CORE_GET_ALL_IOT_MODULE_REQUEST */]:
                return {};

            case types["_124" /* CORE_GET_ALL_IOT_MODULE_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/hotseat/reducer.js


var hotseat_reducer_initialState = [];
/* harmony default export */ var hotseat_reducer = ({
  allSeat: function allSeat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotseat_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_184" /* CORE_LOAD_ALLSEAT_REQUEST */]:
        return hotseat_reducer_initialState;

      case types["_185" /* CORE_LOAD_ALLSEAT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  seatZoneInfo: function seatZoneInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_352" /* CORE_LOAD_SEAT_ZONE_INFO_REQUEST */]:
        return {};

      case types["_353" /* CORE_LOAD_SEAT_ZONE_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  seatInfo: function seatInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_349" /* CORE_LOAD_SEAT_INFO_REQUEST */]:
        return {};

      case types["_350" /* CORE_LOAD_SEAT_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  allDisableSeat: function allDisableSeat() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotseat_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_175" /* CORE_LOAD_ALLDISABLESEAT_REQUEST */]:
        return hotseat_reducer_initialState;

      case types["_176" /* CORE_LOAD_ALLDISABLESEAT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  disableSeatInfo: function disableSeatInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case types["_241" /* CORE_LOAD_DISABLESEATINFO_REQUEST */]:
        return {};

      case types["_242" /* CORE_LOAD_DISABLESEATINFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/events/reducer.js


var events_reducer_initialState = [];
/* harmony default export */ var events_reducer = ({
    events: function events() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : events_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_563" /* O365_LOAD_EVENTS_REQUEST */]:
                return [];

            case types["_564" /* O365_LOAD_EVENTS_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    checkIn: function checkIn() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["n" /* CORE_CHECKIN_REQUEST */]:
                return false;

            case types["o" /* CORE_CHECKIN_SUCCESS */]:
                return true;

            default:
                return state;
        }
    },
    checkOut: function checkOut() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["q" /* CORE_CHECKOUT_REQUEST */]:
                return false;

            case types["r" /* CORE_CHECKOUT_SUCCESS */]:
                return true;

            default:
                return state;
        }
    },
    deleteEvent: function deleteEvent() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["_66" /* CORE_DELETE_EVENT_REQUEST */]:
                return false;

            case types["_70" /* CORE_DELETE_EVENT_SUCCESS */]:
                return true;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/iotRoomRegis/reducer.js


var iotRoomRegis_reducer_initialState = [];
/* harmony default export */ var iotRoomRegis_reducer = ({

  iotRoomRegis: function iotRoomRegis() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iotRoomRegis_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_279" /* CORE_LOAD_IOT_ROOMREGIS_REQUEST */]:
      case types["_415" /* CORE_SEARCH_IOT_REQUEST */]:
        return [];
      case types["_280" /* CORE_LOAD_IOT_ROOMREGIS_SUCCESS */]:
      case types["_416" /* CORE_SEARCH_IOT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },

  iotRoomRegisInfo: function iotRoomRegisInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iotRoomRegis_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_143" /* CORE_GET_IOT_ROOMREGIS_INFO_REQUEST */]:
        return {};

      case types["_144" /* CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  createIotRoomRegisResult: function createIotRoomRegisResult() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
      case types["_15" /* CORE_CREATE_IOT_ROOMREGIS_REQUEST */]:
        return false;

      case types["_16" /* CORE_CREATE_IOT_ROOMREGIS_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },
  updateIotRoomRegisResult: function updateIotRoomRegisResult() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
      case types["_505" /* CORE_UPDATE_IOT_REQUEST */]:
        return false;

      case types["_506" /* CORE_UPDATE_IOT_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  }

});
// CONCATENATED MODULE: ./src/features/display/reducer.js


var display_reducer_initialState = [];
/* harmony default export */ var display_reducer = ({

  allDisplay: function allDisplay() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_244" /* CORE_LOAD_DISPLAY_REQUEST */]:
        return [];
      case types["_245" /* CORE_LOAD_DISPLAY_SUCCESS */]:
        return action.payload;

      default:
        return state;
    }
  },

  displayInfo: function displayInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      // case CORE_GET_IOT_INFO_REQUEST:
      //   return {}

      // case CORE_GET_IOT_INFO_SUCCESS:
      //   return action.payload

      default:
        return state;
    }
  }

});
// CONCATENATED MODULE: ./src/features/profilecenter/reducer.js


var profilecenter_reducer_initialState = {};
/* harmony default export */ var profilecenter_reducer = ({
    profileCenterInfo: function profileCenterInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : profilecenter_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_590" /* PROFILE_CENTER_LOAD_INFO_REQUEST */]:
                return profilecenter_reducer_initialState;
            case types["_591" /* PROFILE_CENTER_LOAD_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    profileUpdateStatus: function profileUpdateStatus() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            case types["_593" /* PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST */]:
                return profilecenter_reducer_initialState;
            case types["_594" /* PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roomDisable/reducer.js


var roomDisable_reducer_initialState = [];
/* harmony default export */ var roomDisable_reducer = ({
  roomDisableList: function roomDisableList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomDisable_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_214" /* CORE_LOAD_ALL_ROOMDISABLE_REQUEST */]:
        return [];
      case types["_215" /* CORE_LOAD_ALL_ROOMDISABLE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  },
  roomDisable: function roomDisable() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomDisable_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_328" /* CORE_LOAD_ROOMDISABLE_REQUEST */]:
        return {};
      case types["_329" /* CORE_LOAD_ROOMDISABLE_SUCCESS */]:
        return action.payload;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/concurrent/reducer.js


/* harmony default export */ var concurrent_reducer = ({
    concurrents: function concurrents() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_235" /* CORE_LOAD_CONCURRENT_REQUEST */]:
                return [];

            case types["_236" /* CORE_LOAD_CONCURRENT_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roles/reducer.js


var roles_reducer_initialState = [];
/* harmony default export */ var roles_reducer = ({
    roles: function roles() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roles_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_319" /* CORE_LOAD_ROLES_REQUEST */]:
                return roles_reducer_initialState;
            case types["_320" /* CORE_LOAD_ROLES_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    role: function role() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_322" /* CORE_LOAD_ROLE_INFO_REQUEST */]:
                return roles_reducer_initialState;
            case types["_323" /* CORE_LOAD_ROLE_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/roomformat/reducer.js


var roomformat_reducer_initialState = [];
/* harmony default export */ var roomformat_reducer = ({
    eventRoomFormat: function eventRoomFormat() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomformat_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_256" /* CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST */]:
                return roomformat_reducer_initialState;

            case types["_257" /* CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    eventRoomFormatInfo: function eventRoomFormatInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roomformat_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_254" /* CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST */]:
                return {};

            case types["_255" /* CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/order/reducer.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var order_reducer_initialState = [];
/* harmony default export */ var order_reducer = ({
    orderFbs: function orderFbs() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_304" /* CORE_LOAD_ORDER_FBS_REQUEST */]:
                return order_reducer_initialState;

            case types["_305" /* CORE_LOAD_ORDER_FBS_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    orderFbsInfo: function orderFbsInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_302" /* CORE_LOAD_ORDER_FBS_INFO_REQUEST */]:
                return {};

            case types["_303" /* CORE_LOAD_ORDER_FBS_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    orderAmenity: function orderAmenity() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_298" /* CORE_LOAD_ORDER_AMENITY_REQUEST */]:
                return order_reducer_initialState;

            case types["_299" /* CORE_LOAD_ORDER_AMENITY_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    orderAmenityInfo: function orderAmenityInfo() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : order_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_296" /* CORE_LOAD_ORDER_AMENITY_INFO_REQUEST */]:
                return {};

            case types["_297" /* CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    avaibleOrder: function avaibleOrder() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "REQUEST";
        var action = arguments[1];

        switch (action.type) {
            case types["_146" /* CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST */]:
                return "REQUEST";
            case types["_147" /* CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    return action.payload;
                } else return {};
            case types["_145" /* CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/eventType/reducer.js


var eventType_reducer_initialState = [];
/* harmony default export */ var eventType_reducer = ({
    allEventType: function allEventType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventType_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_250" /* CORE_LOAD_EVENTTYPE_REQUEST */]:
                return eventType_reducer_initialState;
            case types["_251" /* CORE_LOAD_EVENTTYPE_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    eventType: function eventType() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        switch (action.type) {
            case types["_248" /* CORE_LOAD_EVENTTYPE_INFO_REQUEST */]:
                return {};
            case types["_249" /* CORE_LOAD_EVENTTYPE_INFO_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/features/hotdeskTemporaryClosed/reducer.js


var hotdeskTemporaryClosed_reducer_initialState = [];
/* harmony default export */ var hotdeskTemporaryClosed_reducer = ({

    allTemporaryClosed: function allTemporaryClosed() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotdeskTemporaryClosed_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_217" /* CORE_LOAD_ALL_TEMPORARY_CLOSE_REQUEST */]:
                return [];
            case types["_218" /* CORE_LOAD_ALL_TEMPORARY_CLOSE_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    },
    temporaryClosed: function temporaryClosed() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotdeskTemporaryClosed_reducer_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_361" /* CORE_LOAD_TEMPORARY_CLOSE_REQUEST */]:
                return [];
            case types["_362" /* CORE_LOAD_TEMPORARY_CLOSE_SUCCESS */]:
                return action.payload;

            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/features/hotdeskAvailableTimeSlot/reducer.js
var reducer__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var requestState = 'request',
    hotdeskAvailableTimeSlot_reducer_initialState = [],
    initialStateObj = {};

/* harmony default export */ var hotdeskAvailableTimeSlot_reducer = ({
  allAvailableTimeSlot: function allAvailableTimeSlot() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotdeskAvailableTimeSlot_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_193" /* CORE_LOAD_ALL_AVAILABLE_TIMESLOT_REQUEST */]:
        return requestState;
      case types["_194" /* CORE_LOAD_ALL_AVAILABLE_TIMESLOT_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_192" /* CORE_LOAD_ALL_AVAILABLE_TIMESLOT_FAILURE */]:
        return hotdeskAvailableTimeSlot_reducer_initialState;
      default:
        return state;
    }
  },
  availableTimeSlotInfo: function availableTimeSlotInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotdeskAvailableTimeSlot_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_226" /* CORE_LOAD_AVAILABLE_TIMESLOT_REQUEST */]:
        return requestState;
      case types["_227" /* CORE_LOAD_AVAILABLE_TIMESLOT_SUCCESS */]:
        var result = null;
        if (action.payload && !Array.isArray(action.payload) && reducer__typeof(action.payload) === 'object') {
          result = action.payload;
        }
        return result;
      case types["_225" /* CORE_LOAD_AVAILABLE_TIMESLOT_FAILURE */]:
        return initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/hotdeskRole/reducer.js
var hotdeskRole_reducer__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var reducer_requestState = 'request',
    hotdeskRole_reducer_initialState = [],
    reducer_initialStateObj = {};
/* harmony default export */ var hotdeskRole_reducer = ({
  allHotdeskRole: function allHotdeskRole() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : hotdeskRole_reducer_initialState;
    var action = arguments[1];

    switch (action.type) {
      case types["_202" /* CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST */]:
        return reducer_requestState;
      case types["_203" /* CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS */]:
        var result = [];
        if (result && Array.isArray(action.payload)) {
          result = action.payload;
        }
        return result;
      case types["_201" /* CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE */]:
        return hotdeskRole_reducer_initialState;
      default:
        return state;
    }
  },
  hotdeskRoleInfo: function hotdeskRoleInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialStateObj;
    var action = arguments[1];

    switch (action.type) {
      case types["_268" /* CORE_LOAD_HOTDESK_ROLE_REQUEST */]:
        return reducer_requestState;
      case types["_269" /* CORE_LOAD_HOTDESK_ROLE_SUCCESS */]:
        var result = null;
        if (action.payload && !Array.isArray(action.payload) && hotdeskRole_reducer__typeof(action.payload) === 'object') {
          result = action.payload;
        }
        return result;
      case types["_267" /* CORE_LOAD_HOTDESK_ROLE_FAILURE */]:
        return reducer_initialStateObj;
      default:
        return state;
    }
  }
});
// CONCATENATED MODULE: ./src/features/allControl/reducers.js


var reducers_initialState = [];
/* harmony default export */ var reducers = ({
    allAccessControl: function allAccessControl() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_199" /* CORE_LOAD_ALL_CONTROL_REQUEST */]:
                return [];
            case types["_200" /* CORE_LOAD_ALL_CONTROL_SUCCESS */]:
                // return testAllController
                return action.payload;

            default:
                return state;
        }
    },
    iotResponse: function iotResponse() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_472" /* CORE_UPDATE_DOUT_REQUEST */]:
                return { status: false, moduleName: "dout" };
            case types["_473" /* CORE_UPDATE_DOUT_SUCCESS */]:
                return { status: action.payload, moduleName: "dout" };
            case types["_457" /* CORE_UPDATE_DALI_REQUEST */]:
                return { status: false, moduleName: "dali" };
            case types["_458" /* CORE_UPDATE_DALI_SUCCESS */]:
                return { status: action.payload, moduleName: "dali" };
            case types["_469" /* CORE_UPDATE_DMX_REQUEST */]:
                return { status: false, moduleName: "dmx" };
            case types["_470" /* CORE_UPDATE_DMX_SUCCESS */]:
                return { status: action.payload, moduleName: "dmx" };
            default:
                return state;
        }
    },
    builgingList: function builgingList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_199" /* CORE_LOAD_ALL_CONTROL_REQUEST */]:
                return [];
            case types["_200" /* CORE_LOAD_ALL_CONTROL_SUCCESS */]:
                var data = action.payload,
                    buildingList = [],
                    options = [];
                if (data && data.length > 0) {
                    data.forEach(function (element) {
                        var building = element.building;
                        if (!building) building = { _id: "1", name: "No Building" };

                        var _ref = building ? building : {},
                            _id = _ref._id,
                            name = _ref.name;

                        var check = building && buildingList ? buildingList.findIndex(function (b) {
                            return b._id === _id;
                        }) : null;
                        if (check === -1) {
                            buildingList.push({ _id: _id, name: name });
                        }
                    });
                }
                var filterBuilding = buildingList.sort(function (a, b) {
                    return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
                });
                return {
                    buildings: filterBuilding,
                    buildingOptions: options
                };
            default:
                return [];
        }
    },
    allIotModuleWithBuilding: function allIotModuleWithBuilding() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducers_initialState;
        var action = arguments[1];

        switch (action.type) {
            case types["_199" /* CORE_LOAD_ALL_CONTROL_REQUEST */]:
                return [];
            case types["_200" /* CORE_LOAD_ALL_CONTROL_SUCCESS */]:
                var data = action.payload,
                    groupByfloor = [];
                if (data && data.length > 0) {
                    data.forEach(function (element) {
                        var floor = element.floor,
                            roomName = element.roomName,
                            roomId = element.roomId,
                            roomEmail = element.roomEmail,
                            status = element.status,
                            building = element.building;

                        var groupIndex = groupByfloor.findIndex(function (g) {
                            return g.floorId && floor && g.floorId === floor._id;
                        }),
                            dataObj = { roomName: roomName, roomId: roomId, roomEmail: roomEmail, status: status };
                        if (groupIndex > -1) {
                            var item = groupByfloor[groupIndex],
                                _data = item.data;
                            groupByfloor[groupIndex] = {
                                buildingName: building ? building.name : "No Building",
                                buildingId: building ? building._id : "1",
                                floorId: floor ? floor._id : "0",
                                floorName: floor ? floor.name : "No Floor",
                                data: _data.concat([dataObj])
                            };
                        } else groupByfloor.push({
                            buildingName: building ? building.name : "No Building",
                            buildingId: building ? building._id : "1",
                            floorId: floor ? floor._id : "0",
                            floorName: floor ? floor.name : "No Floor",
                            data: [dataObj]
                        });
                    });
                }
                return groupByfloor;

            default:
                return [];
        }
    }
});
// CONCATENATED MODULE: ./src/reducers.js






// import roomReducer from 'Features/settings/room/reducer'

// import userReducer from 'Features/settings/user/reducer'





























// import controllers from './features/controllers/reducer'





/* harmony default export */ var src_reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["c" /* reducer */],
    notifications: Object(lib["reducer"])(),
    auth: reducer,
    ui: ui_reducer,
    integration: integration_reducer.initialState,
    ini: integration_reducer.ini,
    integrationInfo: integration_reducer.integrationInfo,
    roomsO365: rooms_reducer.roomsO365,
    roomsCore: rooms_reducer.roomsCore,
    roomsSubscribe: rooms_reducer.roomsSubscribe,
    roomCore: rooms_reducer.roomCore,
    allLocation: rooms_reducer.allLocation,
    // rooms: roomReducer.rooms,
    // locations: roomReducer.locations,
    // coreRoom: roomReducer.coreRoom,
    // users : userReducer.users,
    // user : userReducer.user,
    allRoomReport: report_reducer.coreRoom,
    roomReport: report_reducer.roomReport,
    users: user_reducer.users,
    usersO365: user_reducer.usersO365,
    usersAD: user_reducer.usersAD,
    user: user_reducer.user,
    setting: setting_reducer.setting,
    statusSum: report_reducer.statusSum,
    userReport: report_reducer.userReport,
    roomReports: report_reducer.roomReports,
    userSum: report_reducer.userSum,
    roomSum: report_reducer.roomSum,
    amenity: amenity_reducer.amenity,
    amenityMaster: amenity_reducer.amenityMaster,
    amenityInfo: amenity_reducer.amenityInfo,
    fbs: fbs_reducer.fbs,
    fbsMaster: fbs_reducer.fbsMaster,
    fbsInfo: fbs_reducer.fbsInfo,
    fbCategory: fbs_reducer.fbCategory,
    profileList: profile_reducer.profileList,
    profileInfo: profile_reducer.profileInfo,
    usergroups: usergroup_reducer.usergroups,
    usergroup: usergroup_reducer.usergroup,
    actions: action_reducer.actions,
    userStatus: report_reducer.userStatus,
    userSummary: report_reducer.userSummary,
    // roomSummary : reportReducer.roomSummary,
    roomTemp: report_reducer.roomTemp,
    topRoom: report_reducer.topRoom,
    topUser: report_reducer.topUser,
    roomDetail: report_reducer.roomDetail,
    roomsStatus: report_reducer.roomsStatus,
    term: term_reducer.term,
    faq: faq_reducer.faq,
    contactus: contact_reducer.contactus,
    coreLocations: location_reducer.coreLocations,
    building: building_reducer.building,
    buildingInfo: building_reducer.buildingInfo,
    floor: floor_reducer.floor,
    floorinfo: floor_reducer.floorInfo,
    zone: zone_reducer.zone,
    zoneInfo: zone_reducer.zoneInfo,
    background: background_reducer.background,
    backgroundInfo: background_reducer.backgroundInfo,
    fbCategoryInfo: fbCategory_reducer.fbCategoryInfo,
    AD: setting_reducer.AD,
    TMS: setting_reducer.TMS,
    CMR: setting_reducer.CMR,
    BOT: setting_reducer.BOT,
    timezone: setting_reducer.timezone,
    iots: iot_reducer.iots,
    iot: iot_reducer.iot,
    allSeat: hotseat_reducer.allSeat,
    seatZoneInfo: hotseat_reducer.seatZoneInfo,
    seatInfo: hotseat_reducer.seatInfo,
    allDisableSeat: hotseat_reducer.allDisableSeat,
    disableSeatInfo: hotseat_reducer.disableSeatInfo,
    events: events_reducer.events,
    checkIn: events_reducer.checkIn,
    checkOut: events_reducer.checkOut,
    deleteEvent: events_reducer.deleteEvent,
    resetPassword: user_reducer.resetPassword,
    iotRoomRegis: iotRoomRegis_reducer.iotRoomRegis,
    iotRoomRegisInfo: iotRoomRegis_reducer.iotRoomRegisInfo,
    allDisplay: display_reducer.allDisplay,
    displayInfo: display_reducer.displayInfo,
    profileCenterInfo: profilecenter_reducer.profileCenterInfo,
    createIotRoomRegisResult: iotRoomRegis_reducer.createIotRoomRegisResult,
    updateIotRoomRegisResult: iotRoomRegis_reducer.updateIotRoomRegisResult,
    profileUpdateStatus: profilecenter_reducer.profileUpdateStatus,
    roomDisableList: roomDisable_reducer.roomDisableList,
    roomDisable: roomDisable_reducer.roomDisable,
    vcList: rooms_reducer.vcList,
    concurrents: concurrent_reducer.concurrents,
    roles: roles_reducer.roles,
    role: roles_reducer.role,
    eventRoomFormat: roomformat_reducer.eventRoomFormat,
    eventRoomFormatInfo: roomformat_reducer.eventRoomFormatInfo,
    orderFbs: order_reducer.orderFbs,
    orderFbsInfo: order_reducer.orderFbsInfo,
    orderAmenity: order_reducer.orderAmenity,
    orderAmenityInfo: order_reducer.orderAmenityInfo,

    avaibleOrder: order_reducer.avaibleOrder,

    allEventType: eventType_reducer.allEventType,
    eventType: eventType_reducer.eventType,
    importUserO365: user_reducer.importUserO365,

    // iotmodule: controllers.iotmodule,
    // iotinfo: controllers.iotinfo,
    iotWithModule: iot_reducer.iotWithModule,
    iotModule: iot_reducer.iotModule,
    allTemporaryClosed: hotdeskTemporaryClosed_reducer.allTemporaryClosed,
    temporaryClosed: hotdeskTemporaryClosed_reducer.temporaryClosed,

    allAvailableTimeSlot: hotdeskAvailableTimeSlot_reducer.allAvailableTimeSlot,
    availableTimeSlotInfo: hotdeskAvailableTimeSlot_reducer.availableTimeSlotInfo,

    allHotdeskRole: hotdeskRole_reducer.allHotdeskRole,
    hotdeskRoleInfo: hotdeskRole_reducer.hotdeskRoleInfo,

    allAccessControl: reducers.allAccessControl,
    iotResponse: reducers.iotResponse,
    builgingList: reducers.builgingList,
    allIotModuleWithBuilding: reducers.allIotModuleWithBuilding,
    usersADList: user_reducer.usersADList
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(src_reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

module.exports = {"name":"roomminister_backend","version":"2.6.0","main":"index.js","license":"MIT","scripts":{"dev":"webpack-dev-server --env=dev","build":"node --max_old_space_size=4096 ./node_modules/webpack/bin/webpack.js --config webpack.config.js --env=prod -p --display-modules --display-chunks","serve":"node server.js"},"devDependencies":{"airbnb-prop-types":"^2.8.1","babel-core":"^6.26.3","babel-eslint":"^7.2.3","babel-loader":"^7.1.2","babel-plugin-import":"^1.6.7","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","babel-preset-react":"^6.24.1","clean-webpack-plugin":"^0.1.19","copy-webpack-plugin":"^4.5.1","css-loader":"^0.28.9","eslint":"^4.1.1","eslint-config-react-app":"^2.1.0","eslint-loader":"^1.9.0","eslint-plugin-flowtype":"^2.34.1","eslint-plugin-import":"^2.6.0","eslint-plugin-jsx-a11y":"^5.1.1","eslint-plugin-react":"^7.1.0","file-loader":"^1.1.11","html-webpack-plugin":"^3.1.0","node-sass":"^4.11.0","postcss-cssnext":"^3.1.0","postcss-import":"^11.0.0","postcss-loader":"^2.1.0","prop-types":"^15.6.0","react-hot-loader":"^4.0.0-beta.21","redux-devtools":"^3.5.0","redux-devtools-dock-monitor":"^1.1.3","redux-devtools-log-monitor":"^1.4.0","redux-logger":"^3.0.6","redux-slider-monitor":"^2.0.0-1","sass-loader":"^6.0.6","style-loader":"^0.20.1","uglify-js":"^3.3.16","uglifyjs-webpack-plugin":"^1.2.4","url-loader":"^1.0.1","webpack":"^3.10.0","webpack-bundle-analyzer":"^2.11.1","webpack-dev-server":"^2.11.1","webpack-merge":"^4.1.2"},"dependencies":{"antd":"^3.16.4","axios":"^0.19.0","base-64":"^0.1.0","chart.js":"^2.7.2","classnames":"^2.2.5","dotenv":"^5.0.1","draft-js":"^0.10.5","draftjs-to-html":"^0.8.4","express":"^4.16.3","font-awesome":"^4.7.0","js-cookie":"^2.2.0","jsonwebtoken":"^8.2.0","lodash":"^4.17.11","material-ui":"^0.20.0","moment":"^2.22.0","moment-timezone":"^0.5.14","normalizr":"^3.2.4","react":"^16.2.0","react-chartjs-2":"^2.7.4","react-circle":"^1.0.3","react-circular-progressbar":"^1.0.0","react-color":"^2.17.3","react-country-flag":"^2.0.1","react-d3-speedometer":"^0.4.1","react-datepicker":"^1.7.0","react-dom":"^16.2.0","react-draft-wysiwyg":"^1.12.13","react-file-base64":"^1.0.3","react-loadable":"^5.3.1","react-pagination-table":"^2.0.2","react-print-components":"^1.0.4","react-redux":"^5.0.7","react-render-html":"^0.6.0","react-router-dom":"^4.2.2","react-switch-lang":"^1.0.2","react-to-print":"^2.1.1","reapop":"^1.2.0","reapop-theme-wybo":"^1.0.2","recharts":"^1.5.0","recompose":"^0.26.0","redux":"^3.7.2","redux-form":"^7.3.0","redux-form-material-ui":"^4.3.4","redux-thunk":"^2.2.0","reselect":"^3.0.1","rgb-hex":"^3.0.0","semantic-ui-react":"^0.79.1","styled-components":"^3.2.5"}}

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

module.exports = {"account":"Log-in to your account","login":"Log In","remember":"Remember","email":"Email","password":"Password","error":"Required!","emailerror":"Invalid email address"}

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

module.exports = {"ok":"Ok","cancel":"Cancel","back":"Back","edit":"Edit","submit":"Submit","confirm":"Confirm","yes":"YES","no":"NO","done":"Done","AdvancedSearch":"Advanced Search","Update":"Update","Print":"Print this out!","Enabled":"Enabled","Disable":"Disable","View":"View","QRCode":"QR Code","Delete":"Delete","Search":"Search","Clear":"Clear","UserO365":"Import User O365","Add":"Add","Next":"Next","Unregister":"Unregister","close":"Close","O365Rooms":"{name} Rooms","syncUser":"Sync User"}

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

module.exports = {"masterData":"Master Data","rooms":"Rooms","roomMail":"Mail System Rooms","roomRegis":"Room Registration","roomSub":"Room Subscription","roomDis":"Room Disable","roomFormat":"Room Format","location":"Location","building":"Building","floor":"Floor","zone":"Zone","Users":"Users","adUsers":"AD User","userRegis":"User Registration","Department":"Department","userConcur":"User Login (Concurrent)","Role":"Role","Profile":"Profile","Background":"Background","Facilitites":"Facilitites","food":"Foods & Beverage","Category":"Category","Foods":"Foods","iotDisplay":"Display","iotRegis":"IoT Registration","iotRoomConfig":"IoT Room Config","eventType":"Event Type","Events":"Events","viewEvents":"View Events","Orders":"Orders","createOrder":"Create Order","Settings":"Settings","globalSetting":"Global Setting","Integration":"Integration","Terms":"Terms & Conditions","FAQ":"FAQ","Contact":"Contact Us","Report":"Report","Summary":"Summary","roomSummary":"Room Summary","userSummary":"User Summary","foodSummary":"Food Summary","facilitySummary":"Facility Summary","deleteEventSummary":"Delete Event Summary","reserveNotUse":"Reserve Not Use","Room":"Room","User":"User","Detail":"Detail","roomDetails":"Room Details","userDetails":"User Details","foodDetails":"Food Details By Event","facilityDetails":"Facility Details By Event","Monitor":"Monitor","Overview":"Overview","Status":"Status","topUser":"Top Users by Reservation","topRooms":"Top Rooms by Reservation","Hello":"Hello","UserInformation":"User Information","SignOut":"Sign Out","hotDesk":"Hot Desk","seatRegis":"Seat Registration","avaiableTime":"Available Time Slot","role":"Role","temporaryClosed":"Temporary Closed Schedule","permission":"Permission","device":"Devices","logo":"Logo"}

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Rooms":"Rooms","Page":"Page","of":"of","No":"No.","Name":"Name","Email":"Email","Sync":"Is Sync","AddNew":"Add New","Capacity":"Capacity","RoomType":"RoomType","Image":"Image","NotiUrl":"Notification Url","Expire":"Expire","Subject":"Subject","time":"Start - End","Room":"Room","Description":"Description","formatList":"Room Format List","Code":"Code","Create":"Create Room","Update":"Update Room","RoomEmail":"Room Email Address","AddRoomEmail":"Add room email address","Roomname":"Room name","AddRoomName":"Add room name","noSelect":"----  Not select  ----","RoomCapacity":"Room Capacity","AddCapacity":"Add room capacity","BGImage":"Background Image","Timezone":"Timezone","Roomtype":"Room type","SyncVC":"Sync VC Id","RoomImage":"Room Image","fileSize":"*File size limit = 10 MB","AutoCheckin":"Auto Checkin","AvailableReserve":"Available for reserve","SelectAll":"Select All","ViewRoom":"View Room","Location":"Location","Facilities":"Facilities","Food":"Food & Berverage","DisplayBG":"Display Background","Profile":"Profile","Qrcode":"Qrcode","Confirmation":"Confirmation","ModelDelete":"Do you want to delete this room ?","ModelDisable":"Do you want to disable this room ?","ModelEnable":"Do you want to enable this room ?","ModelDeleteDisable":"Do you want to delete this item ?","CreateDisable":"Create Room Disable","Start":"Start","End":"End","AllRoom":"All Room","UpdateDisable":"Update Room Disable","ViewDisable":"View Room Disable","CreateFormat":"Create Room Format","UpdateFormat":"Update Room Format","ViewFormat":"View Room Format","modelsubscribe":"Do you want to subscribe this room ?","modelUnsubscribe":"Do you want to unsubscribe this room ?","Subscribe":"Subscribe","selectRoom":"Select Room","search":"Search","owners":"Owners","information":"Information","facilitites":"Internal Facilitites","event":"Event","owner":"Owners","display":"Display","generateEventPin":"Generate Event PIN"}

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

module.exports = {"Name":"Name","Email":"Email","Capacity":"Capacity","RoomType":"RoomType","Subject":"Subject","autoCheckIn":"Is Auto Check-in","SelectAll":"Select All","Yes":"Yes","No":"No","Building":"Building","Floor":"Floor","Zone":"Zone","Facilities":"Facilities","FirstName":"First Name","LastName":"Last Name","Backend":"Backend Accessible","Department":"Department","Description":"Description","Category":"Category","Start":"Start","End":"End","NameIOT":"Name","Room":"Room","Code":"Code"}

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","BuildingList":"Building List","AddNewBuilding":"Add New","Confirmation":"Confirmation","deleteBuilding":"Do you want to delete this building ?","CreateBuilding":"Create Building","UpdateBuilding":"Update Building","Availablefor":"Available for reserve","Facilities":"Facilities","Food":"Food & Berverage","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","FloorList":"Floor List","FloorListHead":"Floor List","CreateFloor":"Create Floor","UpdateFloor":"Update Floor","ViewFloor":"View Floor","Location":"Location","AddNewFloor":"Add New","Building":"Building","deleteFloor":"Do you want to delete this floor ?","floorNo":"No","pleaseSelect":"---- Plaese Select Location ----","ZoneList":"Zone List","ZoneListHead":"Zone List","CreateZone":"Create Zone","UpdateZone":"Update Zone","ViewZone":"View Zone","AddNewZone":"Add New","deleteZone":"Do you want to delete this zone ?","Floor":"Floor","selectBuilding":"---- Plaese Select Building ----","selectFloor":"---- Plaese Select Floor ----"}

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Filesize":"*File size limit = 10 MB","UserRegis":"User Registration","CreateUser":"Create User","UpdateUser":"Update User","Users":"Users","Email":"Email","Backend":"Backend Accessible","Resetpass":"Reset password","Confirmation":"Confirmation","deleteUser":"Do you want to delete this user ?","resetPass":"Do you want to reset password for this user ?","ViewUser":"View User","UserDetail":"User Detail","PINCode":"PIN Code","RFID":"RFID","Status":"Status","TimeZone":"Time Zone","Department":"Department","Role":"Role","QRCode":"QR Code","MeetingDetail":"Meeting Detail","AutoLock":"Is Auto Lock","AvailableRooms":"Available Rooms for reserve","AvailableRoomsRole":"Available Rooms for reserve ( from Role )","UserName":"User Name","Adduser":"Add user","Password":"Password","Addpass":"Add password","ConfirmPass":"Confirm Password","Addsamepass":"Add same password","FirstName":"First Name","Addfirstname":"Add first name","LastName":"Last Name","Addlastname":"Add last name","Addpincode":"Add pin code","Addrfid":"Add rfid","SelectStatus":"Select Status","SelectTimezone":"Select Timezone","SelectAll":"Select All","Require":"Require!!","Passatleast":"Password has at least 8 character.","Passwordnotmatch.":"Password does not match.","importAD":"Import User AD","selectuser":"Please select user","Select":"Select User","CurrentPass":"Current Password","NewPass":"New Password","passError1":"Contain at least 8 characters","passError2":"Contain at least 1 number","passError3":"Contain at least 1 lowercase character (a-z)","passError4":"Contain at least 1 uppercase character (A-Z)","passError5":"Contains only 0-9a-zA-Z","NoUsers":"No Users","UserInfo":"User Infomation","Language":"Language","ChangePass":"Change Password","NewDepartment":"Add New","Groups":"Groups","Description":"Description","CreateDepartment":"Create Department","UpdateDepartment":"Update Department","Selected":"Selected","Add":"Add","Mobile":"Mobile","external":"user external","MobilePhone":"Mobile Phone","SelectUser":"Select User","Selectinternal":"Select user internal","Internal":"Selected Internal","internal":"Internal","External":"External","Search":"Search","Update":"Update","UserGroup":"User in Group(s)","ViewDepartment":"View Department","deleteusergroup":"Do you want to delete this usergroup ?","specialcharactor":"Can't input special charactor!!","Items":"Items","Fullname":"Full name","Platfrom":"Platfrom","Deleteitem":"Do you want to Delete this item ?","passwordWrongFormat":"Password wrong format","passwordMustmorethan8":"Password must more than 8 char","passwordWasNumber":"Password must contain at least 1 number ","passwordWasNormalChar":"Password must contain at least 1 lowercase character (a-z)","passwordWasUpperChar":"Password must contain at least 1 uppercase character (A-Z)","passwordNotMatch":"Password Not Match"}

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","AddNew":"Add New","RoleList":"Role List","UpdateRole":"Update Role","CreateRole":"Create Role","ViewRole":"View Role","Synco365":"Sync o365 Role","MaxBooking":"Max. Advanced Booking (days)","MaxDuration":"Max. Duration Per Event (minutes)","Confirmation":"Confirmation","modelDelete":"Do you want to delete this role ?","AvailableRooms":"Available Rooms for reserve","Require":"Require!!"}

/***/ }),

/***/ 901:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!","ProfileList":"Profile List","CreateProfile":"Create Profile","UpdateProfile":"Update Profile","View":"View","usingprofile":"Room(s) using this profile","Action":"Action","Identify":"Identify","Department":"Department","Calendar":"Calendar","Order":"Order","Rules":"Rules","Norule":"No rule","ManageRule":"Manage Rule"}

/***/ }),

/***/ 902:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","BackgroundList":"Background List","Default":"Default","SetDefault":"Set Default","modelDelete":"Do you want to delete this background ?","CreateBackground":"Create Background","Updatebackground":"Update background","Type":"Type","PleaseSelect":"--- Please Select ---","Video":"Video","Upload":"Upload","Viewbackground":"View background","SizeHuge":"This Size is Huge!!","filetype":"This file type is not "}

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","AddNewFood":"Add New","AddNewFoodList":"Add New","Require":"Require!!","modelDelete":"Do you want to delete this amenity ?","PleaseSelect":"--- Please Select ---","CreateFacility":"Create Facility","UpdateFacility":"Update Facility","FacilitiesList":"Facilities List","Amount":"Amount","ViewFacility":"View Facility","FoodCategory":"Food & Berverage Category List","modelDeleteFood":"Do you want to delete this category ?","DeleteFoodList":"Do you want to delete this food ?","CreateFood":"Create Food & Berverage Category","UpdateFood":"Update Food & Berverage Category","ViewFood":"View Food & Berverage Category","FoodList":"Food & Berverage List","Category":"Category","Price":"Price","CreateFoodList":"Create Food & Berverag","UpdateFoodList":"Update Food & Berverage","SelectCategory":"---- Plaese Select Category ----","SizeHuge":"This Size is Huge!!","ViewFoodList":"View Food & Berverage"}

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","Display":"Display","Devices":"Devices","License":"License","Mac":"Mac Address","Model":"Model","IP":"IP Address","Room":"Room","Status":"Status","Unregister":"Unregister","modelUnregis":"Do you want to un-register this item ?","modelDisable":"Do you want to disable this item ?","modelEnable":"Do you want to enable this item ?","IOTRegis":"IOT Registration","IOTRoom":"IOT Room Config","Items":"Items","RoomCode":"Room Code","SerialNumber":"Serial Number","modelDelete":"Do you want to delete this item ?","CreateIOT":"Create IOT Room Config","UpdateIOT":"Update IOT Room Registration","pleaseSelect":"----  Please Select  ----","selectLicense":"----  Please Select License Before ----","notSelect":"----  Not select  ----","ViewIOT":"View IOT Registration"}

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","EventType":"Event Type List","modelDelete":"Do you want to delete this event type ?","CreateType":"Create Event Type","UpdateType":"Update Event Type","ViewType":"View Event Type","AllEvents":"All Events","Subject":"Subject & Organizer","Room":"Room","DateTime":"Date Time","Status":"Status","Organizer":"Organizer","Start":"Start","End":"End","Check-in":"Check-in","Check-out":"Check-out","pin":"Event Pin"}

/***/ }),

/***/ 906:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","OrdersFood":"Orders Food","Start":"Start","End":"End","Subject":"Subject","StartTime":"Start Time","EndTime":"End Time","Status":"Status","OrdersFac":"Orders Facilitites","AllEvent":"All Event","Foods":"Foods & Beverage","Amenities":"Amenities","DateTime":"Date Time","Room":"Room","CreateAmenity":"Create Order Amenity","CreateFood":"Create Order Food","pcs.":"pcs.","Amenity":"Amenity","FoodEmpty":"Food's Empty","Remark":"Remark"}

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","SettingInfo":"Global Setting","UpdateSetting":"Edit","AdminID":"Mailbox Service ID","admin":"Administrator Email & Contact","GlobalSetting":"Global Setting","startTime":"Start Working Time","endTime":"End Working Time","MinOrder":"Min. Order Duration in advance (hours)","slotDuration":"Slot Duration (mins)","tokenExpire":"Token Expire (days)","adminEmail":"Administrator Email","adminTel":"Administrator Tel","adminID":"Administrator ID","advancedBooking":"Advanced Booking (days)","maxBooking":"Maximum Booking Time (mins)","checkinTime":"Check-in Time (mins)","releaseTime":"Release Time (mins)","IoTbefore":"IoT - Light on before event starts (mins)","IoTafter":"IoT - Light off after event ends (mins)","checkinInfo":"Check-in","checkin":"Check-in Notification Enabled","checkout":"Check-out Notification Enabled","HousekeeperAdmin":"Housekeeper Admin","HousekeeperName":"Housekeeper Name","HousekeeperEmail":"Housekeeper Email","HousekeeperTel":"Housekeeper Tel","lockedUser":"Locked User","Investigation":"Investigation Period (days)","Suspended":"Suspended Period (days)","Adsence":"No. of Adsence (times)","SigninPermission":"Signin Permission","SigninUpsert":"Signin And Upsert User","allowSignin":"Allow Signin Domain","Import":"Import","importO365":"Import User From O365","importExcel":"Import User From Excel","importAD":"Import User From AD","lightDimmer":"Light Dimmer (Display)","enabledLight":"Enabled Light Dimmer","start":"Start time","end":"End time","eventPIN":"Event PIN","enabledEventPIN":"Enabled Event PIN","Concurrent":"Concurrent","enabledConcurrent":"Enabled Concurrent","ActiveDirectory":"Active Directory","EnabledADLogin":"Enabled AD Login","adIP":"IP Address","adPort":"Port","adUser":"User","adBaseDN":"Base DN","adDomain":"Domain","reminder":"Reminder Time (minutes)","reminderInfo":"Reminder","enabledReminder":"Enabled Sending Reminder","AdvancedReminder":"Advanced Reminder (hours)","TMS":"TMS Information","enabledTMS":"Enabled TMS Integration","server":"Server","userPrefix":"User Prefix","conferenceType":"Conference Type","CMR":"CMR Information","EnabledCMR":"Enabled CMR Information","BOT":"BOT Information","enabledBOT":"Enabled BOT Integration","Webhook":"Web hook","TestAD":"Test AD","SelectConference":"---- Plaese Select Conference Type---","AutomaticCall":"Automatic Call Launch","OneButton":"One Button To Push","ManualCall":"Manual Call Launch","NoConnect":"No Connect","ReservationOnly":"Reservation Only","Default":"Default","TestTMS":"Test TMS","TestCMR":"Test CMR","TestBOT":"Test BOT","TestSuccessful":"Test Connection Successful","TestFailure":"Test Connection Failure","ChangeIntegration":"Change Integration Config","Integration":"Integration","Backend":"Backend","ClientId":"Client Id","ClientSecret":"Client Secret","TenantId":"Tenant Id","MobileURL":"Mobile Redirect URL","WebURL":"Web Redirect URL","Authen":"Authen","Yoursite":"Your site doesn't set integration.","SettingsUser":"Settings User","IntegrationO365":"Integration Office 365","Registerapp":"Register your application","Pleaseregister":"Please register your application with Global Administrator via","AppPortal":"Application Registration Portal","YourClientId":"Your Client Id:","AdminConsent":"Admin Consent","AllowApp":"Allow this App to Integration","Connect":"Connect","ConnectO365App":"Connect your O365 App Integration to Roomminister","UseFrontend":"Use Frontend Integrations","Term":"Term & Conditions","EditTerm":"Edit Term & Conditions","Faq":"Faq","EditFaq":"Edit Faq","ContactUs":"Contact Us","EditContactUs":"Edit Contact Us","testConnection":"Test Connection","syncRoleAndPolicy":"Sync Role And Policy","isSyncRoleAndPolicy":"Enabled Sync Role And Policy","ewsUsername":"Username","ewsPassword":"Password","ewsHost":"Host","ewsAuthType":"Auth Type","isSigninAndUpsertUser":"Is Sign-in and Upsert User","pinType":"PIN type","eventPinType":{"event":"Event","people":"People"},"prevDayForCheckLockUser":"Investigation Period (days)","lockDay":"Lock (day)","lockTime":"No. of Adsence (times)","food":{"minAdvanceFoodOrderTime":"Minimum can order food & beverage (min)","maxAdvanceFoodOrderDay":"Maximum can order  food & beverage (days)","minCancelFoodOrderDay":"Minimum can  cancel order  food & beverage (days)","minAdvanceFacilityOrderTime":"Minimum can order facility (min)","maxAdvanceFacilityOrderDay":"Maximum can order facility (days)","minCancelFacilityOrderDay":"Minimum can  cancel order facility (days)","advanceOrderTime":"Advance Order Time (min)"},"isUseActiveDirectory":"Is use Active Directory","password":"Password","mqttOpenBefore":"Open before start event(min)","mqttCloseAfter":"Close after end event(min)","cmrSiteName":"Company Name","isUseVMSVirasa":"Enabled VMS","vmsVirasaToken":"Token","email":{"eventPin":"Event Pin Email","checkinSubject":"Email Check in Subject","checkoutSubject":"Email Check out Subject","checkout":"Email Check out","checkin":"Email Check In","reminder":"Email Reminder","approveSubject":"Email Approve Subject","approveContent":"Email Approve Content","forgotPassword":"Content","forgotPasswordSubject":"Subject","resetPassword":"Reset Password Email","resetPasswordSubject":"Email Reset Password Subject","adminResetPassword":"Email Reset Password","adminResetPasswordSubject":"Email Reset Password Subject","eventPinEmailSubject":"Event Pin Email Subject","eventPinEmailContent":"Event Pin Email Content","reminderEmailSubject":"Reminder Email Subject","reminderEmailContent":"Reminder Email Content","eventRecurrencePinEmailSubject":"Event Recurrence Pin Email Subject","eventRecurrencePinEmailContent":"Event Recurrence Pin Email Content","content":"Content","subject":"Subject"},"approve":"Enable Approve","isSyncRole":"Sync Role From o365 (o365 Group)","isSyncUser":"Sync User From o365","isSyncPolicy":"Sync Policy From o365","defaultRoleId":"Default Role Id","motionCheckoutWaitingTime":"Checkout Waiting Time (sec)","motionCheckinWaitingTime":"Checkin Waiting Time (sec)","backendFooter":"Backend Footer Text","openLightBeforeTime":"Open Light Before (min)","openDMXBeforeTime":"Open DMX Before (min)","openDALIBeforeTime":"Open Dali Before (min)","openBacnetBeforeTime":"Open Bacnet Before (min)","common":"Common","dataNpermission":"Data & Permission","booking":"Booking","conference":"Conference","order":"Order","iot":"IOT","display":"Display","integrationSystem":"Integration System","tokenExpireDate":"Token Expire Date","adminInfo":"Administrator Information","houseKeeperInfo":"Housekeeper Information","forgotPasswordEmail":"Forgot Password Email","adminResetPasswordEmail":"Reset Password by Admin","example":"Example","signinAndUpsert":"Setting Sync User (From o365)","importUser":"Import User","isImportUserFromO365":"Import User From o365","isImportUserFromExcel":"Import User From Excel","isImportUserFromAD":"Import User From AD","ADInfo":"AD Information","ewsInfo":"EWS Information","checkoutInfo":"Check-out","eventPinInfo":"Event PIN","emailInfo":"Email","singleEventPin":"Single Event Email","recurrentEventPin":"Recurrent Event Email","enabledLockUser":"Enabled Lock User","defaultConference":"Default Conference","tmsInfo":"CISCO TMS","cmrInfo":"CISCO CMR","enabledZoom":"Enabled Zoom","zoomInfo":"Zoom","token":"Token","userId":"User ID","teamInfo":"Microsoft Team","enabledTeam":"Embled Microsoft Team Integration","tmsServer":"TMS Server","tmsUser":"TMS User","tmsPassword":"TMS Password","tmsPrefix":"TMS Prefix","tmsType":"TMS Conference Type","cmrServer":"CMR Server","cmrSite":"CMR Site Name","cmrUser":"CMR User","cmrPassword":"CMR Password","zoomToken":"Zoom Token","zoomUserId":"Zoom User ID","orderAmenityInfo":"Facility","orderFoodInfo":"Food & Beverage","isEnableMotionCheckin":"Enabled Motion Chech-in","isEnableMotionCheckout":"Enabled Motion Chech-out","botInfo":"CISCO WebEx Team Chat BOT","virasaInfo":"VMS VIRASA","botServer":"BOT Server","virasaServer":"VMS VIRASA Server","virasaToken":"VMS VIRASA Token","forgotSubject":"Forgot Password Email Subject","forgotContent":"Forgot Password Email Content","resetSubject":"Reset Password Subject","resetContent":"Reset Password Content","adminResetSubject":"Admin Reset Password Subject","adminResetContent":"Admin Reset Password Content","adConnect":"AD Connect"}

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","SummaryRoom":"Summary Room Report","Start":"Start","End":"End","Building":"Building","Floor":"Floor","Zone":"Zone","Room":"Room","ExportToExcel":"Export To Excel","SummaryUser":"Summary User Report","User":"User","SummaryFood":"Summary Food Report","SummaryDelete":"Summary Delete Event","SummaryFacility":"Summary Facility Report","ReserveRoom":"Reserve not use By Room Report","ReserveUser":"Reserve not use By User Report","DetailRoom":"Detail Room Report","NoSelect":"--- No Select ---","selectBuilding":"Please select Building","selectFloor":"Please select Floor","DetailUser":"Detail User Report","FoodDetail":"Food Detail By Event Report","FacilityDetail":"Facility Detail By Event Report"}

/***/ }),

/***/ 909:
/***/ (function(module, exports) {

module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File size limit = 10 MB","SelectAll":"Select All","Description":"Description","Confirmation":"Confirmation","AddNew":"Add New","Require":"Require!!","Date":"Date","Type":"Type","Room":"Room","Officehour":"Office hour","Allday":"All day","Search":"Search","Available":"*Available, Reserve are calculated from Now to End of Day (In the future)","NoUse":"*No Use, Occupied, Waiting are calculated from Start of Day to Now (In the past)","StatusSummary":"Status Summary","RoomStatus":"Room Status","FilterDate":"Filter Date and Time","Filter":"Filter","StartAndEnd":"Start And End (Date , Time)","startsearch":"* start search hour","from":"from ","Booking":"Booking Transactions","Confirm":"Confirm Arrival Rate","Subject":"Subject","StartDate":"Start Date and Time","EndDate":"End Date and Time","Thisperiod":"This period doesn't have any event","autorelease":"This period doesn't have event for check in or auto release","Reserve":"*Reserve is number of times reserved","Succescheckedin":"*Success is number of times room has been successfully checked-in","Auto-release":"*Auto-release is number of times room has been auto-released","RealTime":"Real Time Room Status","AutoCheckIn":"Auto CheckIn","Location":"Location","Selectperiod":"Select period of time","Maximum":"Maximum number of","TopUser":"Top User by Reserved: by ","TopRoom":"Top Room by Reserved: by ","day":"Day","advanceSearchGuideLine":" * Blank or 0 will list all of ","advanceSearchGuideLineTitle":" for display","graphBookingTitle":"Amount of booking(s)"}

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports = {"mustMoreThanZero":"Value must more than 0","mustMoreThanOne":"Value must more than 1","require":"Require","image":"Please input image","domain":"Please input allow domain","tokenExpire":"Token expire most more than 0 day","emailWrongFormat":"Email wrong format","checkTime":"Start Time must before End Time","checkADconnect":"Please check AD connect again","checkADconnectAndSubmit":"Please make sure AD connection's save","checkSigninAndUpsert":"Please make sure Signin and upsert's save","checkEWS":"Please make sure EWS's save","checkEWSdata":{"user":"EWS user information's wrong","password":"EWS password information's wrong","host":"EWS host information's wrong","type":"EWS type information's wrong"},"cannotSave":"Can't save. Error as below.","position":"Position","message":"Message","checkConnectTMS":"Please make sure your CISCO TMS's already connect success","checkConnectCMR":"Please make sure your CISCO TMS's already connect success","checkConnectBOT":"Please make sure your CISCO WebEx Team Chat BOT's already connect success","defaultConferenceValueNotMatch":"Please input your conference that match with your selected.","checkAdinId":"Please make sure your Admin ID's already connect success"}

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

module.exports = {"account":"เข้าสู่ระบบ","login":"เข้าสู่ระบบ","remember":"จำฉันไว้ในระบบ","email":"อีเมล์","password":"รหัสผ่าน","error":"กรุณากรอกข้อมูล","emailerror":"กรุณากรอกอีเมล์"}

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

module.exports = {"ok":"ตกลง","cancel":"ยกเลิก","back":"ย้อนกลับ","edit":"แก้ไข","submit":"ยืนยัน","confirm":"ยืนยัน","yes":"ใช่","no":"ไม่","done":"เสร็จสิ้น","AdvancedSearch":"ค้นหาอย่างละเอียด","Update":"แก้ไข","Print":"พืมพ์รูปนี้!","Enabled":"เปิดให้ใช้","Disable":"ปิดไม่ให้ใช้","View":"ดูข้อมูล","QRCode":"QR Code","Delete":"ลบ","Search":"ค้นหา","Clear":"ล้างค่า","UserO365":"นำเข้ารายชื่อจาก O365","Add":"เพิ่ม","Next":"ต่อไป","Unregister":"Unregister","close":"ปิด","O365Rooms":"ห้อง {name}","syncUser":"อัพเดทข้อมูลผู้ใช้งาน"}

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

module.exports = {"masterData":"ข้อมูลหลัก","rooms":"ห้อง","roomMail":"อีเมล์ของห้อง","roomRegis":"รายชื่อห้องที่ลงทะเบียน","roomSub":"ห้องที่กำลังติดตาม","roomDis":"ห้องที่ไม่ให้ช้งาน","roomFormat":"รูปแบบการจัดห้อง","location":"ตำแหน่งห้อง","building":"อาคาร","floor":"ชั้น","zone":"โซน","Users":"บัญชีผู้ใช้งาน","adUsers":"บัญชี AD","userRegis":"รายชื่อบัญชีที่ลงทะเบียน","Department":"ประเภทบัญชี","userConcur":"Concurrent","Role":"ตำแหน่ง","Profile":"โปรไฟล์","Background":"พื้นหลัง","Facilitites":"อุปกรณ์อำนวยความสะดวก","food":"อาหารและเครื่องดื่ม","Category":"ประเภทอาหาร","Foods":"อาหารและเครื่องดื่ม","iotDisplay":"หน้าจอแสดงผล","iotRegis":"อุปกรณ์ IoT ที่ลงทะเบียนแล้ว","iotRoomConfig":"IOT ที่ติดตั้งในห้อง","eventType":"ประเภทของการจอง","Events":"การจองห้อง","viewEvents":"ดูการจองทั้งหมด","Orders":"คำสั่งซื้อ","createOrder":"สร้างคำสั่งซื้อ","Settings":"การตั้งค่า","globalSetting":"การตั้งค่าพื้นฐาน","Integration":"การเชื่อต่อบัญชี","Terms":"ข้อตกลงและเงื่อนไข","FAQ":"ข้อเท็จจริง","Contact":"ติดต่อเรา","Report":"รายงาน","Summary":"สรุป","roomSummary":"การใช้ห้อง","userSummary":"การใช้งานของบัญชี","foodSummary":"การสั่งอาหาร","facilitySummary":"การสั่งอุปกรณ์","deleteEventSummary":"การยกเลิกการจอง","reserveNotUse":"การจองแต่ไม่ได้ใช้","Room":"ห้อง","User":"บัญชีผู้ใช้","Detail":"รายละเอียด","roomDetails":"รายละเอียดห้อง","userDetails":"รายละเอียดบัญชีผู้ใช้","foodDetails":"การสั่งอาหารในแต่ละการจอง","facilityDetails":"การสั่งอุปกรณ์ในแต่ละการจอง","Monitor":"สถิติ","Overview":"ภาพรวม","Status":"สถานะ","topUser":"บัญชีผู้ใช้ที่มาการจองมากที่สุด","topRooms":"ห้องที่มีจองมากที่สุด","Hello":"สวัสดี","UserInformation":"ข้อมูลบัญชีผู้ใช้นี้","SignOut":"ออกจากระบบ","hotDesk":"ที่นั่ง","seatRegis":"เพิ่มที่นั่ง","avaiableTime":"ช่วงเวลาที่สามารถใช้งานได้","role":"กลุ่ม","temporaryClosed":"ช่วงเวลาที่ไม่สามารถใช้งานได้","permission":"สิทธิ์การใช้งาน","device":"อุปกรณ์","logo":"Logo"}

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Rooms":"ห้อง","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Email":"อีเมล์","Sync":"การเชื่อมต่อ","AddNew":"เพิ่มห้อง","Capacity":"ความจุ","RoomType":"ประเภทห้อง","Image":"รูป","NotiUrl":"Url สำหรับแจ้งเตือน","Expire":"หมดอายุ","Subject":"หัวข้อ","time":"เริ่ม - จบ","Room":"ห้อง","Description":"รายละเอียด","formatList":"รายชื่อรูปแบบการจัดห้อง","Code":"รหัส","Create":"สร้างห้อง","Update":"แก้ไขข้อมูลห้อง","RoomEmail":"อีเมล์ห้อง","AddRoomEmail":"เพิ่มอีเมล์ของห้อง","Roomname":"ชื่อห้อง","AddRoomName":"เพิ่มชื่อห้อง","noSelect":"----  ไม่ได้เลือก  ----","RoomCapacity":"ความจุของห้อง","AddCapacity":"เพิ่มความจุของห้อง","BGImage":"ภาพพื้นหลัง","Timezone":"เขตเวลา","Roomtype":"ประเภทห้อง","SyncVC":"เชื่อมต่อ VC Id","RoomImage":"รูปห้อง","fileSize":"*ขนาดของไฟล์ต้องไม่เกิน 10 MB","AutoCheckin":"เช็คอินอัตโนมัติ","AvailableReserve":"ของที่สั่งซื้อได้","SelectAll":"เลือกทั้งหมด","ViewRoom":"ข้อมูลห้อง","Location":"ตำแหน่งห้อง","Facilities":"อุปกรณ์","Food":"อาหารและเครื่องดื่ม","DisplayBG":"พื้นหลังที่ใช้","Profile":"โปรไฟล์","Qrcode":"Qrcode","Confirmation":"ยืนยัน","ModelDelete":"คุณต้องการลบห้องนี้ออกใช่หรือไม่ ?","ModelDisable":"คุณต้องการปิดห้องนี้ไม่ให้ใข้หรือไม่ ?","ModelEnable":"คุณต้องการเปิดใช้ห้อนี้หรือไม่ ?","ModelDeleteDisable":"คุณต้องการลบรายการนี้หรือไม่ ?","CreateDisable":"กำหนดเวลาที่ไม่ให้ใช้ห้อง","Start":"เริ่ม","End":"จบ","AllRoom":"ห้องทั้งหมด","UpdateDisable":"แก้ไขเวลาที่ไม่ให้ใช้ห้อง","ViewDisable":"ข้อมูลช่วงเวลาที่ไม่ให้ใช้ห้อง","CreateFormat":"สร้างรูปแบบการจัดห้อง","UpdateFormat":"แก้ไขข้อมูลรูปแบบการจัดห้อง","ViewFormat":"ข้อมูลรูปแบบห้อง","modelsubscribe":"คุณต้องการติดตามห้องนี้หรือไม่ ?","modelUnsubscribe":"คุณต้องการยกเลิกการติดตามห้องนี้หรือไม่ ?","Subscribe":"ติดตาม","selectRoom":"เลือกห้องที่ต้องการ","search":"ค้นหา","owners":"Owners","information":"รายละเอียด","facilitites":"อุปกรณ์เสริมภายในห้อง","event":"อีเว้นท์","owner":"รายชื่อผู้มีสิทธิ์อนุมัต","display":"หน้าจอ","generateEventPin":"สร้าง Event PIN"}

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports = {"Name":"ชื่อ","Email":"อีเมล์","Capacity":"ความจุ","RoomType":"ประเภทห้อง","Subject":"หัวข้อ","autoCheckIn":"เช็คอินอัตโนมัติ","SelectAll":"เลือกทั้งหมด","Yes":"ใช่","No":"ไม่ใช่","Building":"อาคาร","Floor":"ชั้น","Zone":"โซน","Facilities":"อุปกรณ์","FirstName":"ชื่อ","LastName":"นามสกุล","Backend":"สิทธิในการเข้าถึง Backend","Department":"ตำแหน่ง","Description":"รายละเอียด","Category":"ประเภท","Start":"เริ่ม","End":"จบ","NameIOT":"ชื่อ","Room":"ห้อง","Code":"รหัส"}

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","BuildingList":"รายชื่ออาคาร","AddNewBuilding":"เพิ่มอาคาร","Confirmation":"ยืนยัน","deleteBuilding":"คุณต้องการลบอาคารนี้์หรือไม่ ?","CreateBuilding":"สร้างอาคาร","UpdateBuilding":"แก้ไขข้อมูลอาคาร","Availablefor":"ของที่สั่งซื้อได้","Facilities":"อุปกรณ์","Food":"อาหารและเครื่องดื่ม","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","FloorList":"ชั้นที่มี","FloorListHead":"รายชื่อชั้น","CreateFloor":"สร้างชั้น","UpdateFloor":"แก้ไขข้อมูลชั้น","ViewFloor":"ข้อมูลชั้น","Location":"ตำแหน่ง","AddNewFloor":"เพิ่มชั้น","Building":"อาคาร","deleteFloor":"คุณต้องการลบชั้นนี้์หรือไม่ ?","floorNo":"ชั้นที่","pleaseSelect":"---- กรุณาเลือกอาคาร ----","ZoneList":"โซนที่มี","ZoneListHead":"รายชื่อโซน","CreateZone":"สร้างโซน","UpdateZone":"แก้ไขข้อมูลโซน","ViewZone":"ข้อมูลโซน","AddNewZone":"เพิ่มโซน","deleteZone":"ตุณต้องการลบโซนนี้ใช่หรือไม่ ?","Floor":"ชั้น","selectBuilding":"---- กรุณาเลือกอาคาร ----","selectFloor":"---- กรุณาเลือกชั้น ----"}

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","UserRegis":"รายชื่อบัญชีที่ลงทะเบียน","CreateUser":"เพิ่มบัญชีผู้ใช้งาน","UpdateUser":"แก้ไขข้อมูลบัญชีผู้ใช้งาน","Users":"บัญชี","Email":"อีเมล์","Backend":"สิทธิในการเข้าถึง Backend","Resetpass":"รีเซ็ตรหัสผ่าน","Confirmation":"ยืนยัน","deleteUser":"คุณต้องการลบบัญชีนี้ใช่หรือไม่ ?","resetPass":"คุณต้องการรีเซ็ตรหัสผ่านของบัญชีนี้ใช่หรือไม่ ?","ViewUser":"ข้อมูลบัญชีผู้ใช้","UserDetail":"รายละเอียดบัญชี","PINCode":"PIN Code","RFID":"RFID","Status":"สถานะ","TimeZone":"เขตเวลา","Department":"ประเภทบัญชี","Role":"ตำแหน่ง","QRCode":"QR Code","MeetingDetail":"รายละเอียดการจอง","AutoLock":"ล็อกบัญชีอัตโนมัติ","AvailableRooms":"ห้องที่จองได้","AvailableRoomsRole":"ห้องที่จองได้ ( จากตำแห่ง )","UserName":"บัญชีผู้ใช้","Adduser":"เพิ่มบัญชี","Password":"รหัสผ่าน","Addpass":"กรอกรหัสผ่าน","ConfirmPass":"ยืนยันรหัสผ่าน","Addsamepass":"กรอกรหัสผ่าน","FirstName":"ชื่อ","Addfirstname":"กรอกชื่อ","LastName":"นามสกุล","Addlastname":"กรอกนามสกุล","Addpincode":"กรอก pin code","Addrfid":"กรอก rfid","SelectStatus":"เลือกสถานะ","SelectTimezone":"เลือกเขตเวลา","Require":"กรุณากรอกข้อมูล!!","Passatleast":"รหัสผ่านต้องยาวอย่างน้อย 8 ตัว","Passwordnotmatch.":"รหัสผ่านไม่ตรงกัน","importAD":"นำเข้าบัญชี AD","selectuser":"กรุณาเลือกบัญชีผู้ใช้","Select":"เลือกบัญชีผู้ใช้","CurrentPass":"รหัสผ่านปัจจุบัน","NewPass":"รหัสผ่านใหม่","passError1":"ต้องมีความยาวอย่างน้อย 8 ตัวอักษร","passError2":"ต้องมีเลขอย่างน้อย 1 ตัว","passError3":"ต้องมีอักษรตัวเล็กอย่างน้อย 1 ตัว (a-z)","passError4":"ต้องมีอักษรตัวใหญ่อย่างน้อย 1 ตัว (A-Z)","passError5":"ใช้ได้เฉพาะ 0-9a-zA-Z","NoUsers":"ไม่มีบัญชีผู้ใช้","UserInfo":"ข้อมูลบัญชีผู้ใช้","Language":"ภาษา","ChangePass":"เปลี่ยนรหัสผ่าน","NewDepartment":"เพิ่มหน่อยงานใหม่","Groups":"กลุ่ม","Description":"คำอธิบาย","CreateDepartment":"สร้างประเภทบัญชีใหม่","UpdateDepartment":"แกไขข้อมูลประเภทบัญชี","Selected":"เลือก","Add":"เพิ่ม","Mobile":"เบอร์โทรศัพท์","external":"บัญชีผู้ใช้ภายนอก","MobilePhone":"เบอร์โทรศัพท์มือถือ","SelectUser":"เลือกบัญชีผู้ใช้","Selectinternal":"เลือกบัญชีผู้ใช้ภายใน","Internal":"เลือกบัญชีภายใน","internal":"บัญชีภายใน","External":"บัญชีภายนอก","Search":"ค้นหา","Update":"แก้ไข","UserGroup":"บัญชีในกลุ่ม","ViewDepartment":"ข้อมูลปรดภทบัญชี","deleteusergroup":"คุณต้องการลบประเภทบัญชีนี้หรือไม่","specialcharactor":"ไม่สามารถใส่อักขระพิเศษได้!!","Items":"อุปกรณ์","Fullname":"ชื่อเต็ม","Platfrom":"อุปกรณ์","Deleteitem":"คุณต้องการลบอุปกรณ์นี้ทิ้งรึเปล่า ?","passwordWrongFormat":"Password wrong format","passwordMustmorethan8":"Password must more than 8 char","passwordWasNumber":"Password must contain at least 1 number ","passwordWasNormalChar":"Password must contain at least 1 lowercase character (a-z)","passwordWasUpperChar":"Password must contain at least 1 uppercase character (A-Z)","passwordNotMatch":"รหัสผ่านไม่ตรงกัน"}

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","AddNew":"เพิ่มตำแหน่ง","RoleList":"รายชื่อตำแหน่งทั้งหมด","UpdateRole":"แก้ไขข้อมูลตำแหน่ง","CreateRole":"สร้างตำแหน่ง","ViewRole":"ข้อมูลตำแหน่ง","Synco365":"นำเข้าตำแหน่งจาก o365","MaxBooking":"ช่วงเวลาที่จองได้ล่วงหน้า (วัน)","MaxDuration":"ระยะเวลาที่จองได้สูงสุดในการจองแต่ละครั้ง (นาที)","Confirmation":"ยืนยัน","modelDelete":"คุณต้องการลบตำแหน่งนี้หรือไม่ ?","AvailableRooms":"ห้องที่สามารถจองได้","Require":"กรุณากรอกข้อมูล!!"}

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มโปรไฟล์","Require":"กรุณากรอกข้อมูล!!","ProfileList":"รายชื่อโปรไฟล์","CreateProfile":"สร้างโปรไฟล์","UpdateProfile":"แก้ไขโปรไฟล์","View":"ข้อมูลของ","usingprofile":"ห้องที่ใช้โปรไฟล์นี้อยู่","Action":"สิ่งที่ทำได้","Identify":"การอนุญาต","Department":"หน่วยงาน","Calendar":"ปฏิทิน","Order":"คำสั่ง","Rules":"กฏ","Norule":"ไม่มีกฏ","ManageRule":"จัดการกฏ"}

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","BackgroundList":"พื้นหลังทั้งหมด","Default":"ตั้งเป็นพื้นฐาน","SetDefault":"ตั้งเป็นพื้นฐาน","modelDelete":"คุณต้องการลบพื้นหลังอันนี้หรือไม่ ?","CreateBackground":"สร้างพื้นหลัง","Updatebackground":"แก้ไขพื้นหลัง","Type":"ประเภท","PleaseSelect":"--- กรุณาเลือก ---","Video":"วิดีโอ","Upload":"อัพโหลด","Viewbackground":"ดูพื้นหลัง","SizeHuge":"ไฟล์มีขนาดใหญ่เกินไป!!","filetype":"ไฟล์นี้ไม่ใช่ "}

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มอุปกรณ์","AddNewFood":"เพิ่มประเภท","AddNewFoodList":"เพิ่มเมนู","Require":"กรุณากรอกข้อมูล!!","modelDelete":"คุณต้องการลบอุปกรณ์อันนี้หรือไม่ ?","PleaseSelect":"--- กรุณาเลือก ---","CreateFacility":"เพิ่มอุปกรณ์","UpdateFacility":"แก้ไขอุปกรณ์","FacilitiesList":"รายชื่ออุปกรณ์ทั้งหมด","Amount":"จำนวน","ViewFacility":"ข้อมูลอุปกรณ์","FoodCategory":"ประเภทอาหารและเครื่องดื่ม","modelDeleteFood":"คุณต้องการลบประเภทอาหารชนิดนี้ใช่หรือไม่ ?","DeleteFoodList":"คุณต้องการลบอาหารชนิดนี้ใช่หรือไม่ ?","CreateFood":"สร้างประเภทอาหารและเครื่องดื่ม","UpdateFood":"แก้ไขประเภทอาหารและเครื่องดื่ม","ViewFood":"ข้อมูลประเภทอาหารและเครื่องดื่ม","FoodList":"รายการอาหารและเครื่องดื่ม","Category":"ประเภท","Price":"ราคา","CreateFoodList":"เพิ่มเมนูอาหารและเครื่องดื่ม","UpdateFoodList":"แก้ไขเมนูอาหารและเครื่องดื่ม","SelectCategory":"---- กรุณาเลือกประเภทของอาหาร ----","SizeHuge":"รูปมีขนาดใหญ่เกินไป!!","ViewFoodList":"ข้อมูลเมนูอาหารและเครื่องดื่ม"}

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่ม","Require":"กรุณากรอกข้อมูล!!","Display":"หน้าจอแสดงผล","Devices":"อุปกรณ์","License":"รหัสใบอนุณาต","Mac":"Mac Address","Model":"รุ่น","IP":"IP Address","Room":"ห้อง","Status":"สถานะ","Unregister":"นำออก","modelUnregis":"คุณต้องการนำอุปกรณ์นี้ออกหรือไม่ ?","modelDisable":"คุณต้องการปิดอุปกรณ์ไม่ให้ใช้หรือไม่ ?","modelEnable":"คุณต้องการเปิดอุปกรณ์ให้ใช่หรือไม่ ?","IOTRegis":"อุปกรณ์ IOT","IOTRoom":"IOT ที่ติดตั้งในห้อง","Items":"รายการ","RoomCode":"รหัสห้อง","SerialNumber":"หมายเลขซีเรียล","modelDelete":"คุณต้องการลบอุปกรณ์นี้หรือไม่ ?","CreateIOT":"เพิ่มอุปกรณ์ IOT ที่ติดตั้งในห้อง","UpdateIOT":"แก้ไขอุปกรณ์ IOT ที่ติดตั้งในห้อง","pleaseSelect":"----  กรุณาเลือก  ----","selectLicense":"----  กรุณาเลือกรหัส ----","notSelect":"----  ไม่เลือก  ----","ViewIOT":"ข้อมูลอุปกรณ์"}

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มประเภท","Require":"กรุณากรอกข้อมูล!!","EventType":"ประเภทของการจอง","modelDelete":"คุณต้องการลบประเภทการจองนี้หรือไม่ ?","CreateType":"สร้างประเภทการจองขึ้นมา","UpdateType":"แก้ไขประเภทการจอง","ViewType":"ข้อมูลประเภทของการจอง","AllEvents":"การจองทั้งหมด","Subject":"หัวข้อ & ผู้จอง","Room":"ห้อง","DateTime":"วันเวลา","Status":"สถานะ","Organizer":"ผู้จอง","Start":"เริ่ม","End":"จบ","Check-in":"เช็คอิน","Check-out":"เช็คเอาท์","pin":"Pin"}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","OrdersFood":"รายการสั่งอาหาร","Start":"เริ่ม","End":"จบ","Subject":"หัวข้อ","StartTime":"เวลาเริ่ม","EndTime":"เวลาจบ","Status":"สถานะ","OrdersFac":"รายการสั่งอุปกรณ์","AllEvent":"การจองทั้งหมด","Foods":"อาหารและเครื่องดื่ม","Amenities":"อุปกรณ์","DateTime":"วันเวลา","Room":"ห้อง","CreateAmenity":"เพิ่มการสั่งอุปกรณ์","CreateFood":"เพิ่มการสั่งอาหาร","pcs.":"ชิ้น","Amenity":"อุปกรณ์","FoodEmpty":"ไม่มีที่เลือกไว้","Remark":"เพิ่มเติม"}

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","SettingInfo":"ข้อมูลการตั้งค่า","UpdateSetting":"แก้ไขการตั้งค่า","GlobalSetting":"การตั้งค่าทั่วไป","startTime":"เวลาที่เริ่มจองได้","endTime":"เวลาสุดท้ายที่จองได้","MinOrder":"เวลาที่จองได้อย่างต่ำ (ชั่วโมง)","slotDuration":"ระยะห่างของเวลาในการจอง (นาที)","tokenExpire":"Token หมดอายุ (วัน)","adminEmail":"อีเมล์","adminTel":"เบอร์โทรศัพท์","adminID":"ID ของผู้ดูแลระบบ","advancedBooking":"วันที่จองได้ล่วงหน้า (วัน)","maxBooking":"ระยะเวลาการจองนานที่สุด(นาที)","checkinTime":"เวลาที่เช็คอินได้ (นาที)","releaseTime":"ยกเลิกรายการจองเมื่อไม่มีการเช็คอิน (นาที)","IoTbefore":"IoT - ไฟจะเปิดก่อนการจองจะเริ่ม (นาที)","IoTafter":"IoT - ไฟจะปิดหลังจบการจบ (นาที)","checkinInfo":"เช็คอิน","checkin":"การส่งอีเมล์แจ้งเตือนการเช็คอิน","checkout":"การส่งอีเมล์แจ้งเตือนการเช็คเอ้าท์","HousekeeperAdmin":"ผู้ดูแลระบบแม่บ้าน","HousekeeperName":"ชื่อผู้ดูแลระบบแม่บ้าน","HousekeeperEmail":"อีเมล์ผู้ดูแลระบบแม่บ้าน","HousekeeperTel":"เบอร์โทรศัพท์ผู้ดูแลระบบแม่บ้าน","lockedUser":"การล็อกบัญชีผู้ใช้","Investigation":"ระยะเวลาในการตรวจสอบ (วัน)","Suspended":"ระยะเวลาในการระงะบการใช้งาน (วัน)","Adsence":"จำนวนครั้งที่ไม่มา (ครั้ง)","SigninPermission":"การอนุญาตเข้าสู่ระบบ","SigninUpsert":"การลงชื่อเข้าใช้และเพิ่มหรือแก้ไขบัญชีผู้ใช้","allowSignin":"Domain ที่อนุญาตให้ลงชื่อเข้าใช้","Import":"นำเข้า","importO365":"นำเข้าบัญชีผู้ใช้จาก O365","importExcel":"นำเข้าบัญชีผู้ใช้จาก Excel","importAD":"นำเข้าบัญชีผู้ใช้จาก AD","LightDimmer":"ไฟหรี่ (จอแสดงผล)","enabledLight":"อนุญาตให้ใช้ไฟหรี่","start":"เวลาเริ่ม","end":"เวลาจบ","eventPIN":"PIN ของการจอง","enabledEventPIN":"เปิดใช้งาน PIN","Concurrent":"การลงชื่อเข้าใช้พร้อมกัน","EnabledCocurrent":"อนุญาตให้ลงชื่อเข้าใช้พร้อมกัน","ActiveDirectory":"การจัดการทรัพยากร","EnabledADLogin":"อณุญาติให้เข้าสู่ระบบด้วย AD","adIP":"IP Address","adPort":"Port","adUser":"บัญชีผู้ใช้","adBaseDN":"Base DN","adDomain":"Domain","reminder":"การแจ้งเตือนล่วงหน้า (นาที)","reminderInfo":"การแจ้งเตือนล่วงหน้า","enabledReminder":"อนุญาตให้แจ้งเตือน","AdvancedReminder":"การแจ้งเตือนล่วงหน้า (ชั่วโมง)","TMS":"ข้อมูล TMS","enabledTMS":"อนุญาตให้เชื่อมต่อ TMS","server":"เซิร์ฟเวอร์","userPrefix":"คำนำหน้าผู้ใช้","conferenceType":"ประเภทการประชุมทางไกล","CMR":"ข้อมูล CMR","EnabledCMR":"อนุญาตให้ใช้ข้อมูล CMR","BOT":"ข้อมูล BOT","enabledBOT":"อนุญาตให้เชื่อมต่อ BOT","Webhook":"Web hook","TestAD":"ทดสอบ AD","SelectConference":"---- กรุณาเลือกประเภทการโทรทางไกล ----","AutomaticCall":"โทรโดยอัตโนมัติ","OneButton":"กดปุ่มครั้งเดียว","ManualCall":"โทรด้วยตัวเอง","NoConnect":"ไม่มีการเชื่อมต่อ","ReservationOnly":"การจองเท่านั้น","Default":"ค่าพื้นฐาน","TestTMS":"ทดสอบ TMS","TestCMR":"ทดสอบ CMR","TestBOT":"ทดสอบ BOT","TestSuccessful":"การทดสอบเชื่อมต่อสมบูรณ์","TestFailure":"การทดสอบเชื่อมต่อล้มเหลว","ChangeIntegration":"เปลี่ยนการตั้งค่าเชื่อมต่อ","Integration":"การเชื่อมต่อ","Backend":"Backend","ClientId":"Client Id","ClientSecret":"Client Secret","TenantId":"Tenant Id","MobileURL":"URL สำหรับมือถือ","WebURL":"URL สำหรับเว็บ","Authen":"Authen","Yoursite":"เว็บของคุณไม่มีการเชื่อมต่อ","SettingsUser":"ตั้งค่าบัญชีผู้ใช้","IntegrationO365":"การเชื่อมต่อ Office 365","Registerapp":"ลงทะเบียนแอปพลิเคชันของคุณ","Pleaseregister":"กรุณาลงทะเบียนแอปพลิเคชันของคุณกับผู้ดูแลระบบผ่านทาง","AppPortal":"ลงทะเบียนแอปพลิเคชันพอร์ทัล","YourClientId":"Client Id ของคุณ:","AdminConsent":"ความยินยอมของผู้ดูแลระบบ","AllowApp":"อนุญาตให้แอพนี้เชื่อมต่อ","Connect":"เชื่อมต่อ","ConnectO365App":"เชื่อมต่อแอพ O365 ของคุณเข้ากับ Roomminister","UseFrontend":"การใช้งานเชื่อมต่อ Frontend","Term":"ข้อตกลงและเงื่อนไข","EditTerm":"แก้ไขข้อตกลงและเงื่อนไข","Faq":"คำถามที่พบบ่อย","EditFaq":"แก้ไข คำถามที่พบบ่อย","ContactUs":"ติดต่อเรา","EditContactUs":"แก้ไขการติดต่อ","testConnection":"ทดสอบการเชื่อมต่อ","syncRoleAndPolicy":"ซิงค์ตำแหน่งและข้อบังคับ","isSyncRoleAndPolicy":"อนุญาตซิงค์ตำแหน่งและข้อบังคับ","ewsUsername":"บัญชีผู้ใช้","ewsPassword":"รหัสผ่าน","ewsHost":"เซิร์ฟเวอร์","ewsAuthType":"ประเภทการให้สิทธิ์","defaultRoleId":"ตำแหน่งพื้นฐาน","isSigninAndUpsertUser":"เปิดใช้งาน เมื่อลงชื่อเข้าใช้ อนุญาตให้เพิ่มผู้ใช้งานใหม่","enabledConcurrent":"เปิดใช้งาน เข้าใช้งานพร้อมกันหลายอุปกรณ์","pinType":"ประเภทของ PIN","eventPinType":{"event":"อีเว้นท์","people":"บุคคล"},"prevDayForCheckLockUser":"ตรวจสอบย้อนหลังไม่เกิน (วัน)","lockDay":"ไม่สามารถใช้งานได้ (วัน)","lockTime":"มีการจองแล้วไม่มาใช้งาน จะถูกระงับการใช้งาน (ครั้ง)","food":{"minAdvanceFoodOrderTime":"เวลาที่น้อยที่สุด ที่สามารถสั่งอาหารได้ (นาที)","maxAdvanceFoodOrderDay":"เวลาที่มากที่สุด ที่สามารถสั่งอาหารได้ (วัน)","minCancelFoodOrderDay":"เวลาที่น้อยที่สุด ที่สามารถยกเลิกรายการอาหารได้ (วัน)","minAdvanceFacilityOrderTime":"เวลาที่น้อยที่สุด ที่สามารถสั่งอุปกรณ์ได้ (นาที)","maxAdvanceFacilityOrderDay":"เวลาที่มากที่สุด ที่สามารถสั่งอุปกรณ์ได้ (วัน)","minCancelFacilityOrderDay":"เวลาที่น้อยที่สุด ที่สามารถยกเลิกรายการสั่งอุปกรณ์ได้ (วัน)","advanceOrderTime":"สั่งอาหารล่วงหน้า (นาที)"},"password":"รหัสผ่าน","isUseActiveDirectory":"ใช้งาน Active Directory","mqttOpenBefore":"เปิดใช้งานก่อนเริ่มการประชุม (นาที)","mqttCloseAfter":"ปิดใช้งานหลังจบการประชุม (นาที)","cmrSiteName":"ชื่อองค์กร","isUseVMSVirasa":"เปิดใช้งาน VMS","vmsVirasaToken":"Token","email":{"eventPin":"Event Pin อีเมล์","checkinSubject":"Email Check in Subject","checkoutSubject":"Email Check out Subject","checkout":"Email Check out","checkin":"Email Check In","reminder":"Email Reminder","approveSubject":"Email Approve Subject","approveContent":"Email Approve Content","forgotPassword":"รายละเอียด","forgotPasswordSubject":"หัวข้อ","resetPassword":"อีเมล์เปลี่ยนรหัสผ่าน","resetPasswordSubject":"Email Reset Password Subject","adminResetPassword":"Email Reset Password","adminResetPasswordSubject":"Email Reset Password Subject","eventPinEmailSubject":"Event Pin Email Subject","eventPinEmailContent":"Event Pin Email Content","reminderEmailSubject":"Reminder Email Subject","reminderEmailContent":"Reminder Email Content","eventRecurrencePinEmailSubject":"Event Recurrence Pin Email Subject","eventRecurrencePinEmailContent":"Event Recurrence Pin Email Content","content":"รายละเอียด","subject":"หัวข้อ"},"approve":"เปิดใช้งานการส่งอีเมล์ Approve","isSyncRole":"เชื่อมต่อ กลุ่มผู้ใช้งาน(Role) จาก o365 (o365 Group)","isSyncUser":"เชื่อมต่อ ผู้ใช้งาน จาก o365","isSyncPolicy":"เชื่อมต่อ สิทธิ์การใช้งาน(Policy) จาก o365","motionCheckoutWaitingTime":"Checkout Waiting Time (sec)","motionCheckinWaitingTime":"Checkin Waiting Time (sec)","backendFooter":"Backend Footer Text","openLightBeforeTime":"Open Light Before (min)","openDMXBeforeTime":"Open DMX Before (min)","openDALIBeforeTime":"Open Dali Before (min)","openBacnetBeforeTime":"Open Bacnet Before (min)","admin":"ผู้ดูแลระบบ","common":"ทั่วไป","dataNpermission":"สิทธิ์การใช้งาน","booking":"การจอง","conference":"Conference","order":"อาหาร","iot":"IOT","display":"จอหน้าห้อง","integrationSystem":"ระบบ Integration","tokenExpireDate":"Token หมดอายุ (วัน)","adminInfo":"รายละเอียดของแอดมิน","houseKeeperInfo":"รายละเอียดของแม่บ้าน","forgotPasswordEmail":"อีเมล์ลืมรหัสผ่าน","adminResetPasswordEmail":"อีเมล์เปลี่ยนรหัสผ่าน โดย แอดมิน","example":"ตัวอย่าง","signinAndUpsert":"ตั้งค่าการเชื่อมต่อ (ผู้ใช้งาน จาก o365)","importUser":"นำเข้า ผู้ใช้งาน","isImportUserFromO365":"นำเข้าผู้ใช้งาน จาก o365","isImportUserFromExcel":"นำเข้าผู้ใช้งาน จาก Excel","isImportUserFromAD":"นำเข้าผู้ใช้งาน จาก AD","ADInfo":"รายละเอียดของ AD","ewsInfo":"รายละเอียด EWS","checkoutInfo":"เช็คเอ้าท์","eventPinInfo":"อีเว้นท์ PIN","emailInfo":"อีเมล์","singleEventPin":"อีเมล์ การจองรายการเดี่ยว","recurrentEventPin":"อีเมล์ การจองรายการซ้ำ","enabledLockUser":"อนุญาตให้ใช้งาน Lock User","defaultConference":"ค่าเริ่มต้น Conference","tmsInfo":"CISCO TMS","cmrInfo":"CISCO CMR","enabledZoom":"เปิดใช้งาน Zoom","zoomInfo":"Zoom","token":"Token","userId":"User ID","teamInfo":"Microsoft Team","enabledTeam":"เปิดใช้งาน Microsoft Team Integration","tmsServer":"เซิฟเวอร์ TMS","tmsUser":"TMS User","tmsPassword":"TMS Password","tmsPrefix":"TMS Prefix","tmsType":"TMS Conference Type","cmrServer":"เซิฟเวอร์ CMR","cmrSite":"CMR Site Name","cmrUser":"CMR User","cmrPassword":"CMR Password","zoomToken":"Zoom Token","zoomUserId":"Zoom User ID","orderAmenityInfo":"อุปกรณ์","orderFoodInfo":"อาหาร และ เครื่องดื่ม","isEnableMotionCheckin":"เปิดใช้งาน Motion Chech-in","isEnableMotionCheckout":"เปิดใช้งาน Motion Chech-out","botInfo":"CISCO WebEx Team Chat BOT","virasaInfo":"VMS VIRASA","botServer":"BOT เซิฟเวอร์","virasaServer":"VMS VIRASA เซิฟเวอร์","virasaToken":"VMS VIRASA Token","forgotSubject":"Forgot Password Email Subject","forgotContent":"Forgot Password Email Content","resetSubject":"Reset Password Subject","resetContent":"Reset Password Content","adminResetSubject":"Admin Reset Password Subject","adminResetContent":"Admin Reset Password Content","adConnect":"การเชื่อมต่อ AD"}

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","SummaryRoom":"รายงานสรุปการใช้ห้อง","Start":"เริ่ม","End":"จบ","Building":"อาคาร","Floor":"ชั้น","Zone":"โซน","Room":"ห้อง","ExportToExcel":"ส่งออกเป็น Excel","SummaryUser":"รายงานสรุปบัญชีผู้ใช้","User":"บัญชีผู้ใช้งาน","SummaryFood":"รายงานสรุปการสั่งอาการ","SummaryDelete":"รายงานสรุปการยกเลิกการจอง","SummaryFacility":"รายงานการสรุปการสั่งอุปกรณ์","ReserveRoom":"รายงานการจองที่ไม่ได้ใช้จากห้อง","ReserveUser":"รายงานการจองที่ไม่ได้ใช้จากบัญชีผู้ใช้","DetailRoom":"รายงานรายละเอียดของห้อง","NoSelect":"--- ไม่ได้เลือก ---","selectBuilding":"กรุณาเลือกอาคาร","selectFloor":"กรุณาเลือกชั้น","DetailUser":"รายงานรายละเอียดบัญชีผู้ใช้","FoodDetail":"รายละเอียดการสั่งอาหารในแต่ละการจอง","FacilityDetail":"รายละเอียดการสั่งอุปกรณ์ในแต่ละการจอง"}

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

module.exports = {"Total":"ทั้งหมด","Page":"หน้า","of":"จาก","No":"ลำดับ","Name":"ชื่อ","Image":"รูป","Code":"รหัส","Filesize":"*ขนาดไฟล์ต้องไม่เกิน 10 MB","SelectAll":"เลือกทั้งหมด","Description":"รายละเอียด","Confirmation":"ยืนยัน","AddNew":"เพิ่มพื้นหลัง","Require":"กรุณากรอกข้อมูล!!","Date":"วันที่","Type":"ช่วงเวลา","Room":"ห้อง","Officehour":"ช่วงเวลาทำงาน","Allday":"ทั้งวัน","Search":"ค้นหา","Available":"*ว่าง, จอง คำนวณจากเวลาปัจจุบันจนถึเวลาสิ้นสุดขงวัน (ช่วงเวลาในอนาคต)","NoUse":"*ไม่ได้ใช้งาน, ใช้งาน, รอ คำนวณจากเวลาเริ่มต้นของวันถึงปัจจุบัน (ช่วงเวลาในอดีต)","StatusSummary":"สถานะโดยรวม","RoomStatus":"สถานะของห้อง","FilterDate":"กรองวันเวลา","Filter":"กรอง","StartAndEnd":"เวลาเริ่มกับเวลาจบ (วัน , เวลา)","startsearch":"* เริ่มต้นชั่วโมงค้นหา","from":"จาก ","Booking":"ธุรกรรมการจอง","Confirm":"อัตราการมาถึง","Subject":"หัวข้อ","StartDate":"วันเวลาที่เริ่ม","EndDate":"วันเวลาที่จบ","Thisperiod":"ช่วงเวลานี้ไม่มีการจอง","autorelease":"ช่วงเวลานี้ไม่มีการเช็คอินหรือปล่อยห้องให้ว่าง","Reserve":"*การจอง คือจำนวนครั้งที่จองเอาไว้","Succescheckedin":"*ความสำเร็จ จำนวนครั้งที่ห้องมีการเช็คอินสำเร็จ","Auto-release":"*การปล่อยห้องให้ว่าง จำนวนครั้งที่ห้องมีการปล่อยให้ว่าง","RealTime":"สถานะของห้องเวลาจริง","AutoCheckIn":"เช็คอินอัตโนมัติ","Location":"สถานที่","Selectperiod":"เลือกช่วงเวลา","Maximum":"จำนวนสูงสุดของ","TopUser":"ผู้ใช้ที่จองมากที่สุด: ในแต่ละ","TopRoom":"ห้องที่มีการจองมากที่สุด: ในแต่ละ","day":"วัน","advanceSearchGuideLine":" * ค่าว่าง หรือ 0 เพื่อแสดงทั้งหมด ของ ","advanceSearchGuideLineTitle":" (จำนวน)","graphBookingTitle":"จำนวนการจอง"}

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports = {"mustMoreThanZero":"ค่าต้องมากกว่า 0","mustMoreThanOne":"ค่าต้องมากกว่า 1","require":"กรุณาระบุ","image":"กรุณาเพิ่มข้อมูลรูปภาพ","domain":"กรุณาระบุโดเมนที่อนุญาตให้เขาใช้งาน","tokenExpire":"Token หมดอายุจะต้องมากกว่า 0 วัน","emailWrongFormat":"Email ไม่ถูกต้อง","checkTime":"เวลาเริ่มต้น จะต้องน้อยกว่าเวลาสิ้นสุด","checkADconnect":"ตรวจสอบการเชื่อมต่อ AD อีกครั้ง","checkADconnectAndSubmit":"ตรวจสอบการบันทึกข้อมูล การเชื่อมต่อ AD อีกครั้ง","checkSigninAndUpsert":"ตรวจสอบการบันทึกข้อมูล ตั้งค่าการเชื่อมต่อ (ผู้ใช้งาน จาก o365) อีกครั้ง","checkEWS":"ตรวจสอบการบันทึกข้อมูล  EWS อีกครั้ง","checkEWSdata":{"user":"ข้อมูล ผู้ใช้งาน ของ EWS ไม่ถูกต้อง","password":"ข้อมูล รหัสผ่าน ของ EWS ไม่ถูกต้อง","host":"ข้อมูล เซิร์ฟเวอร์ ของ EWS ไม่ถูกต้อง","type":"ข้อมูล ประเภทการให้สิทธิ์ ของ EWS ไม่ถูกต้อง"},"cannotSave":"ไม่สามารถบันทึกข้อมูลได้ รายละเอียดดังต่อไปนี้","position":"ตำแหน่ง","message":"ข้อความ","checkConnectTMS":"ตรวจสอบการเชื่อมต่อ CISCO TMS","checkConnectCMR":"ตรวจสอบการเชื่อมต่อ CISCO CMR","checkConnectBOT":"ตรวจสอบการเชื่อมต่อ  CISCO WebEx Team Chat BOT","defaultConferenceValueNotMatch":"กรุณาระบุข้อมูล Conference ให้สอดคล้องกับค่าเริ่มต้น","checkAdinId":"ตรวจสอบการเชื่อมต่อ ID ผู้ดูแลระบบ อีกครั้ง"}

/***/ })

},[499]);


// WEBPACK FOOTER //
// app.a024071323d568338c94.js